<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
========================================================================================== -->

<template>
  <div id="dashboard-analytics" style="margin-top: -10px">
    <!--<video src="https://meravelo.com/earth2.mp4" fileExtension=".mp4" mimeType="video/mpeg" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' class="video2" id="bgvid" playsinline autoplay muted loop>-->
    <!--<video src="../assets/video/earth2.mp4" fileExtension=".mp4" mimeType="video/mpeg" class="video2" id="bgvid"-->
    <!--playsinline autoplay muted loop>-->

    <!--</video>-->
    <!--<Canvas-video :src="video"  class="video2" id="bgvid"  :autoplay="true" :loop="true">-->

    <!--</Canvas-video>-->
    <div
      class="vx-row"
      :style="`margin: 0 -3px; display: ${
        shouldShowHeaderCard ? 'flex' : 'none'
      }`">
      <div
        v-for="(h, index) in headerList"
        class="vx-col w-full md:w-1/7 sm:w-1/2 mb-2 px-1">
        <div
          :class="[
            'vx-card',
            'header-card',
            h.class,
            'vs-con-loading__container',
            'cursor-pointer',
          ]"
          @click="h.click">
          <div class="header-card__inner">
            <div class="header-card__icon">
              <img :src="h.icon" alt="" />
            </div>
            <div class="header-card__details">
              <p class="header-card__value">
                {{ h.total_vehicle.total ? h.total_vehicle.total : '0' }}
              </p>
              <div class="header-card__label">
                <span class="header-card__title">{{ $t(h.text) }}</span>
                <vs-tooltip color="#4F4F4F" :text="h.info" position="bottom">
                  <feather-icon
                    icon="HelpCircleIcon"
                    class="header-card__info-icon"
                    svgClasses="header-card__info-icon-svg"></feather-icon>
                </vs-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="router-header flex flex-wrap items-center mb-6" style="width: 100%">-->
    <!--<div class="content-area__heading" style="width: 100%">-->
    <!--<div class="vs-component vs-con-input-label vs-input mb-5 vs-input-primary float-right"-->
    <!--style="background: white;min-width: 400px;width: auto;">-->
    <!--<v-select @input="x=> fleet_group_id=x.value" placeholder="Fleet Group" :clearable="false"-->
    <!--:value="getSelectValue(fleet_group_id,fleet_array)" :reduce="text => text.value"-->
    <!--label="text" :options="fleet_array">-->
    <!--<template slot="option" slot-scope="option" >-->
    <!--<span v-for="list in option.counter" v-if="option.counter > 0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
    <!--<span style="background:#191970;color:white;padding: 2px 5px;border-radius: 7px;margin-right: 4px" v-if="option.counter==0">-->
    <!--{{option.counter +1}}-->
    <!--</span>-->
    <!--<span style="background:#00008B;color:white;padding: 2px 5px;border-radius: 7px;margin-right: 4px" v-if="option.counter==1">-->
    <!--{{option.counter +1}}-->
    <!--</span>-->
    <!--<span style="background:#0000FF;color:white;padding: 2px 5px;border-radius: 7px;margin-right: 4px" v-if="option.counter==2">-->
    <!--{{option.counter +1}}-->
    <!--</span>-->
    <!--<span style="background:#6495ED;color:black;padding: 2px 5px;border-radius: 7px;margin-right: 4px" v-if="option.counter==3">-->
    <!--{{option.counter +1}}-->
    <!--</span>-->
    <!--{{ option.text }}-->
    <!--</template>-->

    <!--</v-select>-->
    <!--</div>-->
    <!--<h2 class="mb-1">Dashboard </h2>-->
    <!--</div>-->
    <!--</div>-->

    <div
      v-if="
        this.getRolePermission().dashboard.maps.openstreet_maps ||
        this.getRolePermission().dashboard.maps.google_maps
      "
      id="data-list-list-view"
      class="data-list-container vs-con-loading__container"
      style="margin-top: 8px">
      <vs-row vs-w="12">
        <vx-card>
          <template slot="no-body">
            <div
              class="router-header flex flex-wrap items-center mb-1 header-filter-map"
              style="
                width: auto;
                position: absolute;
                z-index: 1000;
                justify-content: right;
                top: 20px;
                right: 20px;
              ">
              <div
                class="content-area__heading flex flex-row"
                style="width: auto; gap: 10px">
                <vs-button
                  v-if="isMobileView && !isMobileFilterVisible"
                  size="small"
                  icon-pack="feather"
                  type="filled"
                  color="#d23030"
                  class="mobile-filter-toggle"
                  @click="toggleMobileFilter">
                  <feather-icon icon="FilterIcon" size="18" />
                </vs-button>
                <div
                  v-if="!isMobileView || isMobileFilterVisible"
                  :class="[
                    'bg-white p-8 rounded-lg flex flex-col filter-panel-container',
                    isFilterCollapsed
                      ? 'filter-panel-container--collapsed'
                      : 'filter-panel-container--expanded',
                    isMobileView ? 'mobile-filter-overlay' : '',
                  ]">
                  <div class="flex justify-between items-center">
                    <div
                      class="flex items-center cursor-pointer"
                      @click="toggleFilterCollapse">
                      <h3 class="text-danger">Filter</h3>
                      <feather-icon
                        :icon="
                          isFilterCollapsed
                            ? 'ChevronDownIcon'
                            : 'ChevronUpIcon'
                        "
                        class="text-danger ml-2"
                        size="20" />
                    </div>
                    <feather-icon
                      v-if="isMobileView"
                      icon="XIcon"
                      class="text-danger cursor-pointer"
                      size="18"
                      @click.stop="closeMobileFilter" />
                  </div>
                  <template v-if="!isFilterCollapsed">
                    <div class="flex flex-row items-center" style="gap: 8px">
                      <v-select
                        @input="(x) => (selected_filter = x.value)"
                        placeholder="- Select Filter -"
                        :clearable="false"
                        :value="getSelectValue(selected_filter, pilih_filter)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="pilih_filter"
                        class="flex-1" />
                      <vs-button
                        v-if="selected_filter !== 'all'"
                        size="small"
                        color="warning"
                        type="border"
                        @click="resetFilter"
                        class="ml-2">
                        Reset
                      </vs-button>
                    </div>
                    <div
                      v-if="selected_filter != 'all'"
                      class="flex flex-row"
                      style="gap: 10px">
                      <v-select
                        v-if="selected_filter == 'license_plate'"
                        class="drop-height-auto w-full"
                        multiple
                        placeholder="Search License Plate"
                        :clearable="true"
                        v-model="plate"
                        label="text"
                        :options="plate_array" />
                      <v-select
                        v-if="selected_filter == 'vin'"
                        class="drop-height-auto w-full"
                        @input="(x) => (vin = x.value)"
                        placeholder="- Vehicle Number -"
                        :clearable="false"
                        :value="getSelectValue(vin, vin_array)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="vin_array" />
                      <v-select
                        v-if="selected_filter == 'imei'"
                        class="drop-height-auto w-full"
                        @input="(x) => (imei = x.value)"
                        placeholder="- Select IMEI -"
                        :clearable="false"
                        :value="getSelectValue(imei, imei_array)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="imei_array" />
                      <v-select
                        v-if="selected_filter == 'fleet_group'"
                        class="drop-height-auto w-full"
                        @input="(x) => (fleet_group_id = x.value)"
                        placeholder="- Select Fleet Group -"
                        :clearable="false"
                        :value="getSelectValue(fleet_group_id, fleet_array)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="fleet_array" />
                    </div>
                    <!-- Bagian filter status dengan dropdown -->
                    <div class="flex flex-col">
                      <v-select
                        v-model="selectedActivityFilter"
                        class="drop-height-auto w-full"
                        placeholder="- Select Vehicle Status -"
                        :clearable="false"
                        :options="activityFilterOptions"
                        label="text" />
                    </div>
                    <!-- <input
                    type="text"
                    placeholder="Cari Nopol..."
                    class="normal vs-input--input vs-inputx"
                    v-model="filterLicense" /> -->
                    <div
                      id="sidebar-scrollarea"
                      class="w-full flex flex-col overflow-y-scroll"
                      :style="
                        showDownloadButton ? 'padding-bottom: 40px' : null
                      "
                      @scroll="sidebarScroll">
                      <div
                        v-for="list in sidebar_locations
                          .filter((x) =>
                            x.license_plate
                              .toLowerCase()
                              .includes(filterLicense.toLowerCase())
                          )
                          .slice(0, sidebar_count)"
                        :key="list._id || list.vehicle_id || list.license_plate"
                        class="mb-3">
                        <div
                          v-if="showDownloadButton"
                          class="manual-card p-4 flex flex-col rounded-lg cursor-pointer"
                          style="gap: 12px"
                          @click="gotoVehicle(list)">
                          <div class="manual-card__top-actions">
                            <button
                              type="button"
                              class="manual-card__toggle"
                              :class="{
                                'manual-card__toggle--active':
                                  isCardExpanded(list),
                              }"
                              @click.stop="toggleCardExpansion(list)">
                              <feather-icon
                                :icon="
                                  isCardExpanded(list)
                                    ? 'ChevronUpIcon'
                                    : 'ChevronDownIcon'
                                "
                                size="16" />
                            </button>
                            <span
                              v-if="isManualVehicle(list)"
                              class="manual-ribbon manual-ribbon--clickable"
                              title="Manual Repair - Click to view details"
                              @click.stop="openManualDetailModal(list)">
                              <feather-icon
                                icon="BookmarkIcon"
                                class="w-4 h-4" />
                            </span>
                          </div>
                          <div
                            class="flex items-start"
                            :class="{ 'mt-6': isManualVehicle(list) }"
                            style="gap: 12px">
                            <img
                              class="manual-card__status-icon"
                              :src="
                                isSilenceFilterActive
                                  ? silenceIcon
                                  : list.vehicle_activity == 'MOVING'
                                    ? movingIcon
                                    : list.vehicle_activity == 'IDLE'
                                      ? idleIcon
                                      : list.vehicle_activity == 'STOP'
                                        ? stopIcon
                                        : silenceIcon
                              "
                              alt="logo" />
                            <div class="manual-card__identity">
                              <div style="display: flex; justify-content: start; width: 100%; align-items: center;">
                                <h4 class="manual-card__plate">
                                  {{ list.license_plate }}
                                </h4>
                                <span
                                  :class="
                                    statusBadgeClass(getDisplayActivity(list))
                                  ">
                                  {{
                                    formatActivity(getDisplayActivity(list)) ||
                                    '-'
                                  }}
                                </span>
                              </div> 
                              <h6 style="color:gray; font-size: 12px;">
                                {{ list.fleet_group_name || "" }}
                              </h6>
                            </div>
                          </div>
                          <div
                            v-if="isCardExpanded(list)"
                            class="card-info-grid">
                            <div class="card-info-row">
                              <div class="card-info-item">
                                <img
                                  :src="odometerIcon"
                                  alt="Odometer"
                                  class="card-info-icon card-info-icon-image" />
                                <span>{{ formatSpeed(list.speed) }}</span>
                              </div>
                              <div class="card-info-item">
                                <feather-icon
                                  icon="ClockIcon"
                                  class="card-info-icon" />
                                <span>{{
                                  formatDeviceTime(list.device_time)
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              isCardExpanded(list) && canViewVehicleDetail(list)
                            "
                            class="manual-card__footer">
                            <vs-button
                              size="small"
                              type="border"
                              icon-pack="feather"
                              class="manual-card__view-detail"
                              @click.stop="viewVehicleDetail(list)">
                              <feather-icon
                                icon="ExternalLinkIcon"
                                class="mr-1"
                                size="16" />
                              View Detail
                            </vs-button>
                          </div>
                          <div
                            v-if="isSilenceFilterActive || isRepairFilterActive"
                            class="manual-card__actions">
                            <vs-button
                              v-if="isSilenceFilterActive"
                              type="border"
                              class="w-full"
                              :loading="
                                addingRepairId === (list._id || list.vehicle_id)
                              "
                              @click.stop="addToRepairFromSilence(list)">
                              Add To Repair
                            </vs-button>
                            <vs-button
                              v-if="isRepairFilterActive"
                              type="border"
                              color="danger"
                              class="w-full"
                              :loading="
                                removingRepairId ===
                                (list._id || list.vehicle_id)
                              "
                              @click.stop="removeFromRepair(list)">
                              Remove from Repair
                            </vs-button>
                          </div>
                        </div>
                        <div
                          v-else
                          class="manual-card manual-card--compact p-3 flex flex-col rounded-lg cursor-pointer"
                          @click="gotoVehicle(list)">
                          <div class="manual-card__top-actions">
                            <button
                              type="button"
                              class="manual-card__toggle"
                              :class="{
                                'manual-card__toggle--active':
                                  isCardExpanded(list),
                              }"
                              @click.stop="toggleCardExpansion(list)">
                              <feather-icon
                                :icon="
                                  isCardExpanded(list)
                                    ? 'ChevronUpIcon'
                                    : 'ChevronDownIcon'
                                "
                                size="16" />
                            </button>
                            <span
                              v-if="isManualVehicle(list)"
                              class="manual-ribbon manual-ribbon--clickable"
                              title="Manual Repair - Click to view details"
                              @click.stop="openManualDetailModal(list)">
                              <feather-icon
                                icon="BookmarkIcon"
                                class="w-4 h-4" />
                            </span>
                          </div>
                          <div
                            class="manual-card__header"
                            :class="{ 'mt-6': isManualVehicle(list) }">
                            <img
                              class="manual-card__status-icon"
                              :src="
                                isSilenceFilterActive
                                  ? silenceIcon
                                  : list.vehicle_activity == 'MOVING'
                                    ? movingIcon
                                    : list.vehicle_activity == 'IDLE'
                                      ? idleIcon
                                      : list.vehicle_activity == 'STOP'
                                        ? stopIcon
                                        : silenceIcon
                              "
                              alt="logo" />
                            <div class="manual-card__identity">
                              <div style="display: flex; justify-content: start; width: 100%; align-items: center;">
                                <h4 class="manual-card__plate">
                                  {{ list.license_plate }}
                                </h4>
                                <span
                                  :class="
                                    statusBadgeClass(getDisplayActivity(list))
                                  ">
                                  {{
                                    formatActivity(getDisplayActivity(list)) ||
                                    '-'
                                  }}
                                </span>
                              </div>
                              <h6 style="color:gray; font-size: 12px;">
                                {{ list.fleet_group_name || "" }}
                              </h6>
                            </div>
                          </div>
                          <div
                            v-if="isCardExpanded(list)"
                            class="card-info-grid card-info-grid--compact">
                            <div class="card-info-row">
                              <div class="card-info-item">
                                <img
                                  :src="odometerIcon"
                                  alt="Odometer"
                                  class="card-info-icon card-info-icon-image" />
                                <span>{{ formatSpeed(list.speed) }}</span>
                              </div>
                              <div class="card-info-item">
                                <feather-icon
                                  icon="ClockIcon"
                                  class="card-info-icon" />
                                <span>{{
                                  formatDeviceTime(list.device_time)
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              isCardExpanded(list) && canViewVehicleDetail(list)
                            "
                            class="manual-card__footer">
                            <vs-button
                              size="small"
                              type="border"
                              icon-pack="feather"
                              class="manual-card__view-detail"
                              @click.stop="viewVehicleDetail(list)">
                              <feather-icon
                                icon="ExternalLinkIcon"
                                class="mr-1"
                                size="16" />
                              View Detail
                            </vs-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="showDownloadButton"
                      class="bg-white download-button-wrapper"
                      style="
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        z-index: 10;
                      ">
                      <vs-button
                        type="gradient"
                        class="w-full shadow-lg"
                        color="#d23030"
                        gradient-color-secondary="#f89595"
                        :loading="downloadLoading"
                        @click="downloadCurrentFilterData">
                        <feather-icon
                          icon="DownloadIcon"
                          v-show="!downloadLoading"
                          svgClasses="h-4 w-4 mr-1" />
                        <feather-icon
                          icon="LoaderIcon"
                          v-show="downloadLoading"
                          class="h-4 w-4 mr-1 animate-spin" />
                        {{ downloadButtonText }}
                      </vs-button>
                    </div>
                  </template>
                </div>
                <div
                  v-if="false"
                  class="bg-white p-5 rounded-lg flex flex-col absolute"
                  style="
                    width: 380px;
                    height: 700px;
                    gap: 10px;
                    top: 0;
                    right: 50px;
                  ">
                  <div class="flex flex-row">
                    <div>&lt;</div>
                    <h3 class="text-danger">Detail Kendaraan</h3>
                    <svg
                      class="cursor-pointer ml-auto"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      @click="isSidebarOpen = false">
                      <path
                        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                        fill="#828282" />
                    </svg>
                  </div>
                  <div class="flex flex-row justify-between">
                    <div class="flex flex-col">
                      <p>Plat Nomor</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                    <div
                      class="py-3 px-4 rounded-lg cursor-pointer"
                      style="color: green; background-color: #e6ffe6">
                      Moving
                    </div>
                  </div>
                  <div class="flex flex-col">
                    <p>Model Kendaraan</p>
                    <h4 class="fw-bold">B-1283-VCE</h4>
                  </div>
                  <div class="flex flex-col">
                    <p>Kelompok Armada</p>
                    <h4 class="fw-bold">B-1283-VCE</h4>
                  </div>
                  <div class="flex flex-col">
                    <p>Update Terakhir</p>
                    <h4 class="fw-bold">B-1283-VCE</h4>
                  </div>
                  <div class="flex flex-col">
                    <p>Lokasi Terakhir</p>
                    <h4 class="fw-bold">B-1283-VCE</h4>
                  </div>
                  <div class="flex flex-row justify-between">
                    <div class="flex flex-col">
                      <p>Kecepatan</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                    <div class="flex flex-col">
                      <p>Status Mesin</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                  </div>
                  <div class="flex flex-row justify-between">
                    <div class="flex flex-col">
                      <p>Odometer</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                    <div class="flex flex-col">
                      <p>Waktu Tempuh</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                  </div>
                  <div class="flex flex-row justify-between">
                    <div class="flex flex-col">
                      <p>Bahan Bakar</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                    <div class="flex flex-col">
                      <p>Temperatur</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                  </div>
                  <div class="flex flex-row justify-between">
                    <div class="flex flex-col">
                      <p>IMEI</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                    <div class="flex flex-col">
                      <p>Nomor Telepon</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                  </div>
                  <div class="flex flex-row justify-between">
                    <div class="flex flex-col">
                      <p>Internal Battery</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                    <div class="flex flex-col">
                      <p>External Battery</p>
                      <h4 class="fw-bold">B-1283-VCE</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="pick-category"
              :class="{ collapse: collapse }"
              style="z-index: 1000">
              <div
                @click="collapse = !collapse"
                style="
                  padding-top: 6px;
                  padding-bottom: 7px;
                  border-radius: 25px 25px 0 0;
                  background: white;
                ">
                <img
                  :src="POI"
                  style="width: 70%; margin: auto; cursor: pointer"
                  alt="" />
              </div>
              <div class="" v-for="list in categoryPOI" v-if="list.tampil">
                <vx-tooltip
                  :text="
                    disableImage
                      ? 'Please Zoom closer to activate'
                      : list.catpoi_name
                  "
                  position="right"
                  delay=".1s">
                  <img
                    @click="
                      disableImage
                        ? getNothing()
                        : getPOI(list.id, baseUrl + list.marker)
                    "
                    :src="baseUrl + list.images"
                    alt=""
                    :class="{
                      'disable-img': disableImage,
                      'active-icon': list.active_poi,
                    }"
                    class="poi-icon" />
                </vx-tooltip>
              </div>
              <div @click="collapse = !collapse" class="hide-btn">X</div>
            </div>
            <div class="heights">
              <span></span>
              <l-map
                v-if="
                  active_map &&
                  this.getRolePermission().dashboard.maps.openstreet_maps
                "
                ref="mapRefLeaflet"
                :zoom="zoom"
                :center="centerLeaflet"
                :options="mapOptions"
                style="height: 100%">
                <l-tile-layer :url="url" :attribution="attribution" />
                <!-- <l-popup ref="markpopup" :lat-lng="centerLeaflet">
                  <h1>Popup</h1>
                </l-popup> -->
                <div name="popup" v-show="true" ref="foo">
                  <!-- <h1>hehe</h1> -->
                  <!-- <div>
                    <p v-if="selectedLocation">{{ selectedLocation._id }}</p>
                    <vs-button>Vehicle Details</vs-button>
                  </div> -->
                  <!-- <InfoWindow
                    :selectedLocation="selectedLocation"
                    :detailable="true" /> -->
                </div>
                <!-- <my-elaborate-popup-content v-show="true" ref="bar"> -->
                <!-- <h1 v-if="selectedLocation">fakyu</h1> -->
                <!-- <InfoWindow
                    :selectedLocation="selectedLocation"
                    :detailable="true" />
                </my-elaborate-popup-content> -->
              </l-map>
              <GmapMap
                v-if="
                  active_map &&
                  this.getRolePermission().dashboard.maps.google_maps
                "
                ref="mapRef"
                style="width: 100%; height: 100%"
                :center="center"
                :options="{
                  minZoom: 1,
                  zoomControl: true,
                  mapTypeControl: false,
                  mapTypeControlOptions: mapTypeControlOptions,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false,
                }">
                <gmap-info-window
                  v-if="selectedPOI !== null"
                  :options="{ pixelOffset: { width: 0, height: -35 } }"
                  :position="{
                    lat: selectedPOI.coordinate.coordinates[1],
                    lng: selectedPOI.coordinate.coordinates[0],
                  }"
                  :opened="infoBoxPOI"
                  @closeclick="infoBoxPOI = false">
                  <div
                    class="infoWindow info_container vs-con-loading__container"
                    style="width: 400px">
                    <vs-row vs-w="12">
                      <vs-col
                        vs-justify="center"
                        vs-align="center"
                        vs-lg="12"
                        vs-sm="12"
                        vs-xs="12">
                        <h5>{{ selectedPOI.name }}</h5>
                        <table style="width: 100%">
                          <!--<tr>-->
                          <!--<td>Name</td><td>:</td><td class="bold">{{selectedPOI.name}}</td>-->
                          <!--</tr>-->
                          <tr v-if="selectedPOI.brand != ''">
                            <td>Brand</td>
                            <td>:</td>
                            <td class="bold">{{ selectedPOI.brand }}</td>
                          </tr>
                          <!--<tr v-if="selectedPOI.vmd!=''">-->
                          <!--<td>VMD</td><td>:</td><td class="bold">{{selectedPOI.vmd}}</td>-->
                          <!--</tr>-->
                          <tr>
                            <td>Latitude</td>
                            <td>:</td>
                            <td class="bold">
                              {{ selectedPOI.coordinate.coordinates[1] }}
                            </td>
                          </tr>
                          <tr>
                            <td>Longitude</td>
                            <td>:</td>
                            <td class="bold">
                              {{ selectedPOI.coordinate.coordinates[0] }}
                            </td>
                          </tr>
                          <tr>
                            <td>Type</td>
                            <td>:</td>
                            <td class="bold">{{ selectedPOI.type }}</td>
                          </tr>
                          <tr v-if="selectedPOI.type === 'Specific'">
                            <td>Fleet Group</td>
                            <td>:</td>
                            <td class="bold">
                              {{ selectedPOI.fleet_group_name }}
                            </td>
                          </tr>
                          <tr v-if="selectedPOI.phone != ''">
                            <td>Phone</td>
                            <td>:</td>
                            <td class="bold">{{ selectedPOI.phone }}</td>
                          </tr>
                          <tr v-if="selectedPOI.operating_time != ''">
                            <td>Operating Time</td>
                            <td>:</td>
                            <td class="bold">
                              {{ selectedPOI.operating_time }}
                            </td>
                          </tr>
                          <tr>
                            <td>Address</td>
                            <td>:</td>
                            <td class="bold">{{ selectedPOI.address }}</td>
                          </tr>
                          <tr>
                            <td>Location</td>
                            <td>:</td>
                            <td>
                              <strong>
                                <a
                                  target="_blank"
                                  :href="
                                    'http://www.google.com/maps/place/' +
                                    selectedPOI.coordinate.coordinates[1] +
                                    ',' +
                                    selectedPOI.coordinate.coordinates[0]
                                  "
                                  >Show Google Map</a
                                >
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Street View</td>
                            <td>:</td>
                            <td>
                              <strong>
                                <a
                                  target="_blank"
                                  :href="
                                    'https://www.google.com/maps?q&layer=c&cbll=' +
                                    selectedLocation.latitude +
                                    ',' +
                                    selectedLocation.longitude +
                                    '&cbp'
                                  "
                                  >Show Sreet View</a
                                >
                              </strong>
                            </td>
                          </tr>
                        </table>
                      </vs-col>
                    </vs-row>
                    <!--<vs-button  @click="playBack()" class="mt-4 ml-2 shadow float-left" type="gradient" color="#d23030" gradient-color-secondary="#f89595">Play Back</vs-button>-->
                  </div>
                </gmap-info-window>
                <gmap-info-window
                  v-if="selectedLocation !== null"
                  :options="{ pixelOffset: { width: 0, height: -35 } }"
                  :position="{
                    lat: clickedLocation.latitude,
                    lng: clickedLocation.longitude,
                  }"
                  :opened="infoBoxOpen"
                  @closeclick="infoBoxOpen = false">
                  <InfoWindow
                    :selectedLocation="selectedLocation"
                    :detailable="true" />
                </gmap-info-window>
              </GmapMap>
            </div>
          </template>
        </vx-card>
      </vs-row>
    </div>
    <div v-else>
      <AlertHistory />
    </div>

    <HeaderCard
      :addNewData="openModal"
      @closeModal="closeModal()"
      @manualRepair="addToRepairFromSilence"
      @removeRepair="removeFromRepair"
      :title="titleModal"
      :fleetGroupId="fleet_group_id"
      :isAdministrator="isAdministrator"
      :isCoordinator="isCoordinator"
      :isCommandCenter="isCommandCenter"
      :type="d_type" />

    <LiveShare
      :openModal="openModalLiveShare"
      @closeModal="closeModal()"
      :data="selectedVehicleId" />

    <transition name="modal-fade">
      <div
        v-if="manualDetailModal.show"
        class="modern-modal__overlay"
        @click.self="closeManualDetailModal">
        <div class="modern-modal modern-modal--sm">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">Detail Manual Repair</h3>
              <p class="modern-modal__subtitle">
                Vehicle details for manual repair transfer
              </p>
            </div>
            <button
              class="modern-modal__close"
              type="button"
              @click="closeManualDetailModal">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>
          <section class="modern-modal__body modern-modal__body--compact">
            <div
              v-if="manualDetailModal.loading"
              class="manual-detail-modal__loading">
              <vs-icon icon="autorenew" class="loading-spinner"></vs-icon>
              <p>Memuat data...</p>
            </div>
            <div v-else class="manual-detail-modal__content">
              <div class="field-group">
                <label class="vs-input--label">Plat Nomor</label>
                <div class="manual-detail-modal__value">
                  {{
                    manualDetailModal.vehicle
                      ? manualDetailModal.vehicle.license_plate
                      : '-'
                  }}
                </div>
              </div>
              <div class="field-group">
                <label class="vs-input--label">Alasan</label>
                <div class="manual-detail-modal__value">
                  {{ getManualReason(manualDetailModal.vehicle) }}
                </div>
              </div>
            </div>
          </section>
          <footer class="modern-modal__footer">
            <vs-button
              v-if="!manualDetailModal.loading"
              type="gradient"
              color="#d23030"
              gradient-color-secondary="#f89595"
              class="shadow-lg"
              icon-pack="feather"
              icon="icon-eye"
              @click="viewManualEvidenceFromModal">
              Lihat Bukti Upload
            </vs-button>
            <vs-button
              color="warning"
              type="border"
              @click="closeManualDetailModal">
              Close
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>

    <transition name="modal-fade">
      <div
        v-if="manualRepairModal.show"
        class="modern-modal__overlay"
        @click.self="closeManualRepairModal">
        <div class="modern-modal modern-modal--sm">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">Pindah Manual ke Repair</h3>
              <p class="modern-modal__subtitle">
                Move vehicle to repair status with reason and evidence
              </p>
            </div>
            <button
              class="modern-modal__close"
              type="button"
              @click="closeManualRepairModal">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>
          <section class="modern-modal__body modern-modal__body--compact">
            <div class="manual-repair-modal__content">
              <div class="field-group">
                <label class="vs-input--label">Kendaraan</label>
                <div class="manual-detail-modal__value">
                  {{
                    manualRepairModal.vehicle
                      ? manualRepairModal.vehicle.license_plate
                      : '-'
                  }}
                </div>
              </div>
              <div class="field-group">
                <label class="vs-input--label">Alasan</label>
                <vs-textarea
                  v-model="manualRepairModal.reason"
                  :disabled="manualRepairModal.submitting"
                  placeholder="Isi alasan pemindahan manual ke repair" />
              </div>
              <div class="field-group">
                <label class="vs-input--label">Unggah bukti (maks. 5 MB)</label>
                <input
                  ref="manualEvidenceInput"
                  type="file"
                  class="manual-repair-modal__file-input"
                  :disabled="manualRepairModal.submitting"
                  @change="handleManualRepairFile"
                  accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" />
                <vs-button
                  type="border"
                  class="manual-repair-modal__upload-btn"
                  :disabled="manualRepairModal.submitting"
                  @click="triggerManualEvidenceBrowse">
                  Pilih File
                </vs-button>
                <div
                  class="manual-repair-modal__selected"
                  v-if="manualRepairModal.fileName">
                  <feather-icon icon="PaperclipIcon" class="w-3 h-3" />
                  <span>{{ manualRepairModal.fileName }}</span>
                </div>
              </div>
              <p
                v-if="manualRepairModal.error"
                class="manual-repair-modal__error">
                {{ manualRepairModal.error }}
              </p>
            </div>
          </section>
          <footer class="modern-modal__footer">
            <vs-button
              type="gradient"
              color="#d23030"
              gradient-color-secondary="#f89595"
              class="shadow-lg"
              :loading="manualRepairModal.submitting"
              @click="submitManualRepair">
              Simpan
            </vs-button>
            <vs-button
              color="warning"
              type="border"
              :disabled="manualRepairModal.submitting"
              @click="closeManualRepairModal">
              Batal
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import HeaderCard from './dashboard/HeaderCard.vue'
import InfoWindow from './components/InfoWindow.vue'
import LiveShare from './components/LiveShare.vue'

import VueApexCharts from 'vue-apexcharts'
import Video from '../assets/video/earth2.mp4'
import * as REPO from '../repository/index'
import Cars from '../assets/images/icons/total.png'
// import Geofence from '../assets/images/icons/geofence_violation.png'
import UIO from '../assets/images/icons/unit_in_operation.png'
import Map from '../assets/images/icons/map.png'
import Stop from '../assets/images/icons/stop.png'
import Idle from '../assets/images/icons/idle.png'
import Moving from '../assets/images/icons/moving.png'
import Parking from '../assets/images/icons/parking.png'
import Silence from '../assets/images/icons/silence.png'
import InRepair from '../assets/images/icons/in_repair.png'
import OdometerIcon from '../assets/images/icons/odometer.svg'

import BlogIcon from '../assets/images/icons/b_log.png'
import BlogIconMoving from '../assets/images/icons/b_log_moving.png'
import BlogIconIdle from '../assets/images/icons/b_log_idle.png'
import BlogIconStop from '../assets/images/icons/b_log_stop.png'
import BlogIconSilence from '../assets/images/icons/b_log_silence.png'
import * as cron from 'node-cron'
import cus_marker from '../assets/images/marker_1.png'
import GeofenceMarker from '../assets/images/marker/geofence.png'
import CrashMarker from '../assets/images/icon_baru/crash.png'
import IdleMarker from '../assets/images/icon_baru/idle.png'
import MovingMarker from '../assets/images/icon_baru/moving.png'
import SilenceMarker from '../assets/images/icon_baru/silent.png'
import StopMarker from '../assets/images/icon_baru/stop.png'
import { MarkerWithLabel } from '@googlemaps/markerwithlabel'

import { BASE_FILE } from '../constant'
// Cluster Image
import M1 from '../assets/images/cluster/m1.png'
import M2 from '../assets/images/cluster/m1.png'
import M3 from '../assets/images/cluster/m1.png'
import M4 from '../assets/images/cluster/m1.png'
import M5 from '../assets/images/cluster/m1.png'

// POI
import POI from '../assets/images/POI.svg'

//
const car =
  'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
import { gmapApi } from 'vue2-google-maps'
import * as moment from 'moment'
import { getColor } from '@/helper/main'
import { json2excel } from 'js2excel'

// leaflet
import { latLng, icon } from 'leaflet'
import 'leaflet-rotatedmarker'
import 'leaflet.markercluster'

import Vue from 'vue'
import { renderToString } from 'vue-server-renderer/basic'
import AlertHistory from './master-data/alert/AlertHistory.vue'

export default {
  data() {
    return {
      infoOptions: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      googleListener: null,
      selectedPOICategory: null,
      IsCommandCenter: false,
      infoWindowPos: null,
      infoWinOpen: false,
      collapse: true,
      infoBoxOpen: false,
      infoBoxPOI: false,
      active_map: true,
      selectedLocation: null,
      pesan: '',
      GeofenceMarker: GeofenceMarker,
      IdleMarker: IdleMarker,
      MovingMarker: MovingMarker,
      StopMarker: StopMarker,
      SilenceMarker: SilenceMarker,
      CrashMarker: CrashMarker,
      BlogIcon,
      currentMidx: '',

      markerClusterGroup: null,
      icon: icon({
        iconUrl: BlogIconMoving,
        iconSize: [56, 56],
        iconAnchor: [28, 35],
      }),
      zoom: 5,
      centerLeaflet: latLng(-1.789275, 115.921327),
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
      },
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      center: { lat: -1.789275, lng: 115.921327 },
      map: '',
      POI: POI,
      baseUrl: '',
      filterLicense: '',
      directionDisplay: '',
      selectedPOI: null,
      data_coordinate: '',
      current_zoom: null,
      directionsService: '',
      geofence_array: [],
      pilih_filter: [],
      all_marker: [],
      marker_rotate: [],
      selected_filter: 'all',
      geofence: '',
      markerCluster: '',
      drawingManager: '',
      stepDisplay: '',
      imei: '',
      plate: [],
      vin: '',
      imei_array: [],
      plate_array: [],
      vin_array: [],

      isSidebarOpen: false,
      sidebar_count: 10,
      sidebar_locations: [],
      sidebarVehicleLookup: {},
      expandedCards: {},
      markerLookup: {},
      markerRenderToken: 0,
      markerRenderFrame: null,
      markerRenderBatchSize: 200,
      isApplyingDefaultFleet: false,
      isMarkerRendering: false,
      lastMarkerFleetId: null,
      lastMarkerFilter: null,
      syncMarkerIconsFrame: null,
      handleLeafletZoomEnd: null,
      repairCurrentPage: 1,
      repairHasMore: true,
      isLoadingRepair: false,
      operationCurrentPage: 1,
      operationHasMore: true,
      isLoadingOperation: false,
      idleCurrentPage: 1,
      idleHasMore: false,
      isLoadingIdle: false,
      stopCurrentPage: 1,
      stopHasMore: false,
      isLoadingStop: false,
      v_act_filter: [],
      downloadLoading: false,
      removingRepairId: null,
      addingRepairId: null,
      manualRepairModal: {
        show: false,
        vehicle: null,
        reason: '',
        file: null,
        fileName: '',
        submitting: false,
        error: '',
      },
      manualDetailModal: {
        show: false,
        vehicle: null,
        loading: false,
        completeData: null,
      },
      strips: [],

      cus_marker: cus_marker,
      position: '',
      eol: '',
      speed2: '',
      filterParam: [],
      dataPOI: [],
      geofencePOI: [],
      markerPOI: [],
      icon: {},
      locations: [],
      lastVertex: 1,
      k: 0,
      stepnum: 0,
      car: 'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z',
      step: 50,
      tick: 100,
      polyline: null,
      speed: 0.000005,
      wait: 1,
      poly2: null,
      infowindow: null,
      infoWindowButton: '',
      timerHandle: null,
      mapTypeControlOptions: {
        mapTypeIds: [],
      },
      marker: null,
      markerArray: [],
      steps: [],
      crontab: null,
      data: {
        total_vehicle: 0,
        geofence_violation: 0,
        moving_vehicle: 0,
        parking_vehicle: 0,
        silent_vehicle: 0,
      },
      headerList: [],
      sideBarList: [],
      video: Video,
      fleet_group_id: '',
      clickedLocation: '',
      titleModal: '',
      fleet_array: [],
      all_poi: [],
      categoryPOI: [],
      isImp: false,
      carsIcon: Cars,
      silenceCountFromAPI: null,

      openModal: false,
      openModalLiveShare: false,
      selectedVehicleId: '',
      isCommandCenter: false,
      isAdministrator: false,
      isCoordinator: false,
      disableImage: true,
      disable: false,
      mapIcon: Map,
      movingIcon: Moving,
      silenceIcon: Silence,
      inRepairIcon: InRepair,
      stopIcon: Stop,
      odometerIcon: OdometerIcon,
      // geofenceIcon: Geofence,
      uioIcon: UIO,
      totalIcon: Cars,
      idleIcon: Idle,
      parkIcon: Parking,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot',
      ],
      total_vehicle: { total: 0, last_page: 1 },

      d_type: '',
      d_vehicle: [],
      isFilterCollapsed: false,
      isMobileView: false,
      isMobileFilterVisible: false,
    }
  },
  beforeDestroy() {
    this.closeModal()
    this.stopCron()
    this.cancelMarkerRendering()
    if (this.syncMarkerIconsFrame) {
      cancelAnimationFrame(this.syncMarkerIconsFrame)
      this.syncMarkerIconsFrame = null
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  beforeRouteLeave(to, from, next) {
    //
    this.closeModal()
    this.cancelMarkerRendering()
    setTimeout(() => {
      next()
    }, 100)
  },
  watch: {
    // headerList: {
    //   handler(newVal, oldVal) {
    //     // Debug log
    //     console.log('📊 HeaderList updated:', newVal.map(h => ({
    //       title: h.text,
    //       total: h.total_vehicle ? h.total_vehicle.total : 0
    //     })))
        
    //     // Force re-compute activityFilterOptions
    //     this.$forceUpdate()
    //   },
    //   deep: true
    // },
    center(val) {
      //
    },
    selected_filter(val, oldVal) {
      const self = this
      this.vin = ''
      this.plate = []
      this.imei = ''
      if (this.drawingManager !== '') this.drawingManager.setMap(null)
      //
      if (this.all_marker.length > 0) {
        this.all_marker.forEach((x) => {
          x.setMap(null)
        })
      }

      // When filter is set to 'all', reload all data
      if (val === 'all') {
        if (oldVal && oldVal !== 'all') {
          this.getDataCron()
        }
        if (this.isMarkerRendering) {
          return
        }
        if (this.map) {
          this.getMarker(this.map)
        } else {
          this.getData()
        }
      }

      if (val == 'license_plate') {
        setTimeout(() => {
          const inputs = document.getElementsByTagName('input')
          const input = Array.from(inputs).find(
            (x) => x['placeholder'] == 'Search License Plate'
          )
          input.removeEventListener('keydown', self.onKeyDownLicense, true)
          input.addEventListener('keydown', self.onKeyDownLicense, true)
          input.addEventListener(
            'keyup',
            (e) => (e.target.value = e.target.value.toUpperCase()),
            true
          )
        }, 50)
      }
    },
    fleet_group_id(val) {
      if (this.isApplyingDefaultFleet) {
        return
      }

      if (val != '') {
        this.loadingStart('total-card')
        this.loadingStart('idle-card')
        this.loadingStart('uio-card')
        this.loadingStart('moving-card')
        this.loadingStart('stop-card')
        this.loadingStart('silence-card')
        this.loadingStart('repair-card')
        this.getDataCron()
        this.filterData()
      }
    },
    locations(val) {
      // Always recalc totals so dropdown counts stay in sync with displayed list
      this.updateHeaderListFromLocations(val)

      if (this.v_act_filter.length > 0) {
        let filteredLocations = []
        const baseLocations = this.filterByLicensePlate(val)

        // Handle IN_OPERATION filter
        if (this.v_act_filter.includes('IN_OPERATION')) {
          const operationFiltered = this.filterByLicensePlate(
            this.getVehiclesForActivity('IN_OPERATION', baseLocations)
          )

          filteredLocations = filteredLocations.concat(operationFiltered)
        }

        // Handle IN_REPAIR filter
        if (this.v_act_filter.includes('IN_REPAIR')) {
          const repairFiltered = this.filterByLicensePlate(
            this.getVehiclesForActivity('IN_REPAIR', baseLocations)
          )

          filteredLocations = filteredLocations.concat(repairFiltered)
        }

        // Handle SILENCE filter - langsung dari API backend
        if (this.v_act_filter.includes('SILENCE')) {
          const silenceVehicles = this.filterByLicensePlate(
            this.getVehiclesForActivity('SILENCE', baseLocations)
          )

          filteredLocations = filteredLocations.concat(silenceVehicles)
        }

        // Handle normal activity filters (MOVING, IDLE, STOP)
        const normalFilters = this.v_act_filter.filter((v) =>
          ['MOVING', 'IDLE', 'STOP'].includes(v)
        )
        if (normalFilters.length > 0) {
          normalFilters.forEach((activity) => {
            const vehicles = this.getVehiclesForActivity(
              activity,
              baseLocations
            )
            if (vehicles.length > 0) {
              filteredLocations = filteredLocations.concat(vehicles)
            }
          })
        }

        const uniqueLocations =
          this.uniqueVehiclesByLicensePlate(filteredLocations)

        const finalNormalized =
          this.normalizeLicensePlateForList(uniqueLocations)

        this.sidebar_locations = finalNormalized
        this.sidebar_count = finalNormalized.length
        
        if(this.sidebar_locations.length == 1){
          this.selectedActivityFilter = this.sidebar_locations[0].vehicle_activity
        }
      } 
      else {
        this.resetSidebarPagination()
        const normalizedLocations =
          this.resolveVehicleActivityForSidebarList(val)
        this.sidebar_locations = normalizedLocations
        this.sidebar_count = Math.min(10, normalizedLocations.length || 10)
      }
    },
    sidebar_locations() {
      this.resetCardExpansion()
      this.rebuildSidebarVehicleLookup()
      this.scheduleSyncMapMarkerIconsWithSidebar()
    },
    v_act_filter(val) {
      // Reset sidebar count when filter changes
      if (val.length === 0) {
        this.resetSidebarPagination()
      }

      // Reset repair pagination when switching to repair filter
      if (val.includes('IN_REPAIR')) {
        this.repairCurrentPage = 1
        this.repairHasMore = true
      }

      // Reset operation pagination when switching to operation filter
      if (val.includes('IN_OPERATION')) {
        this.operationCurrentPage = 1
        this.operationHasMore = true
      }

      if (val.includes('IDLE')) {
        this.idleCurrentPage = 1
        this.idleHasMore = Boolean(
          this.headerList[3] &&
            this.headerList[3].total_vehicle &&
            this.headerList[3].total_vehicle.last_page &&
            this.headerList[3].total_vehicle.last_page > 1
        )
      }

      if (val.includes('STOP')) {
        this.stopCurrentPage = 1
        this.stopHasMore = Boolean(
          this.headerList[4] &&
            this.headerList[4].total_vehicle &&
            this.headerList[4].total_vehicle.last_page &&
            this.headerList[4].total_vehicle.last_page > 1
        )
      }

      if (val.length > 0) {
        let filteredLocations = []
        
        // Apply license plate filter to base locations first
        const baseLocations = this.filterByLicensePlate(this.locations)

        // Handle IN_OPERATION filter
        if (val.includes('IN_OPERATION')) {
          const operationFiltered = this.filterByLicensePlate(
            this.getVehiclesForActivity('IN_OPERATION', baseLocations)
          )

          filteredLocations = filteredLocations.concat(operationFiltered)
        }

        // Handle IN_REPAIR filter
        if (val.includes('IN_REPAIR')) {
          const repairFiltered = this.filterByLicensePlate(
            this.getVehiclesForActivity('IN_REPAIR', baseLocations)
          )

          filteredLocations = filteredLocations.concat(repairFiltered)
        }

        // Handle SILENCE filter
        if (val.includes('SILENCE')) {
          const silenceVehicles = this.filterByLicensePlate(
            this.getVehiclesForActivity('SILENCE', baseLocations)
          )

          filteredLocations = filteredLocations.concat(silenceVehicles)
        }

        // Handle normal activity filters (MOVING, IDLE, STOP)
        const normalFilters = val.filter((v) =>
          ['MOVING', 'IDLE', 'STOP'].includes(v)
        )
        if (normalFilters.length > 0) {
          normalFilters.forEach((activity) => {
            const vehicles = this.getVehiclesForActivity(
              activity,
              baseLocations // Use filtered base locations
            )
            if (vehicles.length > 0) {
              filteredLocations = filteredLocations.concat(vehicles)
            }
          })
        }

        const uniqueLocations =
          this.uniqueVehiclesByLicensePlate(filteredLocations)
        const normalized = this.normalizeLicensePlateForList(uniqueLocations)
        this.sidebar_locations = normalized
        this.sidebar_count = normalized.length
      } else {
        // No activity filter - show all vehicles (with license plate filter if active)
        this.resetSidebarPagination()
        const filteredLocations = this.filterByLicensePlate(this.locations)
        const normalizedLocations =
          this.resolveVehicleActivityForSidebarList(filteredLocations)
        this.sidebar_locations = normalizedLocations
        this.sidebar_count = Math.min(10, normalizedLocations.length || 10)
      }
    },
    plate(val) {
      if (val && val.length > 0) {
        this.filterData()
      }
    },
    vin(val) {
      if (val && val !== '') {
        this.filterData()
      }
    },
    imei(val) {
      if (val && val !== '') {
        this.filterData()
      }
    },
  },

  methods: {
    resetSidebarPagination(limit = 10) {
      this.sidebar_count = limit
    },
    uniqueVehiclesByLicensePlate(vehicles) {
      if (!Array.isArray(vehicles)) return []

      const seen = new Set()
      return vehicles.filter((vehicle) => {
        const plate = this.getVehicleLicensePlate(vehicle)
        const key = plate ? plate.trim().toUpperCase() : ''
        if (!key || seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    resolveVehicleActivityForSidebarList(list) {
      return this.normalizeLicensePlateForList(list).map((vehicle) => {
        const resolved = { ...vehicle }
        resolved.vehicle_activity = this.resolveVehicleActivity(resolved)
        return resolved
      })
    },
    shouldUseFilteredStatusCounts() {
      return ['license_plate', 'imei', 'vin'].includes(this.selected_filter)
    },
    getFilteredStatusCount(activity) {
      const vehicles = this.uniqueVehiclesByLicensePlate(
        this.resolveVehicleActivityForSidebarList(this.sidebar_locations)
      )

      if (activity === 'ALL') return vehicles.length

      return vehicles.filter((vehicle) => {
        const resolvedActivity = this.resolveVehicleActivity(vehicle)

        if (activity === 'IN_OPERATION') {
          return this.isInOperationVehicle(vehicle)
        }

        if (activity === 'IN_REPAIR') {
          return (
            resolvedActivity === 'IN_REPAIR' || this.isManualVehicle(vehicle)
          )
        }

        return resolvedActivity === activity
      }).length
    },
    removeDuplicates(array, key = 'value') {
      const seen = new Set()
      return array.filter(item => {
        const value = item[key]
        if (seen.has(value)) {
          return false
        }
        seen.add(value)
        return true
      })
    },
    async fetchSilenceCount() {
      try {
        const fleetId = this.fleet_group_id || this.$dataLocal.UserData().id
        const res = await REPO.getDashboardSilentVehicleCount(fleetId, {})
        if (res.data.status == 'true') {
          this.silenceCountFromAPI = res.data.data
        }
      } catch (err) {
        console.error('Error fetching silence count:', err)
      }
    },
    handleResize() {
      if (typeof window === 'undefined') return
      this.isMobileView = window.innerWidth <= 768
      if (!this.isMobileView) {
        this.isMobileFilterVisible = false
      }
    },
    toggleMobileFilter() {
      this.isFilterCollapsed = false
      this.isMobileFilterVisible = true
    },
    closeMobileFilter() {
      this.isMobileFilterVisible = false
    },
    toggleFilterCollapse() {
      this.isFilterCollapsed = !this.isFilterCollapsed
    },
    getSidebarItemKey(item) {
      if (!item || typeof item !== 'object') return null
      return (
        item._id ||
        item.vehicle_id ||
        item.license_plate ||
        item.vehicle_number ||
        item.vin ||
        item.id ||
        JSON.stringify({ plate: item.license_plate, vin: item.vin })
      )
    },
    isCardExpanded(item) {
      const key = this.getSidebarItemKey(item)
      if (!key) return false
      return Boolean(this.expandedCards[key])
    },
    toggleCardExpansion(item) {
      const key = this.getSidebarItemKey(item)
      if (!key) return
      const nextState = !this.isCardExpanded(item)
      this.$set(this.expandedCards, key, nextState)
    },
    resetCardExpansion() {
      this.expandedCards = {}
    },
    canViewVehicleDetail(vehicle) {
      return Boolean(this.getVehicleInfoReferenceId(vehicle))
    },
    getVehicleReferenceKeys(entity) {
      if (!entity) return []

      const addKey = (set, value, transform) => {
        if (value === null || value === undefined) return
        const stringValue = String(value).trim()
        if (!stringValue) return
        set.add(transform ? transform(stringValue) : stringValue)
      }

      const keys = new Set()
      addKey(keys, this.getVehicleInfoReferenceId(entity))
      addKey(keys, this.getVehicleLicensePlate(entity), (v) => v.toUpperCase())

      const additionalCandidates = [
        entity.vin,
        entity.vehicle_number,
        entity.vehicleNumber,
        entity.vehicle_no,
        entity.vehicleNo,
        entity.device_id,
        entity.deviceId,
      ]

      additionalCandidates.forEach((candidate) =>
        addKey(keys, candidate, (v) => v.toUpperCase())
      )

      return Array.from(keys)
    },
    getVehicleInfoReferenceId(vehicle) {
      if (!vehicle) return null
      return vehicle._id || vehicle.vehicle_id || vehicle.id || null
    },
    findLocationForVehicle(vehicle) {
      if (!vehicle || !Array.isArray(this.locations)) {
        return null
      }

      const targetKeys = new Set(this.getVehicleReferenceKeys(vehicle))
      if (targetKeys.size === 0) return null

      return this.locations.find((location) => {
        const locationKeys = this.getVehicleReferenceKeys(location)
        return locationKeys.some((key) => targetKeys.has(key))
      })
    },
    rebuildSidebarVehicleLookup() {
      const lookup = {}
      if (!Array.isArray(this.sidebar_locations)) {
        this.sidebarVehicleLookup = lookup
        return
      }

      this.sidebar_locations.forEach((vehicle) => {
        this.getVehicleReferenceKeys(vehicle).forEach((key) => {
          lookup[key] = vehicle
        })
      })

      this.sidebarVehicleLookup = lookup
    },
    findSidebarVehicleForLocation(location) {
      if (!location || !this.sidebarVehicleLookup) {
        return null
      }

      const targetKeys = this.getVehicleReferenceKeys(location)
      for (const key of targetKeys) {
        if (this.sidebarVehicleLookup[key]) {
          return this.sidebarVehicleLookup[key]
        }
      }
      return null
    },
    resolveMapDisplayActivity(location) {
      const sidebarVehicle = this.findSidebarVehicleForLocation(location)
      const sidebarActivity =
        sidebarVehicle && this.getDisplayActivity(sidebarVehicle)
      const normalizedSidebarActivity =
        this.normalizeVehicleActivity(sidebarActivity)

      if (normalizedSidebarActivity) {
        return normalizedSidebarActivity
      }

      return this.resolveVehicleActivity(location)
    },
    getMapIconByActivity(activity) {
      const normalized = this.normalizeVehicleActivity(activity)
      if (normalized === 'MOVING') return BlogIconMoving
      if (normalized === 'STOP') return BlogIconStop
      if (normalized === 'SILENCE') return BlogIconSilence
      return BlogIconIdle
    },
    getGoogleMarkerIcon(iconUrl) {
      return {
        url: iconUrl,
        anchor: new google.maps.Point(28, 35),
        scaledSize: new google.maps.Size(56, 56),
        labelOrigin: new google.maps.Point(28, 28),
        fillColor: '#00CCBB',
        fillOpacity: 1,
        strokeColor: '',
        strokeWeight: 0,
      }
    },
    getLeafletMarkerIcon(iconUrl) {
      return icon({
        iconUrl,
        iconSize: [48, 48],
        iconAnchor: [24, 24],
        tooltipAnchor: [0, 12],
      })
    },
    updateGoogleMarkerRotationIcon(previousUrl, nextUrl, direction) {
      if (!Array.isArray(this.marker_rotate)) return

      const existing = this.marker_rotate.find(
        (item) => item.icon === previousUrl
      )
      if (existing) {
        existing.icon = nextUrl
        existing.rotation = direction
        return
      }

      this.marker_rotate.push({
        icon: nextUrl,
        rotation: direction,
      })
    },
    applyGoogleMarkerRotation(iconUrl, direction) {
      setTimeout(() => {
        const markerImage = document.querySelector(`img[src="${iconUrl}"]`)
        if (markerImage) {
          markerImage.style.cssText += `transform: rotate(${
            direction + 90
          }deg); transform-origin: center center;`
        }
      }, 100)
    },
    scheduleSyncMapMarkerIconsWithSidebar() {
      if (this.syncMarkerIconsFrame) {
        cancelAnimationFrame(this.syncMarkerIconsFrame)
      }

      this.syncMarkerIconsFrame = requestAnimationFrame(() => {
        this.syncMarkerIconsFrame = null
        this.syncMapMarkerIconsWithSidebar()
      })
    },
    syncMapMarkerIconsWithSidebar() {
      if (
        !Array.isArray(this.sidebar_locations) ||
        this.sidebar_locations.length === 0 ||
        !this.markerLookup
      ) {
        return
      }

      const sidebarVehicles =
        Array.isArray(this.v_act_filter) && this.v_act_filter.length === 0
          ? this.sidebar_locations.slice(0, this.sidebar_count)
          : this.sidebar_locations

      sidebarVehicles.forEach((sidebarVehicle) => {
        const marker = this.findMarkerForVehicle(sidebarVehicle)
        if (!marker || typeof marker.setIcon !== 'function') return

        const location =
          this.findLocationForVehicle(sidebarVehicle) || sidebarVehicle

        const previousIconUrl = this.getMapIconByActivity(
          location.vehicle_activity
        )
        const activity = this.resolveMapDisplayActivity(location)
        const iconUrl = this.getMapIconByActivity(activity)
        location.vehicle_activity = activity

        if (this.getRolePermission().dashboard.maps.google_maps) {
          const previousUrl = previousIconUrl + '#' + location._id
          const nextUrl = iconUrl + '#' + location._id
          marker.setIcon(this.getGoogleMarkerIcon(nextUrl))
          this.updateGoogleMarkerRotationIcon(
            previousUrl,
            nextUrl,
            location.direction
          )
          this.applyGoogleMarkerRotation(nextUrl, location.direction)
        } else if (this.getRolePermission().dashboard.maps.openstreet_maps) {
          marker.setIcon(this.getLeafletMarkerIcon(iconUrl))
        }
      })
    },
    registerMarkerForLocation(marker, location) {
      if (!marker || !location) return
      const keys = this.getVehicleReferenceKeys(location)
      if (!keys.length) return

      keys.forEach((key) => {
        this.$set(this.markerLookup, key, marker)
      })
    },
    findMarkerForVehicle(vehicle) {
      if (!vehicle) return null
      const keys = this.getVehicleReferenceKeys(vehicle)
      for (const key of keys) {
        if (key && this.markerLookup[key]) {
          return this.markerLookup[key]
        }
      }
      return null
    },
    openVehicleInfo(location, options = {}) {
      if (!location) {
        this.$toast.error('Data kendaraan tidak ditemukan')
        return Promise.resolve()
      }

      const referenceId = this.getVehicleInfoReferenceId(location)
      if (!referenceId) {
        this.$toast.error('Vehicle ID tidak ditemukan')
        return Promise.resolve()
      }

      const { showLoader = true } = options
      let loadingStarted = false

      this.infoBoxOpen = false
      this.clickedLocation = { ...location }
      const resolveNumeric = (value) => {
        const parsed = parseFloat(value)
        return Number.isNaN(parsed) ? null : parsed
      }

      const fallbackLatitudeRaw =
        location.latitude !== undefined
          ? location.latitude
          : location.lat !== undefined
            ? location.lat
            : null
      const fallbackLongitudeRaw =
        location.longitude !== undefined
          ? location.longitude
          : location.lng !== undefined
            ? location.lng
            : null

      const fallbackLatitudeNumeric = resolveNumeric(fallbackLatitudeRaw)
      const fallbackLongitudeNumeric = resolveNumeric(fallbackLongitudeRaw)

      if (showLoader && this.$vs && typeof this.$vs.loading === 'function') {
        this.$vs.loading()
        loadingStarted = true
      }

      return REPO.getOneMWMapping(referenceId)
        .then((response) => {
          const detail = response && response.data && response.data.data
          if (!detail) {
            throw new Error('Vehicle detail tidak ditemukan')
          }

          const parsedLatitude = resolveNumeric(detail.latitude)
          const parsedLongitude = resolveNumeric(detail.longitude)

          const effectiveLatitude =
            parsedLatitude !== null
              ? parsedLatitude
              : fallbackLatitudeNumeric !== null
                ? fallbackLatitudeNumeric
                : this.clickedLocation.latitude

          const effectiveLongitude =
            parsedLongitude !== null
              ? parsedLongitude
              : fallbackLongitudeNumeric !== null
                ? fallbackLongitudeNumeric
                : this.clickedLocation.longitude

          this.clickedLocation = {
            ...detail,
            latitude: effectiveLatitude,
            longitude: effectiveLongitude,
          }

          this.selectedLocation = { ...detail }
          this.$nextTick(() => {
            this.infoBoxOpen = true
          })

          if (
            effectiveLatitude !== null &&
            effectiveLongitude !== null &&
            !Number.isNaN(effectiveLatitude) &&
            !Number.isNaN(effectiveLongitude)
          ) {
            this.center = {
              lat: effectiveLatitude,
              lng: effectiveLongitude,
            }
          }
        })
        .catch((error) => {
          this.infoBoxOpen = false
          const message =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error_msg) ||
            (error && error.message) ||
            'Gagal membuka detail kendaraan'
          this.$toast.error(message)
        })
        .finally(() => {
          if (
            loadingStarted &&
            this.$vs &&
            this.$vs.loading &&
            typeof this.$vs.loading.close === 'function'
          ) {
            this.$vs.loading.close()
          }
        })
    },
    viewVehicleDetail(vehicle) {
      const canonicalLocation = this.findLocationForVehicle(vehicle)
      const target = canonicalLocation || vehicle

      if (!target) {
        this.$toast.error('Data kendaraan tidak ditemukan')
        return
      }

      if (target.vehicle_id) {
        this.$router.push(`/monitoring-vehicle/${target.vehicle_id}`)
        return
      }

      if (!this.canViewVehicleDetail(target)) {
        this.$toast.error('Vehicle ID tidak ditemukan')
        return
      }

      const referenceId = this.getVehicleInfoReferenceId(target)
      if (!referenceId) {
        this.$toast.error('Vehicle ID tidak ditemukan')
        return
      }

      let loadingStarted = false
      if (this.$vs && typeof this.$vs.loading === 'function') {
        this.$vs.loading()
        loadingStarted = true
      }

      REPO.getOneMWMapping(referenceId)
        .then((response) => {
          const detail = response && response.data && response.data.data
          const vehicleId = detail && (detail.vehicle_id || detail.id)

          if (!vehicleId) {
            throw new Error('Vehicle detail tidak ditemukan')
          }

          this.$router.push(`/monitoring-vehicle/${vehicleId}`)
        })
        .catch((error) => {
          const message =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error_msg) ||
            (error && error.message) ||
            'Gagal membuka detail kendaraan'
          this.$toast.error(message)
        })
        .finally(() => {
          if (
            loadingStarted &&
            this.$vs &&
            this.$vs.loading &&
            typeof this.$vs.loading.close === 'function'
          ) {
            this.$vs.loading.close()
          }
        })
    },
    formatActivity(activity) {
      if (!activity) return '-'
      const mapping = {
        IN_OPERATION: 'In Operation',
        MOVING: 'Moving',
        IDLE: 'Idle',
        STOP: 'Stop',
        SILENCE: 'Silence',
        IN_REPAIR: 'In Repair',
      }
      return mapping[activity] || activity
    },
    getDisplayActivity(vehicle) {
      // If silence filter is active, all vehicles in the list are silence vehicles
      if (this.isSilenceFilterActive) {
        return 'SILENCE'
      }
      // Otherwise use the actual vehicle activity
      return vehicle.vehicle_activity || ''
    },
    formatSpeed(speed) {
      if (speed === null || speed === undefined || speed === '') {
        return '-'
      }
      return `${speed} km/h`
    },
    statusBadgeClass(activity) {
      const normalized = this.normalizeVehicleActivity(activity)
      const base = 'manual-card__status'
      const variants = {
        MOVING: `${base} manual-card__status--moving`,
        IDLE: `${base} manual-card__status--idle`,
        STOP: `${base} manual-card__status--stop`,
        SILENCE: `${base} manual-card__status--silence`,
        IN_OPERATION: `${base} manual-card__status--operation`,
        IN_REPAIR: `${base} manual-card__status--repair`,
      }
      return variants[normalized] || `${base} manual-card__status--default`
    },
    formatDeviceTime(value) {
      if (!value) return '-'
      const m = moment(value)
      if (!m.isValid()) return '-'
      return m.format('HH:mm • DD MMM')
    },
    formatGeofenceStatus(vehicle) {
      if (!vehicle) return '-'

      const normalizeText = (val) =>
        typeof val === 'string' ? val.trim().toUpperCase() : ''

      const status = normalizeText(vehicle.geofence_status)
      const statusMap = {
        IN: 'Inside Geofence',
        INSIDE: 'Inside Geofence',
        OUT: 'Outside Geofence',
        OUTSIDE: 'Outside Geofence',
        VIOLATION: 'Geofence Violation',
      }
      if (status && statusMap[status]) {
        return statusMap[status]
      }

      const flags = [vehicle.geofence_violation, vehicle.is_geofence_violation]
      const hasViolation = flags.some((flag) => {
        if (flag === undefined || flag === null) return false
        if (typeof flag === 'boolean') return flag
        if (typeof flag === 'number') return flag !== 0
        if (typeof flag === 'string') {
          const normalized = flag.trim().toLowerCase()
          return ['true', '1', 'y', 'yes'].includes(normalized)
        }
        return false
      })

      if (hasViolation) {
        return 'Geofence Violation'
      }

      return '-'
    },
    isInOperationVehicle(vehicle) {
      const normalizeFlag = (flag) => {
        if (flag === undefined || flag === null) return false
        if (typeof flag === 'boolean') return flag
        if (typeof flag === 'number') return flag !== 0
        if (typeof flag === 'string') {
          const normalized = flag.trim().toLowerCase()
          return ['true', '1', 'y', 'yes'].includes(normalized)
        }
        return false
      }

      const normalizeText = (value) =>
        typeof value === 'string' ? value.trim().toUpperCase() : ''

      const activity = this.normalizeVehicleActivity(
        vehicle && vehicle.vehicle_activity
      )
      if (activity === 'IN_OPERATION') {
        return true
      }

      const geofenceStatus = normalizeText(vehicle && vehicle.geofence_status)
      if (['OUT', 'OUTSIDE', 'VIOLATION'].includes(geofenceStatus)) {
        return true
      }

      return (
        normalizeFlag(vehicle && vehicle.geofence_violation) ||
        normalizeFlag(vehicle && vehicle.is_geofence_violation)
      )
    },
    getVehicleLicensePlate(vehicle) {
      if (!vehicle) return ''
      return (
        vehicle.license_plate ||
        vehicle.vehicle_plate ||
        vehicle.plate_number ||
        vehicle.licensePlate ||
        vehicle.plate ||
        ''
      )
    },
    normalizeVehicleActivity(activity) {
      if(activity === '-') return '-';
      
      if (activity === null || activity === undefined) return ''

      let upper
      if (typeof activity === 'string') {
        upper = activity.trim().toUpperCase()
      } else {
        try {
          upper = String(activity).trim().toUpperCase()
        } catch (error) {
          return ''
        }
      }

      if (!upper) return ''

      const compact = upper
        .replace(/[\s-]+/g, '_')
        .replace(/__+/g, '_')
        .replace(/^_+|_+$/g, '')

      const aliasMap = {
        IN_OPERATION: 'IN_OPERATION',
        INOPERATION: 'IN_OPERATION',
        OPERATION: 'IN_OPERATION',
        IN_OPERATIONAL: 'IN_OPERATION',
        INOP: 'IN_OPERATION',
        MOVING: 'MOVING',
        MOVE: 'MOVING',
        RUNNING: 'MOVING',
        DRIVING: 'MOVING',
        IDLE: 'IDLE',
        IDLING: 'IDLE',
        IDLER: 'IDLE',
        STOP: 'STOP',
        STOPPED: 'STOP',
        STOPPING: 'STOP',
        STATIONARY: 'STOP',
        PARKED: 'STOP',
        PARKING: 'STOP',
        HALT: 'STOP',
        SILENCE: 'SILENCE',
        SILENT: 'SILENCE',
        SILENCED: 'SILENCE',
        IN_REPAIR: 'IN_REPAIR',
        REPAIR: 'IN_REPAIR',
        REPAIRING: 'IN_REPAIR',
        UNDER_REPAIR: 'IN_REPAIR',
        IN_MAINTENANCE: 'IN_REPAIR',
      }

      if (aliasMap[compact]) {
        return aliasMap[compact]
      }

      const trimmed = compact.replace(/_/g, '')
      if (aliasMap[trimmed]) {
        return aliasMap[trimmed]
      }

      return compact
    },
    resolveVehicleActivity(location) {
      if (!location) return ''
      
      if(location.vehicle_activity && location.vehicle_activity == '-') return '-';

      const activitySource =
        typeof location.vehicle_activity !== 'undefined'
          ? location.vehicle_activity
          : typeof location.vehicleActivity !== 'undefined'
            ? location.vehicleActivity
            : location.activity

      const normalized = this.normalizeVehicleActivity(activitySource)

      const rawDeviceTime =
        location.device_time ||
        location.deviceTime ||
        (location.latest_activity && location.latest_activity.device_time)

      let hoursSinceUpdate = null
      if (rawDeviceTime) {
        let deviceMoment = moment(rawDeviceTime)
        if (!deviceMoment.isValid() && typeof rawDeviceTime === 'string') {
          deviceMoment = moment(
            rawDeviceTime,
            ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ', moment.ISO_8601],
            true
          )
        }

        if (deviceMoment.isValid()) {
          hoursSinceUpdate = moment().diff(deviceMoment, 'hours', true)
        }
      }

      const isManual = this.isTruthyManualFlag(
        typeof location.is_manual !== 'undefined'
          ? location.is_manual
          : location.isManual
      )
      const isInRepair = normalized === 'IN_REPAIR'
      const isStale =
        typeof hoursSinceUpdate === 'number' &&
        !Number.isNaN(hoursSinceUpdate) &&
        hoursSinceUpdate >= 4

      if (isStale && !isManual && !isInRepair) {
        return 'SILENCE'
      }

      if (normalized) {
        return normalized
      }

      if (isStale) {
        return 'SILENCE'
      }

      return ''
    },
    normalizeLicensePlateForList(list) {
      if (!Array.isArray(list)) return []
      return list.map((item) => {
        const normalized = { ...item }
        const plate = this.getVehicleLicensePlate(item)
        if (plate) {
          normalized.license_plate = plate
        }

        const activityValue =
          typeof item.vehicle_activity !== 'undefined'
            ? item.vehicle_activity
            : typeof item.vehicleActivity !== 'undefined'
              ? item.vehicleActivity
              : item.activity

        if (activityValue !== undefined && activityValue !== null) {
          normalized.vehicle_activity =
            this.normalizeVehicleActivity(activityValue)
        }

        if (typeof normalized.vehicleActivity !== 'undefined') {
          delete normalized.vehicleActivity
        }

        let manualValue
        if (typeof normalized.is_manual !== 'undefined') {
          manualValue = normalized.is_manual
        } else if (typeof normalized.isManual !== 'undefined') {
          manualValue = normalized.isManual
          delete normalized.isManual
        }

        if (typeof manualValue !== 'undefined') {
          normalized.is_manual = this.isTruthyManualFlag(manualValue)
        }

        return normalized
      })
    },
    getHeaderVehiclesByActivity(activity) {
      if (!Array.isArray(this.headerList) || this.headerList.length === 0) {
        return []
      }

      const activityMap = {
        IN_OPERATION: { index: 1, key: 'd_geofence_violation' },
        MOVING: { index: 2, key: 'd_moving_vehicle' },
        IDLE: { index: 3, key: 'd_idle_vehicle' },
        STOP: { index: 4, key: 'd_stop_vehicle' },
        SILENCE: { index: 5, key: 'd_silent_vehicle' },
        IN_REPAIR: { index: 6, key: 'd_in_repair_vehicle' },
      }

      const target = activityMap[activity]
      if (!target) return []

      const entry = this.headerList[target.index]
      if (!entry || !Array.isArray(entry[target.key])) {
        return []
      }

      return this.normalizeLicensePlateForList(entry[target.key])
    },
    getVehiclesForActivity(activity, fallbackSource = []) {
      if (this.shouldUseFilteredStatusCounts()) {
        const filteredSource = Array.isArray(fallbackSource)
          ? fallbackSource
          : []

        const filteredVehicles = filteredSource.filter((vehicle) => {
          const resolvedActivity = this.resolveVehicleActivity(vehicle)

          if (activity === 'IN_OPERATION') {
            return this.isInOperationVehicle(vehicle)
          }

          if (activity === 'IN_REPAIR') {
            return (
              resolvedActivity === 'IN_REPAIR' || this.isManualVehicle(vehicle)
            )
          }

          return resolvedActivity === activity
        })

        return this.resolveVehicleActivityForSidebarList(filteredVehicles)
      }

      const fromHeader = this.getHeaderVehiclesByActivity(activity)
      if (fromHeader.length > 0) {
        return fromHeader
      }

      if (!Array.isArray(fallbackSource) || fallbackSource.length === 0) {
        return []
      }

      const fallbackFiltered = fallbackSource.filter((x) => {
        const registeredEvent = this.resolveVehicleActivity(x)
        return registeredEvent === activity
      })

      return this.normalizeLicensePlateForList(fallbackFiltered)
    },
    shouldSyncHeaderWithLocations() {
      // Keep API counts unless a manual filter is applied
      if (!Array.isArray(this.headerList) || this.headerList.length === 0) {
        return false
      }

      if (
        this.selected_filter === 'fleet_group' ||
        this.shouldUseFilteredStatusCounts()
      ) {
        return false
      }

      return this.selected_filter && this.selected_filter !== 'all'
    },
    updateHeaderListFromLocations(locations) {
      if (!this.shouldSyncHeaderWithLocations()) {
        return
      }

      // Calculate vehicle counts based on filtered locations
      const normalizedLocations = this.normalizeLicensePlateForList(
        Array.isArray(locations) ? locations : []
      )

      const repairEntries = this.normalizeLicensePlateForList(
        this.headerList[6].d_in_repair_vehicle || []
      )
      const repairPlates = new Set(
        repairEntries
          .map((vehicle) => this.getVehicleLicensePlate(vehicle))
          .filter(Boolean)
          .map((plate) => plate.trim().toUpperCase())
      )

      const operationEntries = this.normalizeLicensePlateForList(
        this.headerList[1].d_geofence_violation || []
      )
      const operationPlates = new Set(
        operationEntries
          .map((vehicle) => this.getVehicleLicensePlate(vehicle))
          .filter(Boolean)
          .map((plate) => plate.trim().toUpperCase())
      )

      const seenPlates = new Set()

      const buckets = {
        total: [],
        in_operation: [],
        moving: [],
        idle: [],
        stop: [],
        silence: [],
        repair: [],
      }

      normalizedLocations.forEach((location) => {
        const plate = this.getVehicleLicensePlate(location)
        const normalizedPlate = plate ? plate.trim().toUpperCase() : ''
        if (!normalizedPlate || seenPlates.has(normalizedPlate)) {
          return
        }

        seenPlates.add(normalizedPlate)
        buckets.total.push(location)

        const activity = this.resolveVehicleActivity(location)
        location.vehicle_activity = activity

        const isManualRepair = this.isManualVehicle(location)
        const isListedRepair = repairPlates.has(normalizedPlate)
        const isRepair =
          activity === 'IN_REPAIR' || isManualRepair || isListedRepair

        // Untuk activity IN_REPAIR, masukkan ke bucket repair
        if (activity === 'IN_REPAIR') {
          buckets.repair.push(location)
          return
        }

        // SILENCE tidak di-bucket di sini, langsung dari API backend
        // Skip SILENCE agar tidak di-proses di frontend
        if (activity === 'SILENCE') {
          return
        }

        // Untuk activity lain (MOVING, IDLE, STOP), exclude jika ada di repair list
        if (isManualRepair || isListedRepair) {
          buckets.repair.push(location)
          return
        }

        if (
          this.isInOperationVehicle(location) ||
          operationPlates.has(normalizedPlate)
        ) {
          buckets.in_operation.push(location)
        }

        switch (activity) {
          case 'MOVING':
            buckets.moving.push(location)
            break
          case 'IDLE':
            buckets.idle.push(location)
            break
          case 'STOP':
            buckets.stop.push(location)
            break
        }
      })

      // Update headerList with calculated counts
      this.headerList[0].total_vehicle = {
        total: buckets.total.length,
        data: buckets.total,
      }
      this.headerList[0].d_total_vehicle = buckets.total

      // IMPORTANT: Don't overwrite In Operation count from API
      // The API call (getDashboardGeofenceViolation) provides the authoritative count
      // We only update the display list (d_geofence_violation) if we have valid data from calculation
      // but preserve the total count from API
      const currentInOperationTotal =
        this.headerList[1].total_vehicle &&
        this.headerList[1].total_vehicle.total
          ? this.headerList[1].total_vehicle.total
          : 0
      if (currentInOperationTotal > 0) {
        // Keep API total but update list if we have calculated data
        if (buckets.in_operation.length > 0) {
          this.headerList[1].d_geofence_violation = buckets.in_operation
        }
        // Keep existing total from API
      } else {
        // No API data yet, use calculated value
        this.headerList[1].total_vehicle = {
          total: buckets.in_operation.length,
        }
        this.headerList[1].d_geofence_violation = buckets.in_operation
      }

      this.headerList[2].total_vehicle = { total: buckets.moving.length }
      this.headerList[2].d_moving_vehicle = buckets.moving
      this.headerList[3].total_vehicle = { total: buckets.idle.length }
      this.headerList[3].d_idle_vehicle = buckets.idle
      this.headerList[4].total_vehicle = { total: buckets.stop.length }
      this.headerList[4].d_stop_vehicle = buckets.stop

      // SILENCE: Tidak update di sini, langsung dari API backend
      // headerList[5] di-update di getDataCron() via getDashboardSilentVehicle

      this.headerList[6].total_vehicle = { total: buckets.repair.length }
      this.headerList[6].d_in_repair_vehicle = buckets.repair
    },
    resetFilter() {
      const defaultFleetId = this.$dataLocal.UserData().id

      // Reset all filter values to default
      this.plate = []
      this.vin = ''
      this.imei = ''
      this.v_act_filter = []
      this.fleet_group_id = defaultFleetId

      if (this.selected_filter !== 'all') {
        this.selected_filter = 'all'
      } else if (this.map) {
        this.getMarker(this.map)
      } else {
        this.getData()
      }

      this.getDataCron()

      // Show success notification
      this.$vs.notify({
        title: 'Filter Reset',
        text: 'All filters have been reset',
        color: 'success',
        position: 'bottom-right',
      })
    },
    async downloadCurrentFilterData() {
      if (!this.showDownloadButton) return
      this.downloadLoading = true

      const type = this.currentFilterType
      const reportTitle = this.currentFilterTitle
      const fleetId = this.fleet_group_id || this.$dataLocal.UserData().id

      const res = await REPO.getVehicleDashboardDownload(fleetId, type)
      const data = (res && res.data && res.data.data) || []
      
      data.forEach((item) => {
        if (item && item.device_time) {
          item.duration = this.getDuration(item.device_time)
        }
      })

      // Prepare data for excel export
      const exportData = data.map((item) => ({
        license_plate: item.license_plate || '',
        device_time: item.device_time || '',
        duration: item.duration || '',
        vehicle_activity:
          type === 'silence' ? 'SILENCE' : item.vehicle_activity || '',
        speed: item.speed || 0,
        latitude: item.latitude || '',
        longitude: item.longitude || '',
        driver_name: item.driver_name || '',
        fleet_group_name: item.fleet_group_name || '',
        vehicle_model: item.vehicle_model || '',
        imei: item.imei || '',
        'Sim Card Number': item.simcard_number || item.sim_card_number || '',
      }))

      json2excel({
        data: exportData,
        name: reportTitle,
        formateDate: 'yyyy-mm-dd hh:ss',
      })

      this.downloadLoading = false
      this.$toast.success(`Data ${reportTitle} berhasil diunduh`)
      return

      const exportTypeMap = {
        all: 'all', // Changed from 'total' to 'silent' - use the working API that returns all vehicles
        operation: 'geofence',
        moving: 'moving',
        idle: 'idle',
        stop: 'stop',
        silence: 'silent',
        repair: 'repair',
      }
      const apiType = exportTypeMap[type] || 'silent'

      this.downloadLoading = true
      try {
        let data = []

        // For silence filter, use headerList data to get complete info (imei, simcard)
        if (type === 'silence') {
          // Use headerList[5].d_silent_vehicle for complete data with all fields
          const silenceVehicles = this.headerList[5].d_silent_vehicle || []

          // Filter out vehicles without latitude (same as UI does)
          data = silenceVehicles.filter((location) => {
            return (
              'latitude' in location &&
              location.latitude !== '' &&
              location.latitude !== null
            )
          })
        } else if (['idle', 'stop', 'moving'].includes(type)) {
          data = await this.fetchAllVehiclesForActivity(type)
        } else {
          const res = await REPO.getAllVehicleDownload(apiType, fleetId)
          data = (res && res.data && res.data.data) || []

          // Fallback to sidebar data to avoid empty exports when API has no payload yet
          if (!data.length && Array.isArray(this.sidebar_locations)) {
            data = this.sidebar_locations
          }
        }

        if (!data.length) {
          this.$toast.error('Data tidak ditemukan')
          return
        }

        // Add duration to each item
        data.forEach((item) => {
          if (item && item.device_time) {
            item.duration = this.getDuration(item.device_time)
          }
        })

        // Prepare data for excel export
        const exportData = data.map((item) => ({
          license_plate: item.license_plate || '',
          device_time: item.device_time || '',
          duration: item.duration || '',
          vehicle_activity:
            type === 'silence' ? 'SILENCE' : item.vehicle_activity || '',
          speed: item.speed || 0,
          latitude: item.latitude || '',
          longitude: item.longitude || '',
          driver_name: item.driver_name || '',
          fleet_group_name: item.fleet_group_name || '',
          vehicle_model: item.vehicle_model || '',
          imei: item.imei || '',
          'Sim Card Number': item.simcard_number || item.sim_card_number || '',
        }))

        json2excel({
          data: exportData,
          name: reportTitle,
          formateDate: 'yyyy-mm-dd hh:ss',
        })

        this.$toast.success(`Data ${reportTitle} berhasil diunduh`)
      } catch (error) {
        const message =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error_msg) ||
          (error && error.message) ||
          'Gagal mengunduh data'
        this.$toast.error(message)
      } finally {
        this.downloadLoading = false
      }
    },
    async fetchAllVehiclesForActivity(type) {
      const activityMap = {
        idle: REPO.getDashboardIdleVehicle,
        stop: REPO.getDashboardStopVehicle,
        moving: REPO.getDashboardMovingVehicle,
      }

      const fetcher = activityMap[type]
      if (!fetcher) {
        return []
      }

      const fleetId = this.fleet_group_id || this.$dataLocal.UserData().id
      let page = 1
      let hasMore = true
      const results = []

      while (hasMore) {
        try {
          const response = await fetcher(fleetId, { page })
          if (response.data.status == 'true') {
            const payload = response.data.data || {}
            const normalized = this.normalizeLicensePlateForList(
              payload.data || []
            )
            results.push(...normalized)

            const lastPage = payload.last_page || 1
            hasMore = page < lastPage
            page += 1
          } else {
            hasMore = false
          }
        } catch (error) {
          console.error(`Error fetching ${type} vehicles for download:`, error)
          hasMore = false
        }
      }

      return results
    },
    async removeFromRepair(vehicle) {
      const vehicleId =
        (vehicle && vehicle._id) || (vehicle && vehicle.vehicle_id)

      if (!vehicleId) {
        this.$toast.error('ID kendaraan tidak ditemukan')
        return
      }

      this.removingRepairId = vehicleId
      const body = { vehicle_id: [vehicleId] }
      const isManual = this.isManualVehicle(vehicle)
      const query = {
        vehicle_activity: 'outrepair',
      }

      if (isManual) {
        query.bypass_validation = 'true'
      }

      try {
        const response = await REPO.addToRepairVehicle(body, query)

        // Check if the vehicle was actually removed (validation passed)
        const validations =
          (response.data &&
            response.data.data &&
            response.data.data.fleetify_validations) ||
          []
        const thisVehicleValidation = validations.find(
          (v) => v.vehicle_id === vehicleId
        )

        if (thisVehicleValidation && !thisVehicleValidation.can_exit_repair) {
          // Validation failed - vehicle cannot exit repair
          this.$toast.error(
            'Cannot remove from repair: ' +
              (thisVehicleValidation.reason ||
                'Vehicle still in repair according to Fleetify')
          )
          return
        }

        // Validation passed - remove from UI
        // Remove from sidebar locations
        this.sidebar_locations = this.sidebar_locations.filter((item) => {
          const id = (item && item._id) || (item && item.vehicle_id)
          return id !== vehicleId
        })

        // Remove from repair vehicles data to prevent stale data
        this.headerList[6].d_in_repair_vehicle =
          this.headerList[6].d_in_repair_vehicle.filter((item) => {
            const id = (item && item._id) || (item && item.vehicle_id)
            return id !== vehicleId
          })

        this.$vs.notify({
          title: 'Success',
          text: 'Vehicle removed from repair',
          color: 'success',
          position: 'bottom-right',
        })

        this.getDataCron()
        this.v_act_filter = []

        if (this.selected_filter !== 'all') {
          this.selected_filter = 'all'
        } else if (this.map) {
          this.getMarker(this.map)
        } else {
          this.getData()
        }
      } catch (error) {
        const message =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error_msg) ||
          (error && error.message) ||
          'Failed to remove vehicle'
        this.$toast.error(message)
      } finally {
        this.removingRepairId = null
      }
    },
    addToRepairFromSilence(vehicle) {
      const vehicleId = this.getVehicleId(vehicle)

      if (!vehicleId) {
        this.$toast.error('ID kendaraan tidak ditemukan')
        return
      }

      this.addingRepairId = null
      this.manualRepairModal.vehicle = vehicle
      this.manualRepairModal.reason = ''
      this.manualRepairModal.file = null
      this.manualRepairModal.fileName = ''
      this.manualRepairModal.error = ''
      this.manualRepairModal.submitting = false
      this.manualRepairModal.show = true

      if (this.$refs.manualEvidenceInput) {
        this.$refs.manualEvidenceInput.value = ''
      }
    },
    triggerManualEvidenceBrowse() {
      if (this.manualRepairModal.submitting) {
        return
      }
      if (this.$refs.manualEvidenceInput) {
        this.$refs.manualEvidenceInput.click()
      }
    },
    handleManualRepairFile(event) {
      const files = (event && event.target && event.target.files) || []

      if (!files.length) {
        this.manualRepairModal.file = null
        this.manualRepairModal.fileName = ''
        return
      }

      const file = files[0]
      const maxSize = 5 * 1024 * 1024

      if (file.size > maxSize) {
        this.manualRepairModal.error = 'Ukuran file melebihi batas 5 MB'
        this.manualRepairModal.file = null
        this.manualRepairModal.fileName = ''

        if (this.$refs.manualEvidenceInput) {
          this.$refs.manualEvidenceInput.value = ''
        }
        return
      }

      this.manualRepairModal.file = file
      this.manualRepairModal.fileName = file.name
      this.manualRepairModal.error = ''
    },
    closeManualRepairModal() {
      this.manualRepairModal.show = false
      this.resetManualRepairModal()
    },
    resetManualRepairModal() {
      this.manualRepairModal.vehicle = null
      this.manualRepairModal.reason = ''
      this.manualRepairModal.file = null
      this.manualRepairModal.fileName = ''
      this.manualRepairModal.error = ''
      this.manualRepairModal.submitting = false

      if (this.$refs.manualEvidenceInput) {
        this.$refs.manualEvidenceInput.value = ''
      }
    },
    async openManualDetailModal(vehicle) {
      this.manualDetailModal.show = true
      this.manualDetailModal.vehicle = vehicle
      this.manualDetailModal.loading = true
      this.manualDetailModal.completeData = null

      // Ambil license plate
      const licensePlate = this.getVehicleLicensePlate(vehicle)

      if (!licensePlate) {
        console.error('License plate not found')
        this.manualDetailModal.completeData = vehicle
        this.manualDetailModal.loading = false
        return
      }

      try {
        console.log('=== FETCHING REPAIR VEHICLE DATA ===')
        console.log('License plate:', licensePlate)
        console.log('Fleet group ID:', this.fleet_group_id)

        // Fetch data lengkap dari endpoint repair vehicle by license plate
        const response = await REPO.getRepairVehicleByLicensePlate(
          this.fleet_group_id,
          licensePlate
        )

        console.log('=== REPAIR VEHICLE API RESPONSE ===')
        console.log('Full response:', response.data)

        if (
          response.data &&
          response.data.status == 'true' &&
          response.data.data
        ) {
          const repairData = response.data.data
          console.log('Repair data object:', repairData)
          console.log('Data array:', repairData.data)

          if (repairData.data && repairData.data.length > 0) {
            // Data ditemukan dari endpoint repair vehicle
            const fetchedData = repairData.data[0]
            this.manualDetailModal.completeData = fetchedData
            console.log('=== COMPLETE DATA FETCHED ===')
            console.log('Fetched vehicle data:', fetchedData)
            console.log('manual_reason:', fetchedData.manual_reason)
            console.log('manualReason:', fetchedData.manualReason)
            console.log('reason:', fetchedData.reason)
            console.log(
              'manual_attachment_url:',
              fetchedData.manual_attachment_url
            )
            console.log('manualAttachmentUrl:', fetchedData.manualAttachmentUrl)
          } else {
            console.log(
              'No data in repair vehicle response, using vehicle object'
            )
            this.manualDetailModal.completeData = vehicle
          }
        } else {
          console.log(
            'API response status not true or no data, using vehicle object'
          )
          this.manualDetailModal.completeData = vehicle
        }
      } catch (error) {
        console.error('=== ERROR FETCHING REPAIR VEHICLE DATA ===')
        console.error('Error:', error)
        console.error('Error response:', error.response)
        // Fallback ke data yang ada
        this.manualDetailModal.completeData = vehicle
      } finally {
        this.manualDetailModal.loading = false
      }
    },
    closeManualDetailModal() {
      this.manualDetailModal.show = false
      this.manualDetailModal.vehicle = null
      this.manualDetailModal.loading = false
      this.manualDetailModal.completeData = null
    },
    getManualReason(vehicle) {
      if (!vehicle) return 'Manual transfer'

      // Prioritas: gunakan completeData jika ada
      const dataToUse = this.manualDetailModal.completeData || vehicle

      return (
        dataToUse.manual_reason ||
        dataToUse.manualReason ||
        dataToUse.reason ||
        'Manual transfer'
      )
    },
    viewManualEvidenceFromModal() {
      // Gunakan completeData yang sudah di-fetch saat modal dibuka
      const dataToUse =
        this.manualDetailModal.completeData || this.manualDetailModal.vehicle

      if (dataToUse) {
        this.viewManualEvidenceFromList(dataToUse)
      }
    },
    async submitManualRepair() {
      if (this.manualRepairModal.submitting) {
        return
      }

      const vehicle = this.manualRepairModal.vehicle
      const vehicleId = this.getVehicleId(vehicle)

      if (!vehicleId) {
        this.manualRepairModal.error = 'ID kendaraan tidak ditemukan'
        return
      }

      const reason = (this.manualRepairModal.reason || '').trim()
      if (!reason) {
        this.manualRepairModal.error = 'Alasan wajib diisi'
        return
      }

      const file = this.manualRepairModal.file
      const maxSize = 5 * 1024 * 1024

      if (!file) {
        this.manualRepairModal.error = 'Bukti wajib diunggah'
        return
      }

      if (file.size > maxSize) {
        this.manualRepairModal.error = 'Ukuran file melebihi batas 5 MB'
        return
      }

      this.manualRepairModal.submitting = true
      this.manualRepairModal.error = ''
      this.addingRepairId = vehicleId

      try {
        const uploadResponse = await this.uploadManualRepairEvidence(
          file,
          vehicleId
        )
        const fileUrl =
          (uploadResponse &&
            uploadResponse.data &&
            uploadResponse.data.data &&
            uploadResponse.data.data.url) ||
          null

        if (!fileUrl) {
          throw new Error('Gagal mengunggah bukti manual')
        }

        const body = {
          vehicle_id: [vehicleId],
          is_manual: true,
          manual_reason: reason,
          manual_attachment_url: fileUrl,
        }
        const query = { vehicle_activity: 'repair' }

        await REPO.addToRepairVehicle(body, query)

        this.sidebar_locations = this.sidebar_locations.filter((item) => {
          const id = this.getVehicleId(item)
          return id !== vehicleId
        })
        this.locations = this.locations.filter((item) => {
          const id = this.getVehicleId(item)
          return id !== vehicleId
        })

        this.$vs.notify({
          title: 'Success',
          text: 'Vehicle added to repair',
          color: 'success',
          position: 'bottom-right',
        })

        this.getDataCron()
        this.v_act_filter = []

        if (this.selected_filter !== 'all') {
          this.selected_filter = 'all'
        } else if (this.map) {
          this.getMarker(this.map)
        } else {
          this.getData()
        }

        this.closeManualRepairModal()
      } catch (error) {
        const message =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error_msg) ||
          (error && error.message) ||
          'Failed to add vehicle'
        this.manualRepairModal.error = message
        this.$toast.error(message)
      } finally {
        this.manualRepairModal.submitting = false
        this.addingRepairId = null
      }
    },
    async uploadManualRepairEvidence(file, vehicleId) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('dir', 'manual-repair-evidence')
      formData.append('maxBodyLength', Infinity)
      const uniqueId = `${vehicleId || 'manual'}-${Date.now()}`
      return REPO.uploadManualRepairEvidence(formData, uniqueId)
    },
    getVehicleId(vehicle) {
      if (!vehicle) return null
      if (vehicle._id) return vehicle._id
      if (vehicle.vehicle_id) return vehicle.vehicle_id
      if (vehicle.id) return vehicle.id
      return null
    },
    isManualVehicle(vehicle) {
      if (!vehicle) return false

      const hasManualMetadata = (source) => {
        if (!source) return false

        if (
          typeof source.is_manual !== 'undefined' &&
          this.isTruthyManualFlag(source.is_manual)
        ) {
          return true
        }

        if (
          typeof source.isManual !== 'undefined' &&
          this.isTruthyManualFlag(source.isManual)
        ) {
          return true
        }

        return Boolean(source.manual_reason || source.manual_attachment_url)
      }

      if (hasManualMetadata(vehicle)) {
        return true
      }

      const plate = this.getVehicleLicensePlate(vehicle)
      if (!plate) {
        return false
      }

      const manualRepairList =
        this.headerList &&
        this.headerList[6] &&
        Array.isArray(this.headerList[6].d_in_repair_vehicle)
          ? this.headerList[6].d_in_repair_vehicle
          : []

      if (!manualRepairList.length) {
        return false
      }

      const normalizedPlate = plate.toString().trim().toUpperCase()

      return manualRepairList.some((item) => {
        const itemPlate = this.getVehicleLicensePlate(item)
        if (!itemPlate) return false

        const normalizedItemPlate = itemPlate.toString().trim().toUpperCase()
        if (normalizedItemPlate !== normalizedPlate) {
          return false
        }

        return hasManualMetadata(item)
      })
    },
    isTruthyManualFlag(value) {
      if (typeof value === 'boolean') return value
      if (typeof value === 'number') return value === 1
      if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase()
        return (
          normalized === 'true' || normalized === '1' || normalized === 'yes'
        )
      }
      return false
    },
    onKeyDownLicense(e) {
      this.automateLicensePlate(e, e.target, this.strips)
    },
    sidebarScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.sidebar_count += 10
        this.scheduleSyncMapMarkerIconsWithSidebar()

        // Load more repair vehicles if repair filter is active
        if (
          this.isRepairFilterActive &&
          this.repairHasMore &&
          !this.isLoadingRepair
        ) {
          this.loadMoreRepairVehicles()
        }

        // Load more operation vehicles if operation filter is active
        if (
          this.isOperationFilterActive &&
          this.operationHasMore &&
          !this.isLoadingOperation
        ) {
          console.log('Triggering loadMoreOperationVehicles from scroll')
          this.loadMoreOperationVehicles()
        }

        if (
          this.isIdleFilterActive &&
          this.idleHasMore &&
          !this.isLoadingIdle
        ) {
          this.loadMoreIdleVehicles()
        }

        if (
          this.isStopFilterActive &&
          this.stopHasMore &&
          !this.isLoadingStop
        ) {
          this.loadMoreStopVehicles()
        }
      }
    },
    // Helper method: Get selected license plates
    getSelectedLicensePlates() {
      if (this.selected_filter !== 'license_plate' || !this.plate.length) {
        return null
      }
      
      return this.plate.map((p) => {
        if (p && typeof p === 'object') {
          if (p.text) return p.text.toUpperCase()
          if (p.value) return p.value.toUpperCase()
        }
        if (typeof p === 'string') return p.toUpperCase()
        return ''
      }).filter(Boolean)
    },
    
    // Helper method: Filter vehicles by selected license plates
    filterByLicensePlate(vehicles) {
      const selectedPlates = this.getSelectedLicensePlates()
      if (!selectedPlates) return vehicles
      
      return vehicles.filter((vehicle) => {
        const plate = this.getVehicleLicensePlate(vehicle)
        return selectedPlates.includes(plate ? plate.toUpperCase() : '')
      })
    },
    
    async loadMoreRepairVehicles() {
      if (this.isLoadingRepair || !this.repairHasMore) return

      this.isLoadingRepair = true
      this.repairCurrentPage += 1

      try {
        const val = this.fleet_group_id
        const response = await REPO.getDashboardRepairVehicle(val, {
          page: this.repairCurrentPage,
        })

        if (response.data.status == 'true') {
          const newRepairVehicles = this.normalizeLicensePlateForList(
            response.data.data.data || []
          )


          // Append new repair vehicles to existing ones
          this.headerList[6].d_in_repair_vehicle = [
            ...(this.headerList[6].d_in_repair_vehicle || []),
            ...newRepairVehicles,
          ]

          // Check if we have reached the last page
          const lastPage = response.data.data.last_page || 1
          if (this.repairCurrentPage >= lastPage) {
            this.repairHasMore = false
          } else if (newRepairVehicles.length === 0) {
            this.repairHasMore = false
          }

          // Update the filtered locations if repair filter is active
          if (this.isRepairFilterActive) {
            this.updateSidebarLocationsForRepair()
          }
        } else {
          this.repairHasMore = false
        }
      } catch (error) {
        console.error('Error loading more repair vehicles:', error)
        this.repairHasMore = false
      } finally {
        this.isLoadingRepair = false
      }
    },
    async loadMoreIdleVehicles() {
      if (this.isLoadingIdle || !this.idleHasMore) return

      this.isLoadingIdle = true
      this.idleCurrentPage += 1

      try {
        const val = this.fleet_group_id
        const response = await REPO.getDashboardIdleVehicle(val, {
          page: this.idleCurrentPage,
        })

        if (response.data.status == 'true') {
          const newIdleVehicles = this.normalizeLicensePlateForList(
            response.data.data.data || []
          )

          if (this.idleCurrentPage >= response.data.data.last_page) {
            this.idleHasMore = false
          }

          this.headerList[3].d_idle_vehicle = [
            ...(this.headerList[3].d_idle_vehicle || []),
            ...newIdleVehicles,
          ]

          if (this.isIdleFilterActive) {
            this.updateSidebarLocationsForIdle()
          }
        } else {
          this.idleHasMore = false
        }
      } catch (error) {
        console.error('Error loading more idle vehicles:', error)
        this.idleHasMore = false
      } finally {
        this.isLoadingIdle = false
      }
    },
    async loadMoreStopVehicles() {
      if (this.isLoadingStop || !this.stopHasMore) return

      this.isLoadingStop = true
      this.stopCurrentPage += 1

      try {
        const val = this.fleet_group_id
        const response = await REPO.getDashboardStopVehicle(val, {
          page: this.stopCurrentPage,
        })

        if (response.data.status == 'true') {
          const newStopVehicles = this.normalizeLicensePlateForList(
            response.data.data.data || []
          )

          if (this.stopCurrentPage >= response.data.data.last_page) {
            this.stopHasMore = false
          }

          this.headerList[4].d_stop_vehicle = [
            ...(this.headerList[4].d_stop_vehicle || []),
            ...newStopVehicles,
          ]

          if (this.isStopFilterActive) {
            this.updateSidebarLocationsForStop()
          }
        } else {
          this.stopHasMore = false
        }
      } catch (error) {
        console.error('Error loading more stop vehicles:', error)
        this.stopHasMore = false
      } finally {
        this.isLoadingStop = false
      }
    },
    async loadMoreOperationVehicles() {
      if (this.isLoadingOperation || !this.operationHasMore) return

      console.log(
        'Loading more operation vehicles, page:',
        this.operationCurrentPage + 1
      )
      this.isLoadingOperation = true
      this.operationCurrentPage += 1

      try {
        const val = this.fleet_group_id
        const response = await REPO.getDashboardGeofenceViolation(val, {
          page: this.operationCurrentPage,
        })

        if (response.data.status == 'true') {
          const newOperationVehicles = this.normalizeLicensePlateForList(
            response.data.data.data || []
          )

          // Check if we have more pages
          if (this.operationCurrentPage >= response.data.data.last_page) {
            this.operationHasMore = false
          }

          // Append new operation vehicles to existing ones
          this.headerList[1].d_geofence_violation = [
            ...(this.headerList[1].d_geofence_violation || []),
            ...newOperationVehicles,
          ]

          // Update the filtered locations if operation filter is active
          if (this.isOperationFilterActive) {
            this.updateSidebarLocationsForOperation()
          }
        } else {
          this.operationHasMore = false
        }
      } catch (error) {
        console.error('Error loading more operation vehicles:', error)
        this.operationHasMore = false
      } finally {
        this.isLoadingOperation = false
      }
    },
    updateSidebarLocationsForOperation() {
      let operationFiltered = this.locations.filter((x) =>
        this.isInOperationVehicle(x)
      )

      if (!operationFiltered.length) {
        const operationVehicles = this.headerList[1].d_geofence_violation || []
        const operationPlates = new Set(
          operationVehicles
            .map((vehicle) => this.getVehicleLicensePlate(vehicle))
            .filter(Boolean)
        )
        if (operationPlates.size) {
          operationFiltered = this.locations.filter((x) =>
            operationPlates.has(this.getVehicleLicensePlate(x))
          )
        }
        if (!operationFiltered.length) {
          operationFiltered = operationVehicles
        }
      }

      this.sidebar_locations =
        this.normalizeLicensePlateForList(operationFiltered)
    },
    updateSidebarLocationsForIdle() {
      const idleVehicles = this.headerList[3].d_idle_vehicle || []
      const normalized = this.normalizeLicensePlateForList(idleVehicles)
      this.sidebar_locations = normalized
      this.sidebar_count = normalized.length
    },
    updateSidebarLocationsForStop() {
      const stopVehicles = this.headerList[4].d_stop_vehicle || []
      const normalized = this.normalizeLicensePlateForList(stopVehicles)
      this.sidebar_locations = normalized
      this.sidebar_count = normalized.length
    },
    updateSidebarLocationsForRepair() {
      // Use d_in_repair_vehicle directly as the source
      // It's updated via loadMoreRepairVehicles, so it contains all paginated data
      const repairVehicles = this.headerList[6].d_in_repair_vehicle || []
      
      // Normalize and use directly
      this.sidebar_locations = this.normalizeLicensePlateForList(repairVehicles)
      this.sidebar_count = this.sidebar_locations.length

      if (process.env.NODE_ENV !== 'production') {
        console.log('[Repair Sidebar] first item', this.sidebar_locations[0])
      }
    },
    gotoVehicle(i) {
      const center = {
        lat: i.latitude,
        lng: i.longitude,
      }
      if (this.getRolePermission().dashboard.maps.google_maps) {
        this.$refs.mapRef.panTo(center)
        this.map.setZoom(15)
      } else if (this.getRolePermission().dashboard.maps.openstreet_maps) {
        this.map.flyTo([i.latitude, i.longitude], 20)
      }
      // this.$refs.mapRef.panTo(center)
      // this.map.setZoom(15)
    },
    getManualAttachmentUrl(vehicle) {
      if (!vehicle) return ''

      const directUrl =
        vehicle.manual_attachment_url || vehicle.manualAttachmentUrl
      if (directUrl) {
        return directUrl
      }

      const fallback = vehicle.manual_attachment || vehicle.manualAttachment
      if (!fallback) {
        return ''
      }

      // Some payloads may provide the path without protocol; reuse repository helper to build URL if needed
      if (typeof fallback === 'string' && fallback.startsWith('http')) {
        return fallback
      }

      const normalizedBase = (this.baseUrl || '')
        .replace(/\\+/g, '/')
        .replace(/\/+$/, '')
      const normalizedPath = fallback
        .toString()
        .replace(/\\+/g, '/')
        .replace(/^\/+/, '')
      return `${normalizedBase}/${normalizedPath}`
    },
    openManualEvidence(url) {
      if (!url) return
      window.open(url, '_blank', 'noopener')
    },
    viewManualEvidenceFromList(vehicle) {
      if (!vehicle) {
        this.$toast.error('Data kendaraan tidak tersedia')
        return
      }

      console.log('=== VIEW MANUAL EVIDENCE ===')
      console.log('Vehicle object:', vehicle)

      // Coba ambil URL dari berbagai field yang mungkin
      const attachmentUrl =
        vehicle.manual_attachment_url ||
        vehicle.manualAttachmentUrl ||
        vehicle.manual_attachment ||
        vehicle.manualAttachment

      console.log('manual_attachment_url:', vehicle.manual_attachment_url)
      console.log('manualAttachmentUrl:', vehicle.manualAttachmentUrl)
      console.log('manual_attachment:', vehicle.manual_attachment)
      console.log('manualAttachment:', vehicle.manualAttachment)
      console.log('Final URL to open:', attachmentUrl)

      if (attachmentUrl) {
        window.open(attachmentUrl, '_blank', 'noopener')
      } else {
        this.$toast.error('Bukti tidak tersedia atau belum terupload')
      }
    },
    delay(fn, ms) {
      //
      let timer = 0
      return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(fn.bind(this, ...args), ms || 0)
      }
    },
    hilangSemuaPOI() {
      // this.clearAllMarkers()
      if (this.getRolePermission().dashboard.maps.google_maps) {
        this.hilangSemuaPOIGoogle()
      } else if (this.getRolePermission().dashboard.maps.openstreet_maps) {
        this.hilangSemuaPOILeaflet()
      }

      this.categoryPOI.forEach((z) => {
        z.active_poi = false
      })
    },
    clearAllMarkers() {
      // Clear existing POI markers
      if (this.markerPOI.length > 0) {
        this.markerPOI.forEach((marker) => {
          //
          if (this.getRolePermission().dashboard.maps.google_maps) {
            marker.setMap(null)
          } else {
            marker.remove()
          }
        })
        this.markerPOI = []
      }

      // Clear existing geofences
      if (this.geofencePOI.length > 0) {
        this.geofencePOI.forEach((fence) => {
          if (this.getRolePermission().dashboard.maps.google_maps) {
            fence.setMap(null)
          } else {
            fence.remove()
          }
        })
        this.geofencePOI = []
      }
    },
    hilangSemuaPOIGoogle() {
      let aktif = this.categoryPOI.filter((z) => {
        return z.active_poi == true
      })
      this.geofencePOI.map((x) => {
        x.setMap(null)
      })
      this.markerPOI.map((x) => {
        x.setMap(null)
      })

      if (aktif.length == 0) {
      } else {
        this.$vs.loading({
          container: '#data-list-list-view',
          scale: 1,
        })
        // aktif.forEach((z) => {
        //   let ada = this.dataPOI
        //   if (this.markerPOI.length > 0) {
        //     if (this.markerPOI.length > 0) {
        //       this.markerPOI.forEach((x) => {
        //         x.setMap(null)
        //       })
        //     }
        //   }
        // })
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      }
    },
    hilangSemuaPOILeaflet() {
      let aktif = this.categoryPOI.filter((z) => {
        return z.active_poi == true
      })
      if (aktif.length == 0) {
        // this.map.setOptions({
        //   styles: [
        //     {
        //       featureType: 'poi',
        //       elementType: 'labels',
        //       stylers: [{ visibility: 'on' }],
        //     },
        //   ],
        // })
      } else {
        this.$vs.loading({
          container: '#data-list-list-view',
          scale: 1,
        })
        // this.map.setOptions({
        //   styles: [
        //     {
        //       featureType: 'poi',
        //       elementType: 'labels',
        //       stylers: [{ visibility: 'on' }],
        //     },
        //   ],
        // })
        // aktif.forEach((z) => {
        //   let ada = this.dataPOI
        //   if (this.markerPOI.length > 0) {
        //     if (this.markerPOI.length > 0) {
        //       this.markerPOI.forEach((x) => {
        //         x.remove()
        //       })
        //     }
        //   }
        // })
        this.markerPOI.forEach((x) => {
          x.remove()
        })
        this.geofencePOI.forEach((x) => {
          x.remove()
        })
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      }
    },
    tampilSemuaPOI() {
      let aktif = this.categoryPOI.filter((z) => {
        return z.active_poi == true
      })
      if (aktif.length == 0) {
        this.map.setOptions({
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'on' }],
            },
          ],
        })
      } else {
        this.$vs.loading({
          container: '#data-list-list-view',
          scale: 1,
        })
        this.map.setOptions({
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
          ],
        })
        aktif.forEach((z) => {
          let ada = this.dataPOI
          // let ada = this.dataPOI.filter(x=>{
          //     return x.id == z.id;
          // });

          this.tampilPOI(ada[0].data, this.baseUrl + z.marker, z.id)
        })
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      }
    },
    getNothing() {
      //
    },
    getCategoryPOI() {
      REPO.getListCategoryPOI()
        .then((res) => {
          this.categoryPOI = res.data.data
          this.categoryPOI.forEach((z) => {
            z.active_poi = false
            z.tampil = true
          })
        })
        .catch((err) => {
          //
        })
    },
    getPOI(code, marker) {
      this.$vs.loading({
        container: '#data-list-list-view',
        scale: 1,
      })

      if (this.getRolePermission().dashboard.maps.google_maps) {
        this.getPOIGoogle(code, marker)
      } else if (this.getRolePermission().dashboard.maps.openstreet_maps) {
        this.getPOILeaflet(code, marker)
      }
    },
    getPOIGoogle(code, marker) {
      let ada = this.dataPOI
      // let ada = this.dataPOI.filter(z=>{
      //     return z.id == code;
      // });
      let cat = this.categoryPOI.filter((z) => {
        return z.id == code
      })

      if (cat[0].active_poi) {
        this.hilangSemuaPOI()
        this.selectedPOICategory = null
        cat[0].active_poi = false
        if (this.markerPOI.length > 0) {
          if (this.markerPOI.length > 0) {
            this.markerPOI.forEach((x) => {
              x.setMap(null)
            })
          }
          this.markerPOI = []
        }

        let aktif = this.categoryPOI.filter((z) => {
          return z.active_poi == true
        })
        if (aktif.length == 0) {
          this.map.setOptions({
            styles: [
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{ visibility: 'on' }],
              },
            ],
          })
        }
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      } else {
        this.selectedPOICategory = {
          id: code,
          marker: marker,
        }
        this.categoryPOI.forEach((z) => {
          z.active_poi = false
        })
        if (this.markerPOI.length > 0) {
          if (this.markerPOI.length > 0) {
            this.markerPOI.forEach((x) => {
              x.setMap(null)
            })
          }
          this.markerPOI = []
        }

        cat[0].active_poi = true
        this.map.setOptions({
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
          ],
        })
        if (this.markerPOI.length > 0) {
          // setTimeout(()=>{
          //
          //     this.$vs.loading.close('#data-list-list-view > .con-vs-loading');
          // },200)
          // this.tampilPOI(ada[0].data, marker, code);
          REPO.getPOIParam({
            coordinates: this.data_coordinate,
            category_poi_id: code,
            type: 'ALL',
          })
            .then((res) => {
              let tmp = {
                id: code,
                status: true,
                poi: [],
                data: res.data.data,
              }
              this.dataPOI = []
              this.dataPOI.push(tmp)
              this.tampilPOI(tmp.data, marker, code)
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
            .catch((err) => {
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
        } else {
          let tmp = JSON.parse(JSON.stringify(this.data_coordinate))
          //
          REPO.getPOIParam({
            coordinates: tmp,
            category_poi_id: code,
            type: 'ALL',
          })
            .then((res) => {
              let tmp = {
                id: code,
                status: true,
                poi: [],
                data: res.data.data,
              }
              this.dataPOI = []
              this.dataPOI.push(tmp)
              this.tampilPOI(tmp.data, marker, code)
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
            .catch((err) => {
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
        }
      }
      this.categoryPOI.push({
        tampil: false,
      })
    },
    getPOILeaflet(code, marker) {
      const self = this
      let ada = this.dataPOI
      // let ada = this.dataPOI.filter(z=>{
      //     return z.id == code;
      // });
      let cat = this.categoryPOI.filter((z) => {
        return z.id == code
      })

      if (cat[0].active_poi) {
        this.hilangSemuaPOI()
        this.selectedPOICategory = null
        cat[0].active_poi = false
        if (this.markerPOI.length > 0) {
          if (this.markerPOI.length > 0) {
            this.markerPOI.forEach((x) => {
              x.remove()
            })
          }
          this.markerPOI = []
        }

        let aktif = this.categoryPOI.filter((z) => {
          return z.active_poi == true
        })
        // if (aktif.length == 0) {
        //   this.map.setOptions({
        //     styles: [
        //       {
        //         featureType: 'poi',
        //         elementType: 'labels',
        //         stylers: [{ visibility: 'on' }],
        //       },
        //     ],
        //   })
        // }
        setTimeout(() => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        }, 200)
      } else {
        this.selectedPOICategory = {
          id: code,
          marker: marker,
        }
        this.categoryPOI.forEach((z) => {
          z.active_poi = false
        })
        if (this.markerPOI.length > 0) {
          if (this.markerPOI.length > 0) {
            this.markerPOI.forEach((x) => {
              x.remove()
            })
          }
          this.markerPOI = []
        }

        cat[0].active_poi = true
        // this.map.setOptions({
        //   styles: [
        //     {
        //       featureType: 'poi',
        //       elementType: 'labels',
        //       stylers: [{ visibility: 'off' }],
        //     },
        //   ],
        // })
        if (this.markerPOI.length > 0) {
          // setTimeout(()=>{
          //
          //     this.$vs.loading.close('#data-list-list-view > .con-vs-loading');
          // },200)
          // this.tampilPOI(ada[0].data, marker, code);
          REPO.getPOIParam({
            coordinates: this.data_coordinate,
            category_poi_id: code,
            type: 'ALL',
          })
            .then((res) => {
              let tmp = {
                id: code,
                status: true,
                poi: [],
                data: res.data.data,
              }
              this.dataPOI = []
              this.dataPOI.push(tmp)
              this.tampilPOI(tmp.data, marker, code)
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
            .catch((err) => {
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
        } else {
          let tmp = JSON.parse(JSON.stringify(this.data_coordinate))
          //
          REPO.getPOIParam({
            coordinates: tmp,
            category_poi_id: code,
            type: 'ALL',
          })
            .then((res) => {
              let tmp = {
                id: code,
                status: true,
                poi: [],
                data: res.data.data,
              }
              this.dataPOI = []
              this.dataPOI.push(tmp)
              this.tampilPOI(tmp.data, marker, code)
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
            .catch((err) => {
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
        }
      }
    },
    tampilPOI(data, marker, code) {
      var self = this
      let ada = this.dataPOI

      // this.clearAllMarkers()

      if (this.getRolePermission().dashboard.maps.google_maps) {
        //

        this.markerPOI.forEach((x) => {
          x.setMap(null)
        })
        this.geofencePOI.map((x) => {
          x.setMap(null)
        })
        // this.markerPOI = []

        data.forEach(function (location, i) {
          //
          if (location.coordinate.coordinates.length > 0) {
            let loc = {
              lat: location.coordinate.coordinates[1],
              lng: location.coordinate.coordinates[0],
            }

            let pilih_marker = marker
            let icon = {
              url: pilih_marker + '#1',
              anchor: new google.maps.Point(12, 24),
              scaledSize: new google.maps.Size(24, 24),
              labelOrigin: new google.maps.Point(9, -5),
              fillColor: '#00CCBB',
              fillOpacity: 1,
              strokeColor: '',
              strokeWeight: 0,
            }
            //
            const mark = new google.maps.Marker({
              position: loc,
              // label:{
              //     color: 'blue', // <= HERE
              //     fontSize: '10px',
              //     fontWeight: '900',
              //     text: location.name
              // },
              map: self.map,
              icon: icon,
            })
            let color = '#FF0000'
            const geo = new google.maps.Circle({
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.15,
              center: loc,
              map: self.map,
              radius: location.radius ? location.radius : 20,
            })
            self.geofencePOI.push(geo)
            // google.maps.event.addListener(mark, 'click', () => {
            //   self.center = loc

            //   //
            //   // self.$vs.loading();
            //   self.selectedPOI = location
            //   self.infoBoxPOI = false
            //   setTimeout(() => {
            //     self.infoBoxPOI = true
            //   }, 100)
            // })

            self.markerPOI.push(mark)
          }
        })
      } else if (this.getRolePermission().dashboard.maps.openstreet_maps) {
        this.markerPOI.forEach((x) => {
          x.remove()
        })
        this.geofencePOI.map((x) => {
          x.remove()
        })
        this.markerPOI = []
        data.forEach(function (location, i) {
          if (location.coordinate.coordinates.length > 0) {
            let loc = {
              lat: location.coordinate.coordinates[1],
              lng: location.coordinate.coordinates[0],
            }
            let pilih_marker = marker
            let icon = L.icon({
              iconUrl: pilih_marker,
              iconSize: [24, 24],
              iconAnchor: [12, 24],
              popupAnchor: [0, -24],
            })
            let mark = L.marker(loc, { icon: icon }).addTo(self.map)
            let color = '#FF0000'
            const geo = L.circle(loc, {
              color: color,
              fillColor: color,
              fillOpacity: 0.15,
              radius: location.radius ? location.radius : 20,
            }).addTo(self.map)
            self.geofencePOI.push(geo)
            mark.on('click', () => {
              self.center = loc
              self.selectedPOI = location
              self.infoBoxPOI = false
              setTimeout(() => {
                self.infoBoxPOI = true
              }, 100)
            })
            self.markerPOI.push(mark)
          }
        })
      }
    },
    loadingStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    closeModal() {
      //
      this.openModal = false
      this.openModalLiveShare = false
    },
    rekursive(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = x.fleet_group_name
        let tmp = {
          counter: counter,
          text: text,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    stopCron() {
      if (this.crontab !== null) this.crontab.stop()
      // this.$crontab.stopCrontab({name: "counter"});
    },
    getDataCron() {
      let val = this.fleet_group_id
      this.silenceCountFromAPI = null
      REPO.getDashboardTotalVehicle(val, { page: 1 })
        .then((res) => {
          if (res.data.status == 'true') {
            this.loadingStop('total-card')

            // this.total_vehicle_num = res.data.data
            this.headerList[0].total_vehicle = res.data.data
            this.headerList[0].d_total_vehicle =
              this.normalizeLicensePlateForList(res.data.data.data)
            //
          } else {
            if (res.data.error_msg != 'JWT Token Expired')
              this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
      REPO.getDashboardGeofenceViolation(val, { page: 1 })
        .then((res) => {
          if (res.data.status == 'true') {
            this.loadingStop('uio-card')
            // this.total_geofence_violation = res.data.data
            this.headerList[1].total_vehicle = res.data.data
            this.headerList[1].d_geofence_violation =
              this.normalizeLicensePlateForList(res.data.data.data)

            // Reset operation pagination state
            this.operationCurrentPage = 1
            this.operationHasMore = res.data.data.last_page > 1
          } else {
            if (res.data.error_msg != 'JWT Token Expired')
              this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
      REPO.getDashboardMovingVehicle(val, { page: 1 })
        .then((res) => {
          if (res.data.status == 'true') {
            this.loadingStop('moving-card')

            // this.total_moving_vehicle = res.data.data
            this.headerList[2].total_vehicle = res.data.data
            this.headerList[2].d_moving_vehicle =
              this.normalizeLicensePlateForList(res.data.data.data)
          } else {
            if (res.data.error_msg != 'JWT Token Expired')
              this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
      REPO.getDashboardIdleVehicle(val, { page: 1 })
        .then((res) => {
          if (res.data.status == 'true') {
            this.loadingStop('idle-card')
            this.headerList[3].total_vehicle = res.data.data
            this.headerList[3].d_idle_vehicle =
              this.normalizeLicensePlateForList(res.data.data.data)
            this.idleCurrentPage = 1
            this.idleHasMore = res.data.data.last_page > 1
          } else {
            if (res.data.error_msg != 'JWT Token Expired')
              this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          // (err);
          this.$toast.error(err.message)
        })
      REPO.getDashboardStopVehicle(val, { page: 1 })
        .then((res) => {
          if (res.data.status == 'true') {
            this.loadingStop('stop-card')
            this.headerList[4].total_vehicle = res.data.data
            this.headerList[4].d_stop_vehicle =
              this.normalizeLicensePlateForList(res.data.data.data)
            this.stopCurrentPage = 1
            this.stopHasMore = res.data.data.last_page > 1
          } else {
            if (res.data.error_msg != 'JWT Token Expired')
              this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
      // Fetch SEMUA silence vehicles dari backend (tidak ada filter frontend)
      REPO.getDashboardSilentVehicle(val, { page: 1, per_page: 9999 })
        .then((res) => {
          //
          if (res.data.status == 'true') {
            this.loadingStop('silence-card')

            // Data langsung dari backend, no filter, no bucket
            this.headerList[5].total_vehicle = res.data.data
            const normalized = this.normalizeLicensePlateForList(
              res.data.data.data
            )

            this.headerList[5].d_silent_vehicle = normalized

            // Refresh silence count dari API untuk akurasi
            this.fetchSilenceCount()
          } else {
            if (res.data.error_msg != 'JWT Token Expired')
              this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
      REPO.getDashboardRepairVehicle(val, { page: 1 })
        .then((res) => {
          //
          if (res.data.status == 'true') {
            this.loadingStop('repair-card')
            this.headerList[6].total_vehicle = res.data.data
            this.headerList[6].d_in_repair_vehicle =
              this.normalizeLicensePlateForList(res.data.data.data)

            // Reset repair pagination state
            this.repairCurrentPage = 1
            this.repairHasMore = res.data.data.last_page > 1

            // RESET reapir property:
            this.repairCurrentPage = 1
            this.repairHasMore = res.data.data.last_page > 1  // ← pastikan diset
          } else {
            if (res.data.error_msg != 'JWT Token Expired')
              this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
    },
    playBack() {
      this.$router.push(
        '/playback-vehicle/' + this.selectedLocation.license_plate
      )
    },
    drawMarkerWithoutCluster() {
      var self = this
      this.markerLookup = {}
      if (this.all_marker.length > 0) {
        this.all_marker.forEach((x) => {
          x.setMap(null)
        })
      }
      this.all_marker = []

      this.locations.forEach(function (location, i) {
        //
        if ('latitude' in location) {
          let loc = { lat: location.latitude, lng: location.longitude }
          let pilih_marker = IdleMarker
          const registeredEvent = self.resolveMapDisplayActivity(location)
          location.vehicle_activity = registeredEvent
          let icon = {
            url: BlogIcon,
            anchor: new google.maps.Point(28, 20),
            scaledSize: new google.maps.Size(56, 20),
            labelOrigin: new google.maps.Point(28, 28),
            fillColor: '#00CCBB',
            fillOpacity: 1,
            strokeColor: '',
            strokeWeight: 0,
          }
          //
          let mark = new google.maps.Marker({
            position: loc,
            map: self.map,
            label: {
              text: location.license_plate ? location.license_plate : '',
              color: 'black',
              className: 'label-nopol',
              fontSize: '7px',
              backgroundColor: 'white',
              fontWeight: 'bold',
            },
            icon: icon,
          })
          self.registerMarkerForLocation(mark, location)
          // google.maps.event.addListener(mark, 'click', ()=> {
          //     self.infowindow.setContent("<div>" +
          //         "<span></span>" +
          //         "<hr>" +
          //         "<button class='btn btn-primary' @click='viewDetail2(tes cluster)'>View Detail</button>" +
          //         "</div>");
          //     self.infowindow.open(map, mark);
          // });
          google.maps.event.addListener(mark, 'click', () => {
            self.center = loc
            self.openVehicleInfo(location)
          })
          self.all_marker.push(mark)
        }
      })
      // this.all_marker = markers;
    },
    filterData() {
      this.$vs.loading({
        container: '#data-list-list-view',
        scale: 1,
      })
      if (
        this.getRolePermission().dashboard.maps.google_maps &&
        this.markerCluster &&
        typeof this.markerCluster.clearMarkers === 'function'
      ) {
        this.markerCluster.clearMarkers()
      }
      let param
      // (this.selected_filter);
      if (this.selected_filter == 'all') {
        if (this.isMarkerRendering) {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          return
        }
        this.getData()
        this.getMarker(this.map)
        return
      }
      if (this.selected_filter == 'fleet_group') {
        param = {
          fleet_group_id: this.fleet_group_id,
        }
      }
      if (this.selected_filter == 'vin') {
        param = {
          fleet_group_id: this.$dataLocal.UserData().id,
          vin: this.vin,
        }
      }
      if (this.selected_filter == 'imei') {
        param = {
          fleet_group_id: this.$dataLocal.UserData().id,
          imei_obd_number: this.imei,
        }
      }
      if (this.selected_filter == 'license_plate') {
        let tmp_ = []
        this.plate.forEach((p) => {
          tmp_.push(p.value)
        })
        param = {
          license_plate: tmp_,
        }
        REPO.postFilterLicense(param)
          .then((res) => {
            const normalizedLocations = this.normalizeLicensePlateForList(
              res.data.data || []
            )
            this.locations = normalizedLocations
            // sidebar_locations will be automatically updated by the locations watcher

            //
            if (this.locations.length > 0) {
              this.center = {
                lat: this.locations[0].latitude,
                lng: this.locations[0].longitude,
              }
            }

            const renderPromise = this.getRolePermission().dashboard.maps.google_maps
              ? this.initialize(this.map)
              : this.getRolePermission().dashboard.maps.openstreet_maps
                ? this.initializeOsMap(this.map)
                : Promise.resolve()

            Promise.resolve(renderPromise).finally(() => {
              this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            })
          })
          .catch((err) => {
            this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            let datas = err.response.data
            let err_msg = ''
            let counter = 0
            for (var key in datas) {
              if (datas.hasOwnProperty(key)) {
                //
                err_msg += ' -' + datas[key]
              }
              counter++
            }
            if (counter === 0) {
              err_msg = err.message
            }
            this.$toast.error(err_msg)
          })
        return
      }
      REPO.getFilterCluster(param)
        .then((res) => {
          let tmp = res.data.data
          let data = tmp.filter((location) => {
            return 'latitude' in location && location.latitude !== ''
          })
          this.locations = this.normalizeLicensePlateForList(data)
          //
          if (this.locations.length > 0) {
            this.center = {
              lat: this.locations[0].latitude,
              lng: this.locations[0].longitude,
            }
          }
          const renderPromise = this.getRolePermission().dashboard.maps.google_maps
            ? this.initialize(this.map)
            : this.getRolePermission().dashboard.maps.openstreet_maps
              ? this.initializeOsMap(this.map)
              : Promise.resolve()

          Promise.resolve(renderPromise).finally(() => {
            this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          })
        })
        .catch((err) => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$toast.error(err.message)
        })
      // } else {
      //   this.getData()
      //   this.getMarker(this.map)
      //   // if (this.selected_filter == 'all') {
      //   // }
      // }
    },
    getData() {
      const defaultFleetId = this.$dataLocal.UserData().id
      const shouldLoadInitialHeader = this.fleet_group_id !== defaultFleetId
      if (this.fleet_group_id !== defaultFleetId) {
        this.isApplyingDefaultFleet = true
        this.fleet_group_id = defaultFleetId
        this.$nextTick(() => {
          this.isApplyingDefaultFleet = false
        })
      }
      if (shouldLoadInitialHeader) {
        this.getDataCron()
      }
      this.fleet_array = [
        {
          text: 'All',
          value: defaultFleetId,
        },
      ]
      REPO.getListFleetChield(defaultFleetId).then((res) => {
        if (res.data.status == 'true') {
          let tmp = res.data.data.map((h) => {
            return {
              text: h.fleet_group_name,
              value: h.id,
            }
          })
          //
          // let hasil = []
          // this.rekursive(tmp, hasil, 0)
          //
          const combined = [...this.fleet_array, ...tmp]
          this.fleet_array = this.removeDuplicates(combined)
        }
      })
      REPO.getFilterClusterLicVin(defaultFleetId).then((res) => {
        if (res.data.status == 'true') {
          let arrays = res.data.data
          let license_plate = []
          let imei = []
          let vin = []
          //
          // license_plate.push({text:'- LICENSE PLATE -', value:""});
          arrays.forEach((x) => {
            let license_plate_f = license_plate.some(
              (g) => g.value == x.vehicle_id
            )
            if (!license_plate_f)
              license_plate.push({ text: x.license_plate, value: x.vehicle_id })

            let imei_f = imei.some((g) => g.value == x.imei)
            if (!imei_f) imei.push({ text: x.imei, value: x.imei })

            let vin_f = vin.some((g) => g.value == x.vehicle_number)
            if (!vin_f)
              vin.push({ text: x.vehicle_number, value: x.vehicle_number })
          })
          this.imei_array = imei

          this.vin_array = vin
          this.plate_array = [...license_plate]
        } else {
        }
      })
      REPO.getFilterParamMonitoring(defaultFleetId).then(
        (res) => {
          if (res.data.status == 'true') {
            this.filterParam = res.data.data
            let geo = []

            // geo.push({text:'- GEOFENCE -', value:""});
            // imei.push({text:'- IMEI -', value:""});
            // vin.push({text:'- VEHICLE NUMBER -', value:""});

            this.filterParam.forEach((x) => {
              x.geofence.forEach((geofence) => {
                let geo_f = geo.some((g) => g.value == geofence.geofence_id)
                let name = '-'
                let colour = '#000000'
                if (geofence['geofence_name'] != undefined) {
                  name = geofence.geofence_name
                  colour = geofence.colour
                }
                if (!geo_f)
                  geo.push({
                    text: name,
                    value: geofence.geofence_id,
                    colour: colour,
                  })
              })
            })
            //
            this.geofence_array = geo
          }
        }
      )
    },
    rekursive2(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = text + (parseInt(counter) + 1) + ' ' + x.fleet_group_name
        let tmp = {
          text: text,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    getMarker(map) {
      let id = this.$dataLocal.UserData().id
      REPO.getListVehicleClustering(id)
        .then((res) => {
          let tmp = res.data.data
          //
          let data = tmp.filter((location) => {
            return 'latitude' in location
          })
          this.locations = this.normalizeLicensePlateForList(data)
          //
          const renderPromise = this.getRolePermission().dashboard.maps.google_maps
            ? this.initialize(map)
            : this.getRolePermission().dashboard.maps.openstreet_maps
              ? this.initializeOsMap(map)
              : Promise.resolve()

          Promise.resolve(renderPromise).finally(() => {
            this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          })
        })
        .catch((err) => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$toast.error(err.message)
        })
    },
    format_number(val) {
      if (val) {
        let tmp = Math.round(val)
        return tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        return val
      }
    },
    checkStatus(key, val) {
      let selected = JSON.parse(JSON.stringify(this.selectedLocation))
      //
      if (key in selected) {
        if (selected[key] == val) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    cancelMarkerRendering() {
      this.markerRenderToken += 1
      this.isMarkerRendering = false
      if (this.markerRenderFrame) {
        cancelAnimationFrame(this.markerRenderFrame)
        this.markerRenderFrame = null
      }
    },
    runMarkerBatch(items, renderItem, done) {
      const token = ++this.markerRenderToken
      const batchSize = this.markerRenderBatchSize || 200
      let index = 0

      this.isMarkerRendering = true

      return new Promise((resolve) => {
        const step = () => {
          if (token !== this.markerRenderToken) {
            resolve(false)
            return
          }

          const end = Math.min(index + batchSize, items.length)
          for (; index < end; index++) {
            renderItem(items[index], index)
          }

          if (index < items.length) {
            this.markerRenderFrame = requestAnimationFrame(step)
            return
          }

          this.markerRenderFrame = null
          this.isMarkerRendering = false
          if (typeof done === 'function') {
            done()
          }
          resolve(true)
        }

        this.markerRenderFrame = requestAnimationFrame(step)
      })
    },
    initialize(map) {
      var self = this
      this.cancelMarkerRendering()
      this.markerLookup = {}
      if (this.markerCluster && typeof this.markerCluster.clearMarkers === 'function') {
        this.markerCluster.clearMarkers()
      }

      function MarkerClusterer(map, opt_markers, opt_options) {
        this.extend(MarkerClusterer, google.maps.OverlayView)
        this.map_ = map
        this.markers_ = []
        this.clusters_ = []

        this.sizes = [53, 56, 66, 78, 90]
        this.styles_ = []
        this.ready_ = false

        var options = opt_options || {}

        this.gridSize_ = options['gridSize'] || 60

        this.minClusterSize_ = options['minimumClusterSize'] || 2

        this.maxZoom_ = options['maxZoom'] || null

        this.styles_ = options['styles'] || []

        this.imagePath_ =
          options['imagePath'] || this.MARKER_CLUSTER_IMAGE_PATH_

        this.imageExtension_ =
          options['imageExtension'] || this.MARKER_CLUSTER_IMAGE_EXTENSION_

        this.zoomOnClick_ = true

        if (options['zoomOnClick'] != undefined) {
          this.zoomOnClick_ = options['zoomOnClick']
        }

        this.averageCenter_ = false

        if (options['averageCenter'] != undefined) {
          this.averageCenter_ = options['averageCenter']
        }

        this.setupStyles_()

        this.setMap(map)

        this.prevZoom_ = this.map_.getZoom()

        // Add the map event listeners
        var that = this
        if (self.googleListener != null) {
          google.maps.event.removeListener(self.googleListener)
        }
        let tmps = google.maps.event.addListener(
          this.map_,
          'bounds_changed',
          self.delay(function (e) {
            let bound = that.map_.getBounds()
            let coor = bound.toJSON()
            self.data_coordinate = [
              {
                latitude: coor['north'],
                longitude: coor['east'],
              },
              {
                latitude: coor['south'],
                longitude: coor['east'],
              },
              {
                latitude: coor['south'],
                longitude: coor['west'],
              },
              {
                latitude: coor['north'],
                longitude: coor['west'],
              },
            ]
            if (self.current_zoom > 12) {
              if (self.selectedPOICategory != null) {
                let ada = self.dataPOI
                if (self.markerPOI.length > 0) {
                  if (self.markerPOI.length > 0) {
                    self.markerPOI.forEach((x) => {
                      x.setMap(null)
                    })
                  }
                  self.markerPOI = []
                }

                //
                REPO.getPOIParam({
                  coordinates: self.data_coordinate,
                  category_poi_id: self.selectedPOICategory.id,
                  type: 'ALL',
                })
                  .then((res) => {
                    let tmp = {
                      id: self.selectedPOICategory.id,
                      status: true,
                      poi: [],
                      data: res.data.data,
                    }
                    self.dataPOI = []
                    self.dataPOI.push(tmp)
                    self.tampilPOI(
                      tmp.data,
                      self.selectedPOICategory.marker,
                      self.selectedPOICategory.id
                    )
                    self.$vs.loading.close(
                      '#data-list-list-view > .con-vs-loading'
                    )
                  })
                  .catch((err) => {
                    self.$vs.loading.close(
                      '#data-list-list-view > .con-vs-loading'
                    )
                  })
              }
            } else {
              self.hilangSemuaPOI()
            }

            //
          }, 500)
        )
        // let tmps = google.maps.event.addListener(this.map_, 'bounds_changed', function() {
        //
        //     self.delay(()=>{
        //
        //     },500)
        //     delay(function (e) {
        //
        //     }, 500)
        // })
        self.googleListener = google.maps.event.addListener(
          this.map_,
          'zoom_changed',
          function () {
            // Determines map type and prevent illegal zoom levels
            //
            var zoom = that.map_.getZoom()
            var minZoom = that.map_.minZoom || 0
            var maxZoom = Math.min(
              that.map_.maxZoom || 100,
              that.map_.mapTypes[that.map_.getMapTypeId()].maxZoom
            )
            zoom = Math.min(Math.max(zoom, minZoom), maxZoom)

            if (that.prevZoom_ != zoom) {
              that.prevZoom_ = zoom
              that.resetViewport()
            }
            self.current_zoom = zoom
            if (zoom > 12) {
              if (self.disableImage) {
                // self.tampilSemuaPOI();
              }
              self.disableImage = false
            } else {
              if (!self.disableImage) {
                // self.hilangSemuaPOI();
              }
              self.disableImage = true
            }

            // self.hilangSemuaPOI()
            // self.tampilSemuaPOI()
          }
        )

        google.maps.event.addListener(this.map_, 'idle', function () {
          that.redraw()
        })

        // Finally, add the markers
        if (
          opt_markers &&
          (opt_markers.length || Object.keys(opt_markers).length)
        ) {
          this.addMarkers(opt_markers, false)
        }
      }

      MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m'

      MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png'

      MarkerClusterer.prototype.extend = function (obj1, obj2) {
        return function (object) {
          for (var property in object.prototype) {
            this.prototype[property] = object.prototype[property]
          }
          return this
        }.apply(obj1, [obj2])
      }

      MarkerClusterer.prototype.onAdd = function () {
        this.setReady_(true)
      }

      MarkerClusterer.prototype.draw = function () {}

      MarkerClusterer.prototype.setupStyles_ = function () {
        if (this.styles_.length) {
          return
        }
        let tmp = [M1, M2, M3, M4, M5]
        for (var i = 0, size; (size = this.sizes[i]); i++) {
          this.styles_.push({
            url: tmp[i],
            height: 53,
            width: 53,
            // height: size,
            // width: size,
          })
          // this.styles_.push({
          //     url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
          //     height: size,
          //     width: size
          // });
        }
      }

      MarkerClusterer.prototype.fitMapToMarkers = function () {
        var markers = this.getMarkers()
        var bounds = new google.maps.LatLngBounds()
        for (var i = 0, marker; (marker = markers[i]); i++) {
          bounds.extend(marker.getPosition())
        }

        this.map_.fitBounds(bounds)
      }

      MarkerClusterer.prototype.setStyles = function (styles) {
        this.styles_ = styles
      }
      MarkerClusterer.prototype.getStyles = function () {
        return this.styles_
      }

      MarkerClusterer.prototype.isZoomOnClick = function () {
        return this.zoomOnClick_
      }

      MarkerClusterer.prototype.isAverageCenter = function () {
        return this.averageCenter_
      }

      MarkerClusterer.prototype.getMarkers = function () {
        return this.markers_
      }
      MarkerClusterer.prototype.getTotalMarkers = function () {
        return this.markers_.length
      }

      MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
        this.maxZoom_ = maxZoom
      }

      MarkerClusterer.prototype.getMaxZoom = function () {
        return this.maxZoom_
      }

      MarkerClusterer.prototype.calculator_ = function (markers, numStyles) {
        var index = 0
        var count = markers.length
        var dv = count
        while (dv !== 0) {
          dv = parseInt(dv / 10, 10)
          index++
        }

        index = Math.min(index, numStyles)
        return {
          // deprecated, change soon
          text: count,
          index: index,
        }
      }

      MarkerClusterer.prototype.setCalculator = function (calculator) {
        this.calculator_ = calculator
      }

      MarkerClusterer.prototype.getCalculator = function () {
        return this.calculator_
      }

      MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
        if (markers.length) {
          for (var i = 0, marker; (marker = markers[i]); i++) {
            this.pushMarkerTo_(marker)
          }
        } else if (Object.keys(markers).length) {
          for (var marker in markers) {
            this.pushMarkerTo_(markers[marker])
          }
        }
        if (!opt_nodraw) {
          this.redraw()
        }
      }

      MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
        marker.isAdded = false
        if (marker['draggable']) {
          // If the marker is draggable add a listener so we update the clusters on
          // the drag end.
          var that = this
          google.maps.event.addListener(marker, 'dragend', function () {
            marker.isAdded = false
            that.repaint()
          })
        }
        this.markers_.push(marker)
      }

      MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
        this.pushMarkerTo_(marker)
        if (!opt_nodraw) {
          this.redraw()
        }
      }

      MarkerClusterer.prototype.removeMarker_ = function (marker) {
        var index = -1
        if (this.markers_.indexOf) {
          index = this.markers_.indexOf(marker)
        } else {
          for (var i = 0, m; (m = this.markers_[i]); i++) {
            if (m == marker) {
              index = i
              break
            }
          }
        }

        if (index == -1) {
          // Marker is not in our list of markers.
          return false
        }

        marker.setMap(null)

        this.markers_.splice(index, 1)

        return true
      }

      MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
        var removed = this.removeMarker_(marker)

        if (!opt_nodraw && removed) {
          this.resetViewport()
          this.redraw()
          return true
        } else {
          return false
        }
      }

      MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
        var removed = false

        for (var i = 0, marker; (marker = markers[i]); i++) {
          var r = this.removeMarker_(marker)
          removed = removed || r
        }

        if (!opt_nodraw && removed) {
          this.resetViewport()
          this.redraw()
          return true
        }
      }

      MarkerClusterer.prototype.setReady_ = function (ready) {
        if (!this.ready_) {
          this.ready_ = ready
          this.createClusters_()
        }
      }

      MarkerClusterer.prototype.getTotalClusters = function () {
        return this.clusters_.length
      }

      MarkerClusterer.prototype.getMap = function () {
        return this.map_
      }

      MarkerClusterer.prototype.setMap = function (map) {
        this.map_ = map
      }

      MarkerClusterer.prototype.getGridSize = function () {
        return this.gridSize_
      }

      MarkerClusterer.prototype.setGridSize = function (size) {
        this.gridSize_ = size
      }

      MarkerClusterer.prototype.getMinClusterSize = function () {
        return this.minClusterSize_
      }

      MarkerClusterer.prototype.setMinClusterSize = function (size) {
        this.minClusterSize_ = size
      }

      MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
        var projection = this.getProjection()

        // Turn the bounds into latlng.
        var tr = new google.maps.LatLng(
          bounds.getNorthEast().lat(),
          bounds.getNorthEast().lng()
        )
        var bl = new google.maps.LatLng(
          bounds.getSouthWest().lat(),
          bounds.getSouthWest().lng()
        )

        // Convert the points to pixels and the extend out by the grid size.
        var trPix = projection.fromLatLngToDivPixel(tr)
        trPix.x += this.gridSize_
        trPix.y -= this.gridSize_

        var blPix = projection.fromLatLngToDivPixel(bl)
        blPix.x -= this.gridSize_
        blPix.y += this.gridSize_

        // Convert the pixel points back to LatLng
        var ne = projection.fromDivPixelToLatLng(trPix)
        var sw = projection.fromDivPixelToLatLng(blPix)

        // Extend the bounds to contain the new bounds.
        bounds.extend(ne)
        bounds.extend(sw)

        return bounds
      }

      MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
        return bounds.contains(marker.getPosition())
      }

      MarkerClusterer.prototype.clearMarkers = function () {
        this.resetViewport(true)

        // Set the markers a empty array.
        this.markers_ = []
      }

      MarkerClusterer.prototype.resetViewport = function (opt_hide) {
        // Remove all the clusters
        for (var i = 0, cluster; (cluster = this.clusters_[i]); i++) {
          cluster.remove()
        }

        // Reset the markers to not be added and to be invisible.
        for (var i = 0, marker; (marker = this.markers_[i]); i++) {
          marker.isAdded = false
          if (opt_hide) {
            marker.setMap(null)
          }
        }

        this.clusters_ = []
      }

      MarkerClusterer.prototype.repaint = function () {
        var oldClusters = this.clusters_.slice()
        this.clusters_.length = 0
        this.resetViewport()
        this.redraw()

        // Remove the old clusters.
        // Do it in a timeout so the other clusters have been drawn first.
        window.setTimeout(function () {
          for (var i = 0, cluster; (cluster = oldClusters[i]); i++) {
            cluster.remove()
          }
        }, 0)
      }

      MarkerClusterer.prototype.redraw = function () {
        this.createClusters_()
      }

      MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
        if (!p1 || !p2) {
          return 0
        }

        var R = 6371 // Radius of the Earth in km
        var dLat = ((p2.lat() - p1.lat()) * Math.PI) / 180
        var dLon = ((p2.lng() - p1.lng()) * Math.PI) / 180
        var a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos((p1.lat() * Math.PI) / 180) *
            Math.cos((p2.lat() * Math.PI) / 180) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
      }

      MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
        var distance = 40000 // Some large number
        var clusterToAddTo = null
        var pos = marker.getPosition()
        for (var i = 0, cluster; (cluster = this.clusters_[i]); i++) {
          var center = cluster.getCenter()
          if (center) {
            var d = this.distanceBetweenPoints_(center, marker.getPosition())
            if (d < distance) {
              distance = d
              clusterToAddTo = cluster
            }
          }
        }

        if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
          clusterToAddTo.addMarker(marker)
        } else {
          var cluster = new Cluster(this)
          cluster.addMarker(marker)
          this.clusters_.push(cluster)
        }
      }

      MarkerClusterer.prototype.createClusters_ = function () {
        if (!this.ready_) {
          return
        }

        // Get our current map view bounds.
        // Create a new bounds object so we don't affect the map.
        var mapBounds = new google.maps.LatLngBounds(
          this.map_.getBounds().getSouthWest(),
          this.map_.getBounds().getNorthEast()
        )
        var bounds = this.getExtendedBounds(mapBounds)

        for (var i = 0, marker; (marker = this.markers_[i]); i++) {
          if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
            this.addToClosestCluster_(marker)
          }
        }
      }

      function Cluster(markerClusterer) {
        this.markerClusterer_ = markerClusterer
        this.map_ = markerClusterer.getMap()
        this.gridSize_ = markerClusterer.getGridSize()
        this.minClusterSize_ = markerClusterer.getMinClusterSize()
        this.averageCenter_ = markerClusterer.isAverageCenter()
        this.center_ = null
        this.markers_ = []
        this.bounds_ = null
        this.clusterIcon_ = new ClusterIcon(
          this,
          markerClusterer.getStyles(),
          markerClusterer.getGridSize()
        )
      }

      Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
        if (this.markers_.indexOf) {
          return this.markers_.indexOf(marker) != -1
        } else {
          for (var i = 0, m; (m = this.markers_[i]); i++) {
            if (m == marker) {
              return true
            }
          }
        }
        return false
      }

      Cluster.prototype.addMarker = function (marker) {
        if (this.isMarkerAlreadyAdded(marker)) {
          return false
        }

        if (!this.center_) {
          this.center_ = marker.getPosition()
          this.calculateBounds_()
        } else {
          if (this.averageCenter_) {
            var l = this.markers_.length + 1
            var lat =
              (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l
            var lng =
              (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l
            this.center_ = new google.maps.LatLng(lat, lng)
            this.calculateBounds_()
          }
        }

        marker.isAdded = true
        this.markers_.push(marker)

        var len = this.markers_.length
        if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
          // Min cluster size not reached so show the marker.
          marker.setMap(this.map_)
        }

        if (len == this.minClusterSize_) {
          // Hide the markers that were showing.
          for (var i = 0; i < len; i++) {
            this.markers_[i].setMap(null)
          }
        }

        if (len >= this.minClusterSize_) {
          marker.setMap(null)
        }

        this.updateIcon()
        return true
      }

      Cluster.prototype.getMarkerClusterer = function () {
        return this.markerClusterer_
      }

      Cluster.prototype.getBounds = function () {
        var bounds = new google.maps.LatLngBounds(this.center_, this.center_)
        var markers = this.getMarkers()
        for (var i = 0, marker; (marker = markers[i]); i++) {
          bounds.extend(marker.getPosition())
        }
        return bounds
      }

      Cluster.prototype.remove = function () {
        this.clusterIcon_.remove()
        this.markers_.length = 0
        delete this.markers_
      }

      Cluster.prototype.getSize = function () {
        return this.markers_.length
      }

      Cluster.prototype.getMarkers = function () {
        return this.markers_
      }

      Cluster.prototype.getCenter = function () {
        return this.center_
      }

      Cluster.prototype.calculateBounds_ = function () {
        var bounds = new google.maps.LatLngBounds(this.center_, this.center_)
        this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds)
      }

      Cluster.prototype.isMarkerInClusterBounds = function (marker) {
        return this.bounds_.contains(marker.getPosition())
      }

      Cluster.prototype.getMap = function () {
        return this.map_
      }

      Cluster.prototype.updateIcon = function () {
        var zoom = this.map_.getZoom()
        var mz = this.markerClusterer_.getMaxZoom()

        if (mz && zoom > mz) {
          // The zoom is greater than our max zoom so show all the markers in cluster.
          for (var i = 0, marker; (marker = this.markers_[i]); i++) {
            marker.setMap(this.map_)
          }
          return
        }

        if (this.markers_.length < this.minClusterSize_) {
          // Min cluster size not yet reached.
          this.clusterIcon_.hide()
          return
        }

        var numStyles = this.markerClusterer_.getStyles().length
        var sums = this.markerClusterer_.getCalculator()(
          this.markers_,
          numStyles
        )
        this.clusterIcon_.setCenter(this.center_)
        this.clusterIcon_.setSums(sums)
        this.clusterIcon_.show()
      }

      function ClusterIcon(cluster, styles, opt_padding) {
        cluster
          .getMarkerClusterer()
          .extend(ClusterIcon, google.maps.OverlayView)

        this.styles_ = styles
        this.padding_ = opt_padding || 0
        this.cluster_ = cluster
        this.center_ = null
        this.map_ = cluster.getMap()
        this.div_ = null
        this.sums_ = null
        this.visible_ = false

        this.setMap(this.map_)
      }

      ClusterIcon.prototype.triggerClusterClick = function () {
        var markerClusterer = this.cluster_.getMarkerClusterer()

        // Trigger the clusterclick event.
        google.maps.event.trigger(
          markerClusterer,
          'clusterclick',
          this.cluster_
        )

        if (markerClusterer.isZoomOnClick()) {
          // Zoom into the cluster.
          this.map_.fitBounds(this.cluster_.getBounds())
        }
      }

      ClusterIcon.prototype.onAdd = function () {
        this.div_ = document.createElement('DIV')
        if (this.visible_) {
          var pos = this.getPosFromLatLng_(this.center_)
          this.div_.style.cssText = this.createCss(pos)
          this.div_.innerHTML = this.sums_.text
        }

        var panes = this.getPanes()
        panes.overlayMouseTarget.appendChild(this.div_)

        var that = this
        google.maps.event.addDomListener(this.div_, 'click', function () {
          that.triggerClusterClick()
        })
      }

      ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
        var pos = this.getProjection().fromLatLngToDivPixel(latlng)
        pos.x -= parseInt(this.width_ / 2, 10)
        pos.y -= parseInt(this.height_ / 2, 10)
        return pos
      }

      ClusterIcon.prototype.draw = function () {
        if (this.visible_) {
          var pos = this.getPosFromLatLng_(this.center_)
          this.div_.style.top = pos.y + 'px'
          this.div_.style.left = pos.x + 'px'
        }
      }

      ClusterIcon.prototype.hide = function () {
        if (this.div_) {
          this.div_.style.display = 'none'
        }
        this.visible_ = false
      }

      ClusterIcon.prototype.show = function () {
        if (this.div_) {
          var pos = this.getPosFromLatLng_(this.center_)
          this.div_.style.cssText = this.createCss(pos)
          this.div_.style.display = ''
        }
        this.visible_ = true
      }

      ClusterIcon.prototype.remove = function () {
        this.setMap(null)
      }

      ClusterIcon.prototype.onRemove = function () {
        if (this.div_ && this.div_.parentNode) {
          this.hide()
          this.div_.parentNode.removeChild(this.div_)
          this.div_ = null
        }
      }

      ClusterIcon.prototype.setSums = function (sums) {
        this.sums_ = sums
        this.text_ = sums.text
        this.index_ = sums.index
        if (this.div_) {
          this.div_.innerHTML = sums.text
        }

        this.useStyle()
      }

      ClusterIcon.prototype.useStyle = function () {
        var index = Math.max(0, this.sums_.index - 1)
        index = Math.min(this.styles_.length - 1, index)
        var style = this.styles_[index]
        this.url_ = style['url']
        this.height_ = style['height']
        this.width_ = style['width']
        this.textColor_ = style['textColor']
        this.anchor_ = style['anchor']
        this.textSize_ = style['textSize']
        this.backgroundPosition_ = style['backgroundPosition']
      }

      ClusterIcon.prototype.setCenter = function (center) {
        this.center_ = center
      }

      ClusterIcon.prototype.createCss = function (pos) {
        var style = []
        style.push('background-image:url(' + this.url_ + ');')
        var backgroundPosition = this.backgroundPosition_
          ? this.backgroundPosition_
          : '0 0'
        style.push('background-position:' + backgroundPosition + ';')

        if (typeof this.anchor_ === 'object') {
          if (
            typeof this.anchor_[0] === 'number' &&
            this.anchor_[0] > 0 &&
            this.anchor_[0] < this.height_
          ) {
            style.push(
              'height:' +
                (this.height_ - this.anchor_[0]) +
                'px; padding-top:' +
                this.anchor_[0] +
                'px;'
            )
          } else {
            style.push(
              'height:' +
                this.height_ +
                'px; line-height:' +
                this.height_ +
                'px;'
            )
          }
          if (
            typeof this.anchor_[1] === 'number' &&
            this.anchor_[1] > 0 &&
            this.anchor_[1] < this.width_
          ) {
            style.push(
              'width:' +
                (this.width_ - this.anchor_[1]) +
                'px; padding-left:' +
                this.anchor_[1] +
                'px;'
            )
          } else {
            style.push('width:' + this.width_ + 'px; text-align:center;')
          }
        } else {
          style.push(
            'height:' +
              this.height_ +
              'px; line-height:' +
              this.height_ +
              'px; width:' +
              this.width_ +
              'px; text-align:center;'
          )
        }

        var txtColor = this.textColor_ ? this.textColor_ : 'black'
        var txtSize = this.textSize_ ? this.textSize_ : 11

        style.push(
          'cursor:pointer; top:' +
            pos.y +
            'px; left:' +
            pos.x +
            'px; color:' +
            txtColor +
            '; position:absolute; font-size:' +
            txtSize +
            'px; font-family:Arial,sans-serif; font-weight:bold'
        )
        return style.join('')
      }

      //
      //
      this.infowindow = new google.maps.InfoWindow({
        size: new google.maps.Size(150, 50),
      })

      function view_detail(val) {
        self.view_detail2(val)
      }

      // map.setCenter(self.center);
      // map.setZoom(9);
      // map.setCenter(new google.maps.LatLng( -6.1498619, 106.882887));
      self.marker_rotate = []
      var markers = []
      const validLocations = this.locations.filter((location) => {
        return 'latitude' in location
      })

      const renderMarker = function (location) {
        if ('latitude' in location) {
          //
          let loc = {
            lat: parseFloat(location.latitude),
            lng: parseFloat(location.longitude),
          }
          let pilih_marker = IdleMarker
          const registeredEvent = self.resolveMapDisplayActivity(location)

          location.vehicle_activity = registeredEvent

          const iconUrl = self.getMapIconByActivity(registeredEvent)

          const url = iconUrl + '#' + location._id

          const iconMark = self.getGoogleMarkerIcon(url)

          self.marker_rotate.push({
            icon: url,
            rotation: location.direction,
          })

          const markerLabel = () => {
            if (
              location.license_plate &&
              location.fleet_group_name &&
              location.latitude &&
              location.longitude
            ) {
              return `<div class="label-nopol" style="background-color: white; text-align: center; position: relative; left: -50%">${location.license_plate}<br>${location.fleet_group_name}</div>`
            } else {
              //
              return ''
            }
          }
          let mark = new MarkerWithLabel({
            position: loc,
            icon: iconMark,
            draggable: false,
            map: map,
            labelContent: markerLabel(),
            labelAnchor: new google.maps.Point(0, 7),
            // labelClass: markClass,
            labelInBackground: true,
          })
          self.registerMarkerForLocation(mark, location)

          // google.maps.event.addListener(mark, 'bounds_changed', () => {
          //
          // })
          google.maps.event.addListener(mark, 'click', () => {
            // mark.getIcon().rotation = 100.0
            //
            self.center = loc
            self.openVehicleInfo(location)
          })
          markers.push(mark)
        }
      }

      const rotateMarker = () => {
        let index = 0
        const rotateBatch = () => {
          const end = Math.min(index + self.markerRenderBatchSize, self.marker_rotate.length)
          for (; index < end; index++) {
            const z = self.marker_rotate[index]
            const q = document.querySelector(`img[src="${z.icon}"]`)
            if (q) {
              q.style.cssText += `transform: rotate(${
                z.rotation + 90
              }deg); transform-origin: center center;`
            }
          }

          if (index < self.marker_rotate.length) {
            requestAnimationFrame(rotateBatch)
          }
        }

        setTimeout(() => {
          requestAnimationFrame(rotateBatch)
        }, 500)
      }

      google.maps.event.addListenerOnce(map, 'idle', function () {
        rotateMarker()
      })

      return this.runMarkerBatch(validLocations, renderMarker, () => {
        this.markerCluster = new MarkerClusterer(map, markers, {
          imagePath:
            'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        })

        this.lastMarkerFleetId = this.fleet_group_id
        this.lastMarkerFilter = this.selected_filter
        rotateMarker()
      })
    },
    initializeOsMap(map) {
      const self = this
      this.cancelMarkerRendering()
      this.markerLookup = {}
      if (this.markerClusterGroup) {
        if (map && typeof map.removeLayer === 'function') {
          map.removeLayer(this.markerClusterGroup)
        }
        this.markerClusterGroup.clearLayers()
      }
      this.markerClusterGroup = L.markerClusterGroup()
      map.addLayer(this.markerClusterGroup)

      const validLocations = this.locations.filter((m) => {
        return 'latitude' in m && m.latitude !== ''
      })

      const renderMarker = (m, index) => {
        const registeredEvent = self.resolveMapDisplayActivity(m)

        m.vehicle_activity = registeredEvent

        const marker = L.marker(latLng(m.latitude, m.longitude), {
          rotationAngle: m.direction + 90,
          icon: self.getLeafletMarkerIcon(
            self.getMapIconByActivity(registeredEvent)
          ),
        })

        self.registerMarkerForLocation(marker, m)

        marker.bindTooltip(
          `<p class="text-center">${m.license_plate}<br>${m.fleet_group_name}</p>`,
          {
            permanent: true,
            interactive: true,
            direction: 'bottom',
          }
        )

        marker.on('click', function (e) {
          self.selectedLocation = null
          //
          self.centerLeaflet = {
            lat: m.latitude,
            lng: m.longitude,
          }
          REPO.getOneMWMapping(m._id).then((rress) => {
            const data = rress.data.data
            self.selectedLocation = data

            const container = `
                    <div class="flex flex-row" style="gap: 10px">
                      <div class="flex flex-col">
                        <h5>Vehicle Information</h5>
                        <table>
                          <tr>
                            <td>GPS Date</td>
                            <td>:</td>
                            <td>
                              <strong>${data.device_time} WIB</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Fleet Group</td>
                            <td>:</td>
                            <td>
                              <strong>${data.fleet_group_name}</strong>
                            </td>
                          </tr>
                          <tr>
                            <td style="min-width: 84px">License Plate</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${data.license_plate}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Vehicle Model</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${data.vehicle_model}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Driver Name</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${data.driver_name}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Driver Phone</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${data.driver_phone}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Latitude</td>
                            <td>:</td>
                            <td>
                              <strong> ${data.latitude} </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Longitude</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${data.longitude}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Location</td>
                            <td>:</td>
                            <td>
                              <strong>
                                <a
                                  id="location"
                                  target="_blank"
                                  class="cursor-pointer"
                                  >Show Google Map</a
                                >
                              </strong>
                            </td>
                          </tr>

                          <tr>
                            <td>Street View</td>
                            <td>:</td>
                            <td>
                              <strong>
                                <a
                                  id="street"
                                  target="_blank"
                                  class="cursor-pointer"
                                  >Show Sreet View</a
                                >
                              </strong>
                            </td>
                          </tr>
                        </table>
                        <div class="flex flex-row" style="gap: 10px">
                          ${
                            self.getRolePermission().vehicle_details
                              .vehicle_informations.read_vehicle_details
                              ? `
                            <button 
                              id="view-detail"
                              class="btn btn-primary mt-4 button-detail"
                            >View Detail</button>
                            `
                              : ''
                          }
                          <button 
                            id="live-share"
                            class="btn btn-primary mt-4 button-detail"
                          >Live Share</button>
                        </div>
                      </div>
                      <div class="flex flex-col">
                        <h5>Vehicle Status</h5>
                        <table>
                          <tr>
                            <td>Event Name</td>
                            <td>:</td>
                            <td>
                              <strong>${data.event_name}</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Speed</td>
                            <td>:</td>
                            <td>
                              <strong>${data.speed} km/jam</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Direction</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${
                                  data.direction
                                }<sup style="color: black">0</sup>
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Internal Battery</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${self.format_number(
                                  data.internal_battery_voltage
                                )} V
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>External Battery</td>
                            <td>:</td>
                            <td>
                              <strong>
                                ${self.format_number(
                                  data.external_power_voltage
                                )} V
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Humidity</td>
                            <td>:</td>
                            <td>
                              <span>
                                <strong>
                                  ${
                                    data.humidity
                                      ? self.format_number(data.humidity) + '%'
                                      : '-'
                                  }
                                </strong>
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Battery Level (eye sensor)</td>
                            <td>:</td>
                            <td>
                              <span>
                                <strong>
                                  ${
                                    data.eye_battery_level
                                      ? self.format_number(
                                          data.eye_battery_level
                                        ) + '%'
                                      : '-'
                                  }
                                </strong>
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Engine Status</td>
                            <td>:</td>
                            <td>
                              ${
                                data.ignition == 0
                                  ? `
                                  <span style="color: red">
                                    <strong>OFF</strong>
                                  </span>
                                `
                                  : `
                                  <span style="color: green">
                                    <strong> ON</strong>
                                  </span>
                                `
                              }
                            </td>
                          </tr>
                          <tr>
                            <td>SOS</td>
                            <td>:</td>
                            <td>
                              ${
                                self.checkStatus('panic', 'ON')
                                  ? `
                                <span style="color: red"><strong> ON </strong></span>
                              `
                                  : self.checkStatus('panic', 'OFF')
                                    ? `
                                <span style="color: green"><strong> OFF </strong></span>
                              `
                                    : `<strong> - </strong>`
                              }
                            </td>
                          </tr>

                          <tr>
                            <td>Left Door</td>
                            <td>:</td>
                            <td>
                              ${
                                self.checkStatus('dleft', 'OPEN')
                                  ? `
                                <span style="color: red"><strong> OPEN </strong></span>
                              `
                                  : self.checkStatus('dleft', 'CLOSED')
                                    ? `
                                <span style="color: green"><strong> CLOSE </strong></span>
                              `
                                    : `<strong> - </strong>`
                              }
                            </td>
                          </tr>
                          <tr>
                            <td>Right Door</td>
                            <td>:</td>
                            <td>
                              ${
                                self.checkStatus('dright', 'OPEN')
                                  ? `
                                <span style="color: red"><strong> OPEN </strong></span>
                              `
                                  : self.checkStatus('dright', 'CLOSED')
                                    ? `
                                <span style="color: green"><strong> CLOSE </strong></span>
                              `
                                    : `<strong> - </strong>`
                              }
                            </td>
                          </tr>
                          <tr>
                            <td>Rear Door</td>
                            <td>:</td>
                            <td>
                              ${
                                self.checkStatus('drear', 'OPEN')
                                  ? `
                                <span style="color: red"><strong> OPEN </strong></span>
                              `
                                  : self.checkStatus('drear', 'CLOSED')
                                    ? `
                                <span style="color: green"><strong> CLOSE </strong></span>
                              `
                                    : `<strong> - </strong>`
                              }
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  `

            const popup = L.popup({
              autoPan: true,
              maxWidth: 600,
            }).setContent(container)

            marker.bindPopup(popup).openPopup()

            document
              .getElementById('location')
              .addEventListener('click', () => {
                window.open(
                  `http://www.google.com/maps/place/${data.latitude},${data.longitude}`,
                  '_blank'
                )
              })

            document.getElementById('street').addEventListener('click', () => {
              window.open(
                `http://www.google.com/maps?q&layer=c&cbll=${data.latitude},${data.longitude}`,
                '_blank'
              )
            })

            document
              .getElementById('view-detail')
              .addEventListener('click', () => {
                self.$router.push(
                  '/monitoring-vehicle/' + self.selectedLocation.vehicle_id
                )
              })

            document
              .getElementById('live-share')
              .addEventListener('click', () => {
                //
                self.selectedVehicleId = self.selectedLocation.vehicle_id
                self.openModalLiveShare = true
              })
          })
        })

        marker.addTo(this.markerClusterGroup)
      }

      return this.runMarkerBatch(validLocations, renderMarker, () => {
        this.lastMarkerFleetId = this.fleet_group_id
        this.lastMarkerFilter = this.selected_filter

        // add event listener whenever the map is zoomed
        if (this.handleLeafletZoomEnd) {
          map.off('zoomend', this.handleLeafletZoomEnd)
        }
        this.handleLeafletZoomEnd = () => {
          self.zoom = map.getZoom()
          if (map.getZoom() > 12) {
            self.disableImage = false
          } else {
            self.disableImage = true
            self.hilangSemuaPOI()
          }
        }
        map.on('zoomend', this.handleLeafletZoomEnd)
      })
    },
  },
  created() {
    this.getCategoryPOI()
    this.baseUrl = BASE_FILE.substring(0, BASE_FILE.length - 4)
    this.headerList = [
      // total vehicle
      {
        text: 'Total Vehicle',
        class: 'total-card',
        icon: this.carsIcon,
        num: 'total_vehicle_num',
        total_vehicle: { total: 0, last_page: 1 },
        d_total_vehicle: [],
        click: () => {
          this.openModal = true
          this.titleModal = 'Total Vehicle'
          this.d_type = 'total'
        },
        info: 'Jumlah keseluruhan kendaraan yang terdaftar dalam sistem',
      },
      // geofence out
      {
        text: 'Unit In Operation',
        class: 'uio-card',
        icon: this.uioIcon,
        num: 'total_geofence_violation',
        total_vehicle: { total: 0, last_page: 1 },
        d_geofence_violation: [],
        click: () => {
          this.openModal = true
          this.titleModal = 'Unit In Operation'
          this.d_type = 'geofence'
        },
        info: 'Kendaraan saat ini berada di luar area geofence.',
      },
      // moving
      {
        text: 'Moving Vehicle',
        class: 'moving-card',
        icon: this.movingIcon,
        num: 'total_moving_vehicle',
        total_vehicle: { total: 0, last_page: 1 },
        d_moving_vehicle: [],
        click: () => {
          this.openModal = true
          this.titleModal = 'Moving Vehicle'
          this.d_type = 'moving'
        },
        info: 'Kendaraan yang saat ini bergerak di atas 0 km/jam.',
      },
      // idle
      {
        text: 'Idle Vehicle',
        class: 'idle-card',
        icon: this.idleIcon,
        num: 'total_idle_vehicle',
        total_vehicle: { total: 0, last_page: 1 },
        d_idle_vehicle: [],
        click: () => {
          this.openModal = true
          this.titleModal = 'Idle Vehicle'
          this.d_type = 'idle'
        },
        info: 'kendaraan yang saat ini melakukan pelanggaran overstay engine on.',
      },
      // stop
      {
        text: 'Stop Vehicle',
        class: 'stop-card',
        icon: this.stopIcon,
        num: 'total_stop_vehicle',
        total_vehicle: { total: 0, last_page: 1 },
        d_stop_vehicle: [],
        click: () => {
          this.openModal = true
          this.titleModal = 'Stop Vehicle'
          this.d_type = 'stop'
        },
        info: 'kendaraan yang saat ini melakukan pelanggaran overstay engine off.',
      },
      // silence
      {
        text: 'Silence Vehicle',
        class: 'silence-card',
        icon: this.silenceIcon,
        num: 'total_silent_vehicle',
        total_vehicle: { total: 0, last_page: 1 },
        d_silent_vehicle: [],
        click: () => {
          this.openModal = true
          this.titleModal = 'Silence Vehicle'
          this.d_type = 'silent'
        },
        info: 'Kendaraan yang tidak mengirim data lebih dari 4 jam.',
      },
      // in repair
      {
        text: 'In Repair Vehicle',
        class: 'repair-card',
        icon: this.inRepairIcon,
        num: 'total_in_repair_vehicle',
        total_vehicle: { total: 0, last_page: 1 },
        d_in_repair_vehicle: [],
        click: () => {
          this.openModal = true
          this.titleModal = 'In Repair Vehicle'
          this.d_type = 'repair'
        },
        info: 'Kendaraan yang sedang dalam proses maintenance.',
      },
    ]
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this.handleResize()
      window.addEventListener('resize', this.handleResize)
    }
    this.isMobileFilterVisible = false

    this.loadingStart('total-card')
    this.loadingStart('idle-card')
    this.loadingStart('uio-card')
    this.loadingStart('moving-card')
    this.loadingStart('stop-card')
    this.loadingStart('silence-card')
    this.loadingStart('repair-card')
    this.getData()
    this.stopCron()

    // Fetch silence count dari API untuk mendapatkan angka yang akurat dari database
    this.fetchSilenceCount()

    // console.log('this.$dataLocal.UserData()', this.$dataLocal.UserData())

    this.$on('reloadHeader', () => {
      this.getDataCron()
    })

    // if (this.$dataLocal.UserData().fleet_group.levels == 1) {
    //   this.isCommandCenter = true
    // }
    if (this.$dataLocal.UserData().role.role_name == 'Administrator') {
      this.isAdministrator = true
    }
    if (this.$dataLocal.UserData().role.role_name == 'Koordinator') {
      this.isCoordinator = true
    }
    // ("this.isAdministrator ", this.isAdministrator);
    this.crontab = cron.schedule(
      '*/10 * * * *',
      () => {
        this.getDataCron()
        this.filterData()
      },
      {
        scheduled: true,
      }
    )

    this.crontab.start()
    // this.IsCommandCenter = this.$dataLocal.IsCommandCenter()
    if (this.IsCommandCenter) {
      this.pilih_filter = [
        { value: 'all', text: '- All -' },
        { value: 'fleet_group', text: 'Fleet Group' },
        { value: 'imei', text: 'IMEI' },
        { value: 'vin', text: 'Vehicle Number' },
        { value: 'license_plate', text: 'License Plate' },
      ]
    } else {
      this.pilih_filter = [
        { value: 'all', text: '- All -' },
        { value: 'fleet_group', text: 'Fleet Group' },
        { value: 'imei', text: 'IMEI' },
        { value: 'license_plate', text: 'License Plate' },
      ]
    }

    //
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })

    if (this.getRolePermission().dashboard.maps.google_maps) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map
        map.setCenter(this.center)
        map.setZoom(5)
        this.getMarker(map)
        this.mapTypeControlOptions = {
          mapTypeIds: [
            google.maps.MapTypeId.ROADMAP,
            google.maps.MapTypeId.SATELLITE,
          ],
        }

        //
        google.maps.Polygon.prototype.getBounds = function () {
          var bounds = new google.maps.LatLngBounds()
          var paths = this.getPaths()
          var path
          for (var i = 0; i < paths.getLength(); i++) {
            path = paths.getAt(i)
            for (var ii = 0; ii < path.getLength(); ii++) {
              bounds.extend(path.getAt(ii))
            }
          }
          return bounds
        }
        // google.maps.event.addListener(map, 'zoom_changed', function() {
        //     // Determines map type and prevent illegal zoom levels
        //
        // });
      })
    } else if (this.getRolePermission().dashboard.maps.openstreet_maps) {
      this.map = this.$refs.mapRefLeaflet.mapObject
      this.getMarker(this.map)
    }

    // this.$vs.loading.close('#data-list-list-view > .con-vs-loading')

    // this.fleet_group_id = this.$dataLocal.UserData().id;
    // this.fleet_array = [
    //   {
    //     text: 'All',
    //     value: this.$dataLocal.UserData().id,
    //   },
    // ]
    //
    // REPO.getListFleetChield(this.$dataLocal.UserData().id).then((res) => {
    //   if (res.data.status == 'true') {
    //     let tmp = res.data.data.map((h) => {
    //       return {
    //         text: h.fleet_group_name,
    //         value: h.id,
    //       }
    //     })
    //     //
    //     // let hasil = []
    //     // this.rekursive(tmp, hasil, 0)
    //     //
    //     const duplicate_fleet = tmp.filter(
    //       (item, index) =>
    //         this.fleet_array.findIndex((t) => t.value === item.value) === index
    //     )
    //     this.fleet_array = [...this.fleet_array, ...tmp]
    //
    //   }
    // })
  },
  computed: {
    // computed baru untuk counting saat mode filter::start
    getFilteredCountByActivity() {
      return (activity) => {
        if (!Array.isArray(this.sidebar_locations)) return 0
        if (activity === 'ALL') return this.sidebar_locations.length

        return this.sidebar_locations.filter(
          (item) => (
            activity === 'IN_OPERATION'
              ? this.isInOperationVehicle(item)
              : this.normalizeVehicleActivity(item.vehicle_activity) === activity
      )
        ).length
      }
    },
    // computed baru untuk counting saat mode filter::end
    
    google: gmapApi,
    activityFilterOptions() {
      if (this.shouldUseFilteredStatusCounts()) {
        return [
          {
            text: `All Vehicle (${this.getFilteredStatusCount('ALL')})`,
            value: 'ALL',
          },
          {
            text: `In Operation (${this.getFilteredStatusCount(
              'IN_OPERATION'
            )})`,
            value: 'IN_OPERATION',
          },
          {
            text: `Moving (${this.getFilteredStatusCount('MOVING')})`,
            value: 'MOVING',
          },
          {
            text: `Idle (${this.getFilteredStatusCount('IDLE')})`,
            value: 'IDLE',
          },
          {
            text: `Stop (${this.getFilteredStatusCount('STOP')})`,
            value: 'STOP',
          },
          {
            text: `Silence (${this.getFilteredStatusCount('SILENCE')})`,
            value: 'SILENCE',
          },
          {
            text: `In Repair (${this.getFilteredStatusCount('IN_REPAIR')})`,
            value: 'IN_REPAIR',
          },
        ]
      }

      const getCount = (index) => {
        if (!Array.isArray(this.headerList)) return 0
        const target = this.headerList[index]
        if (!target || !target.total_vehicle) return 0
        const { total } = target.total_vehicle
        return total || 0
      }

      const silenceCount =
        this.silenceCountFromAPI !== null ? this.silenceCountFromAPI : getCount(5)

      return [
        { text: `All Vehicle (${getCount(0)})`, value: 'ALL' },
        {
          text: `In Operation (${getCount(1)})`,
          value: 'IN_OPERATION',
        },
        { text: `Moving (${getCount(2)})`, value: 'MOVING' },
        { text: `Idle (${getCount(3)})`, value: 'IDLE' },
        { text: `Stop (${getCount(4)})`, value: 'STOP' },
        { text: `Silence (${silenceCount})`, value: 'SILENCE' },
        { text: `In Repair (${getCount(6)})`, value: 'IN_REPAIR' },
      ]
    },
    // activityFilterOptions() {
    //   return [
    //     { text: `All Vehicle (${this.getFilteredCountByActivity('ALL')})`, value: 'ALL' },
    //     { text: `In Operation (${this.getFilteredCountByActivity('IN_OPERATION')})`, value: 'IN_OPERATION' },
    //     { text: `Moving (${this.getFilteredCountByActivity('MOVING')})`, value: 'MOVING' },
    //     { text: `Idle (${this.getFilteredCountByActivity('IDLE')})`, value: 'IDLE' },
    //     { text: `Stop (${this.getFilteredCountByActivity('STOP')})`, value: 'STOP' },
    //     { text: `Silence (${this.getFilteredCountByActivity('SILENCE')})`, value: 'SILENCE' },
    //     { text: `In Repair (${this.getFilteredCountByActivity('IN_REPAIR')})`, value: 'IN_REPAIR' },
    //   ]
    // },
    currentActivityFilterValue() {
      if (!Array.isArray(this.v_act_filter) || this.v_act_filter.length === 0) {
        return 'ALL'
      }
      return this.v_act_filter[0]
    },
    selectedActivityFilter: {
      get() {
        const currentValue =
          !Array.isArray(this.v_act_filter) || this.v_act_filter.length === 0
            ? 'ALL'
            : this.v_act_filter[0]

        // Find and return the full option object from activityFilterOptions
        if (
          !this.activityFilterOptions ||
          this.activityFilterOptions.length === 0
        ) {
          return null
        }

        const option = this.activityFilterOptions.find(
          (opt) => opt.value === currentValue
        )
        return option || this.activityFilterOptions[0]
      },
      set(selectedOption) {
        // selectedOption is the full object {text: "...", value: "..."}
        const value = selectedOption ? selectedOption.value : 'ALL'

        if (!value || value === 'ALL') {
          this.v_act_filter = []
        } else {
          this.v_act_filter = [value]
        }
      },
    },
    shouldShowHeaderCard() {
      const roleName = this.$dataLocal.UserData().role.role_name
      return (
        roleName === 'FICO' || roleName === 'FICO CLH' || roleName === 'Vendor'
      )
    },
    isSilenceFilterActive() {
      return (
        Array.isArray(this.v_act_filter) &&
        this.v_act_filter.includes('SILENCE')
      )
    },
    isRepairFilterActive() {
      return (
        Array.isArray(this.v_act_filter) &&
        this.v_act_filter.includes('IN_REPAIR')
      )
    },
    isOperationFilterActive() {
      return (
        Array.isArray(this.v_act_filter) &&
        this.v_act_filter.includes('IN_OPERATION')
      )
    },
    isIdleFilterActive() {
      return (
        Array.isArray(this.v_act_filter) && this.v_act_filter.includes('IDLE')
      )
    },
    isStopFilterActive() {
      return (
        Array.isArray(this.v_act_filter) && this.v_act_filter.includes('STOP')
      )
    },
    showDownloadButton() {
      return true // Always show download button for any filter including All
    },
    downloadButtonText() {
      if (this.v_act_filter.length === 0) return 'Download Data'
      if (this.v_act_filter.includes('SILENCE')) return 'Download Silence Data'
      if (this.v_act_filter.includes('IN_REPAIR')) return 'Download Repair Data'
      if (this.v_act_filter.includes('MOVING')) return 'Download Moving Data'
      if (this.v_act_filter.includes('IN_OPERATION'))
        return 'Download In Operation Data'
      if (this.v_act_filter.includes('IDLE')) return 'Download Idle Data'
      if (this.v_act_filter.includes('STOP')) return 'Download Stop Data'
      return 'Download All Data'
    },
    currentFilterType() {
      if (this.v_act_filter.includes('SILENCE')) return 'silence'
      if (this.v_act_filter.includes('IN_REPAIR')) return 'repair'
      if (this.v_act_filter.includes('MOVING')) return 'moving'
      if (this.v_act_filter.includes('IN_OPERATION')) return 'operation'
      if (this.v_act_filter.includes('IDLE')) return 'idle'
      if (this.v_act_filter.includes('STOP')) return 'stop'
      return 'all'
    },
    currentFilterTitle() {
      if (this.v_act_filter.includes('SILENCE')) return 'Silence Vehicle'
      if (this.v_act_filter.includes('IN_REPAIR')) return 'In Repair Vehicle'
      if (this.v_act_filter.includes('MOVING')) return 'Moving Vehicle'
      if (this.v_act_filter.includes('IN_OPERATION'))
        return 'In Operation Vehicle'
      if (this.v_act_filter.includes('IDLE')) return 'Idle Vehicle'
      if (this.v_act_filter.includes('STOP')) return 'Stop Vehicle'
      return 'All Vehicle'
    },
  },
  components: {
    VueApexCharts,
    InfoWindow,
    HeaderCard,
    LiveShare,
    AlertHistory,
  },
}
</script>

<style>
button .vs-button-text.vs-button--text {
  display: flex!important;
  align-items: center!important;
  gap: 6px;
  justify-content: center;
}

.button-detail {
  direction: ltr;
  --vs-light: 245, 245, 245;
  --vs-primary: 15, 117, 188;
  --vs-success: 40, 199, 111;
  --vs-danger: 234, 84, 85;
  --vs-warning: 255, 159, 67;
  --vs-dark: 30, 30, 30;
  margin: 0;
  outline: none;
  text-transform: none;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: #fff;
  box-sizing: border-box;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  float: left !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important;
  padding: 0.75rem 2rem;
  background: linear-gradient(
    30deg,
    rgb(210, 48, 48) 0%,
    rgb(248, 149, 149) 100%
  );
}
</style>

<style lang="scss" scoped>

.vs-popup {
  width: auto !important;
}

#sidebar-scrollarea::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#sidebar-scrollarea::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

#sidebar-scrollarea::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

#sidebar-scrollarea {
  .manual-card {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-bottom: 12px;

    > * {
      box-sizing: border-box;
    }
  }
}

.center-image {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 4px 12px;
  align-items: center;
  height: auto;
}

.manual-bookmark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 12px;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background-color: #fef3c7;
  color: #b45309;
  border: 1px solid rgba(180, 83, 9, 0.25);
}

.manual-bookmark ::v-deep svg {
  stroke: currentColor;
}

.manual-bookmark__text {
  line-height: 1;
}

.manual-card {
  position: relative;
  overflow: visible;
  border: 2px solid #f2f2f2;
  border-radius: 14px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}

.manual-card__header {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.manual-card__identity {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  padding-right: 40px; // Give space for toggle button and manual ribbon
}

.manual-card__plate {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: 0.2px;
  width: 100%;
  box-sizing: border-box;
}

.manual-card__status {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  background: #eef2ff;
  color: #4338ca;
  margin-left: 8px;
  flex-shrink: 0;
}

.manual-card__status--moving {
  background: #ecfdf5;
  color: #047857;
}

.manual-card__status--idle {
  background: #fff7ed;
  color: #b45309;
}

.manual-card__status--stop {
  background: #fee2e2;
  color: #b91c1c;
}

.manual-card__status--silence {
  background: #e0f2fe;
  color: #0369a1;
}

.manual-card__status--operation {
  background: #fef9c3;
  color: #92400e;
}

.manual-card__status--repair {
  background: #f3e8ff;
  color: #7c3aed;
}

.manual-card__status--default {
  background: #e5e7eb;
  color: #374151;
}

.manual-card__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.card-info-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  width: 100%;
  box-sizing: border-box;
}

.card-info-grid--compact {
  margin-top: 16px;
}

.card-info-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.card-info-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #4a4a4a;
  min-width: 0;
  flex: 1;
  box-sizing: border-box;
}

.card-info-item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.card-info-icon {
  display: inline-flex;
}

.card-info-icon-image {
  width: 18px;
  height: 18px;
}

.card-info-icon ::v-deep svg {
  width: 16px;
  height: 16px;
  stroke: #d23030;
}

.manual-card__status-icon {
  width: 42px;
  height: 42px;
  object-fit: contain;
  flex-shrink: 0;
}

.manual-card__footer {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.manual-card__view-detail {
  border-radius: 9999px;
  padding: 6px 14px !important;
}

.manual-card__view-detail ::v-deep svg {
  width: 16px;
  height: 16px;
}

.manual-card--compact {
  gap: 8px;
}

.manual-card--manual {
  border-color: #f97316 !important;
  box-shadow: 0 8px 24px rgba(249, 115, 22, 0.18);
}

.manual-ribbon {
  position: absolute;
  top: 12px;
  right: 12px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 6px;
  background: #dc2626;
  color: #fff;
  box-shadow: 0 6px 18px rgba(220, 38, 38, 0.35);
  z-index: 2;
  pointer-events: none;
  transition: all 0.2s ease;
}

.manual-ribbon--clickable {
  cursor: pointer;
  pointer-events: auto;
}

.manual-card__top-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  z-index: 3;
}

.manual-card__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

.manual-card__toggle:hover {
  background: #f3f4f6;
}

.manual-card__toggle--active {
  border-color: rgba(210, 48, 48, 0.65);
  background: #fff5f5;
}

.manual-card__toggle ::v-deep svg {
  width: 18px;
  height: 18px;
  stroke: #d23030;
}

.manual-card__top-actions .manual-ribbon {
  position: static;
  box-shadow: 0 6px 18px rgba(220, 38, 38, 0.35);
}

.manual-ribbon--clickable:hover {
  background: #b91c1c;
  box-shadow: 0 8px 22px rgba(220, 38, 38, 0.45);
  transform: translateY(-1px);
}

.manual-ribbon--clickable:active {
  transform: translateY(0);
}

.manual-ribbon ::v-deep svg {
  stroke: currentColor;
}

.manual-ribbon__text {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.manual-card__manual-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #fff7ed;
  border: 1px dashed rgba(249, 115, 22, 0.45);
}

.manual-card__manual-details--inline {
  margin: 12px 16px;
}

.manual-card__manual-reason {
  font-size: 12px;
  color: #92400e;
  margin: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: 96vw;
  max-width: 1080px;
  max-height: 84vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal--sm {
  width: 92vw;
  max-width: 520px;
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 26px 32px 18px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #64748b;
  max-width: 620px;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 20px 28px;
  overflow: hidden;
}

.modern-modal__body--compact {
  padding-bottom: 8px;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 32px 28px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.manual-detail-modal__content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.manual-detail-modal__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 12px;
}

.manual-detail-modal__loading .loading-spinner {
  font-size: 32px;
  color: #d23030;
  animation: spin 1s linear infinite;
}

.manual-detail-modal__loading p {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.field-group {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}

.field-group:hover {
  border-color: rgba(148, 163, 184, 0.8);
}

.field-group .vs-input--label {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
  letter-spacing: 0.01em;
}

.manual-detail-modal__value {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  margin: 0;
  padding: 12px 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#content-area.content-area-default .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced)
  .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }

  .modern-modal {
    width: 96vw;
    max-width: 720px;
    max-height: 94vh;
  }

  .modern-modal__header,
  .modern-modal__body,
  .modern-modal__footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.manual-repair-modal__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.manual-repair-modal__upload {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.manual-repair-modal__file-input {
  display: none;
}

.manual-repair-modal__upload-btn {
  width: fit-content;
}

.manual-repair-modal__selected {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #374151;
  background-color: #f3f4f6;
  padding: 6px 10px;
  border-radius: 9999px;
}

.manual-repair-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.manual-repair-modal__meta {
  font-size: 13px;
  color: #4b5563;
}

.manual-repair-modal__error {
  color: #dc2626;
  font-size: 12px;
  margin: 8px 0 0;
}

.modern-modal .field-group ::v-deep(.vs-textarea) {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
}

.modern-modal .field-group ::v-deep(textarea) {
  border-radius: 12px !important;
  border: 1px solid #d0d5dd !important;
  padding: 12px 16px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #0f172a;
  resize: vertical;
  min-height: 100px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.modern-modal .field-group ::v-deep(textarea:focus) {
  border-color: #2563eb !important;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
  outline: none;
}

/* ========== Header Cards Modern Styling ========== */
.header-card {
  --card-primary: #3b82f6;
  --card-secondary: #dbeafe;
  --card-shadow: rgba(59, 130, 246, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border-radius: 18px;
  padding: 18px 20px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;
  position: relative;
  overflow: visible;
  min-height: 108px;
  display: flex;
  align-items: center;
  width: 100%;
}

.header-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.15);
  border-color: rgba(37, 99, 235, 0.25);
}

.header-card:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

.header-card:active {
  transform: translateY(-2px);
}

.header-card__inner {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.header-card__icon {
  width: 54px;
  height: 54px;
  border-radius: 9999px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #ffffff 0%, var(--card-secondary) 100%);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow:
    0 14px 28px var(--card-shadow),
    inset 0 4px 12px rgba(255, 255, 255, 0.6);
  position: relative;
  isolation: isolate;
}

.header-card__icon img {
  object-fit: contain;
}

.header-card__icon::before {
  content: '';
  position: absolute;
  inset: -10px;
  border-radius: inherit;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.55) 0%,
    transparent 70%
  );
  z-index: -1;
  filter: blur(6px);
}

.header-card__details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
}

.header-card__value {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.header-card__label {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.header-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.01em;
  text-transform: none;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-card__info-icon {
  color: #94a3b8 !important;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
}

.header-card:hover .header-card__info-icon {
  color: #64748b !important;
}

.header-card__info-icon-svg {
  width: 16px;
  height: 16px;
  color: currentColor;
}

.header-card.total-card {
  --card-primary: #4c6ef5;
  --card-secondary: #dbe4ff;
  --card-shadow: rgba(76, 110, 245, 0.18);
}

.header-card.uio-card {
  --card-primary: #0ea5e9;
  --card-secondary: #bae6fd;
  --card-shadow: rgba(14, 165, 233, 0.16);
}

.header-card.moving-card {
  --card-primary: #22d3ee;
  --card-secondary: #cffafe;
  --card-shadow: rgba(34, 211, 238, 0.16);
}

.header-card.idle-card {
  --card-primary: #34d399;
  --card-secondary: #dcfce7;
  --card-shadow: rgba(52, 211, 153, 0.14);
}

.header-card.stop-card {
  --card-primary: #f97316;
  --card-secondary: #ffedd5;
  --card-shadow: rgba(249, 115, 22, 0.16);
}

.header-card.silence-card {
  --card-primary: #f97393;
  --card-secondary: #ffe4e6;
  --card-shadow: rgba(249, 115, 147, 0.16);
}

.header-card.repair-card {
  --card-primary: #94a3b8;
  --card-secondary: #e2e8f0;
  --card-shadow: rgba(148, 163, 184, 0.16);
}

@media (max-width: 1024px) {
  .header-card {
    padding: 18px;
  }

  /* Filter panel optimization for tablet */
  #dashboard-analytics {
    .header-filter-map {
      .content-area__heading .filter-panel-container {
        position: relative !important;
        width: 280px !important;
        right: 10px !important;
        padding: 10px !important;
        padding-bottom: 10px !important;
        gap: 10px !important;

        h3 {
          font-size: 16px !important;
          margin-bottom: 8px !important;
        }

        /* Make dropdowns more compact */
        .v-select {
          font-size: 14px !important;
        }

        /* Compact sidebar scroll area */
        #sidebar-scrollarea {
          gap: 8px !important;
          padding-bottom: 60px !important; // Space for download button
          flex: 1;
          overflow-y: auto !important;

          .manual-card {
            padding: 12px !important;
            gap: 8px !important;

            img {
              width: 32px !important;
              height: 32px !important;
            }

            h4 {
              font-size: 14px !important;
            }

            .text-xs,
            .text-sm,
            p {
              font-size: 11px !important;
            }
          }
        }

        /* Download button - stick to bottom */
        .download-button-wrapper {
          position: absolute !important;
          bottom: 0 !important;
          left: 0 !important;
          right: 0 !important;
          padding: 10px !important;
          background: white !important;
          box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1) !important;
          z-index: 10 !important;

          .vs-button {
            font-size: 13px !important;
            padding: 10px 12px !important;
            width: 100% !important;
          }
        }
      }

      /* Adjust collapsed state */
      .content-area__heading .filter-panel-container--collapsed {
        padding: 8px 10px !important;
        padding-bottom: 8px !important;
      }

      /* Adjust expanded state */
      .content-area__heading .filter-panel-container--expanded {
        max-height: 75vh !important;
        display: flex !important;
        flex-direction: column !important;
      }
    }
  }
}

@media (max-width: 768px) {
  .header-card {
    margin-bottom: 10px;
  }

  .header-card__inner {
    gap: 14px;
  }
}

@media (max-width: 480px) {
  .header-card {
    padding: 16px;
    border-radius: 16px;
  }

  .header-card__value {
    font-size: 22px;
  }

  .header-card__icon {
    width: 48px;
    height: 48px;
  }
}
/* ========== End Header Cards Styling ========== */

.number-card-btrack {
  color: #da003e;
  font-size: 20px;
}

.active-icon {
  box-shadow: 0 0 8px 5px #5cb7f3;
  border-radius: 50%;
}

.poi-icon {
  width: 70%;
  margin: 10px auto;
  cursor: pointer;
}

.disable-img {
  cursor: not-allowed;
  filter: grayscale(100%);
}

.hide-btn {
  position: absolute;
  bottom: -35px;
  left: 4px;
  background: linear-gradient(
    30deg,
    rgb(46, 49, 146) 0%,
    rgb(0, 174, 239) 100%
  );
  border-radius: 50%;
  font-size: 12px;
  color: white;
  width: 30px;
  font-weight: bold;
  cursor: pointer;
  height: 30px;
  padding-left: 11px;
  padding-top: 6px;
  box-shadow: 2px 3px 4px dimgrey;
}

.collapse {
  height: 38px;
  overflow-y: hidden;
  transition: 1s;
}

.pick-category {
  position: absolute;
  border-radius: 25px;
  top: 60px;
  left: 27px;
  width: 38px;
  box-shadow: 2px 3px 3px rgba(103, 103, 103, 0.47);
  z-index: 2;
  background: rgba(255, 255, 255, 0.39);
  display: none !important;
}

.drop-height-auto .dropdown-toggle {
  height: auto !important;
  min-height: 38.5px;
}

.heights {
  width: 100%;
  height: calc(100vh - 8rem);
  border-radius: 16px;
  overflow: hidden; /* Important: prevents map from overflowing rounded corners */
}

/* For Google Maps specifically */
.heights .gm-style {
  border-radius: 16px;
}

/* For Leaflet/OpenStreetMap specifically */
.heights .leaflet-container {
  border-radius: 16px;
}

/* Alternative approach - direct styling on map elements */
#data-list-list-view .vx-card .vx-card__collapsible-content {
  border-radius: 16px;
  overflow: hidden;
}

/* If you want to also round the card container */
#data-list-list-view .vx-card {
  border-radius: 16px;
}

.video2 {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  transform: translateX(-50%) translateY(-50%);
  background-size: cover;
  transition: 1s opacity;
}

.stopfade {
  opacity: 0.5;
}

.videoThumb {
  height: 100%;
}

.overflow-x-auto {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex-wrap: nowrap !important;
  white-space: nowrap;
}

.overflow-x-auto > div {
  flex-shrink: 0;
  min-width: max-content;
}

.overflow-x-auto::-webkit-scrollbar {
  height: 6px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.overflow-x-auto::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Filter buttons container - default for desktop */
.filter-buttons-container {
  gap: 16px;
  padding: 20px 0 24px 0;
}

/* Filter panel container - desktop default */
.filter-panel-container {
  gap: 16px; // Desktop gap
  position: absolute;
  top: 0;
  right: 50px;
  width: 420px;
  transition: all 0.3s ease;
}

.filter-panel-container--collapsed {
  height: auto;
  max-height: none;
  overflow-y: visible;
}

.filter-panel-container--expanded {
  height: 85vh;
  max-height: 85vh;
  overflow-y: hidden;
}

.download-button-wrapper {
  padding: 16px 24px;
  display: flex;
  justify-content: center;
}

.download-button-wrapper .vs-button {
  width: 90%;
  max-width: none;
  border-radius: 14px;
}

#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/* Responsive Styles for Dashboard Analytics */

/* Tablet and below - 1200px */
@media (max-width: 1200px) {
  #dashboard-analytics {
    /* Header cards responsive */
    .vx-row .vx-col {
      width: 50% !important; // 2 columns on tablet
    }

    /* Filter panel responsive */
    .header-filter-map {
      right: 10px !important;
      top: 10px !important;

      .content-area__heading .bg-white,
      .content-area__heading .filter-panel-container {
        width: 360px !important;
        right: 10px !important;
        max-height: 80vh !important;
        padding: 12px !important;
        padding-bottom: 70px !important;
        gap: 8px !important;
        overflow-y: hidden !important;
        position: relative !important;

        h3 {
          margin-bottom: 6px !important;
        }

        .flex.flex-row.items-center {
          margin-bottom: 6px !important;
        }

        .filter-buttons-container,
        .flex.flex-row.overflow-x-auto {
          padding: 6px 0 8px 0 !important;
          margin-bottom: 8px !important;
          gap: 8px !important;
          flex-wrap: nowrap !important;
          overflow-x: auto !important;

          scrollbar-width: thin !important;
          scrollbar-color: rgba(0, 0, 0, 0.3) transparent !important;

          &::-webkit-scrollbar {
            height: 6px !important;
          }

          &::-webkit-scrollbar-track {
            background: rgba(0, 0, 0, 0.05) !important;
            border-radius: 3px !important;
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.3) !important;
            border-radius: 3px !important;
          }
        }

        .download-button-wrapper {
          padding: 12px !important;
          justify-content: center !important;
          box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1) !important;
        }

        .download-button-wrapper .vs-button {
          width: 100% !important;
          max-width: none !important;
        }

        #sidebar-scrollarea.w-full,
        #sidebar-scrollarea {
          flex: 1 1 auto !important;
          max-height: none !important;
          min-height: 200px !important;
          height: auto !important;
          margin-top: 0 !important;
          overflow-y: auto !important;
        }
      }
    }
  }
}

/* Mobile landscape and below - 768px */
@media (max-width: 768px) {
  #dashboard-analytics {
    margin-top: 0 !important;
    padding: 0 !important;

    /* Header cards - hide on mobile to save space, can be shown in collapsed state */
    .vx-row {
      display: none !important; // Hide header cards on mobile for more map space
    }

    /* Map container - Make map the main focus */
    #data-list-list-view {
      margin: 0 !important;
      padding: 0 !important;
      position: relative;

      .vx-card {
        margin: 0 !important;
        border-radius: 0 !important;
      }
    }

    /* Filter panel - floating overlay on mobile */
    .header-filter-map {
      position: fixed !important;
      top: 64px !important; // Below navbar
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      z-index: 1001 !important;
      margin: 0 !important;

      .content-area__heading {
        width: 100% !important;
        margin: 0 !important;

        .bg-white,
        .filter-panel-container {
          position: relative !important;
          width: 50% !important;
          max-width: 50% !important;
          min-width: 50% !important;
          margin: 0 0 0 auto !important; // keep panel anchored to the right
          padding: 10px 12px !important;
          padding-bottom: 70px !important;
          gap: 6px !important;
          border-radius: 0 0 16px 16px !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
          display: flex !important;
          flex-direction: column !important;

          overflow-y: hidden !important; // Parent no scroll, child scrolls

          h3 {
            font-size: 1rem;
            margin-bottom: 4px !important; // Reduced margin
            flex-shrink: 0 !important; // Don't shrink header
          }

          /* Filter select dropdown - more compact */
          .flex.flex-row.items-center {
            margin-bottom: 4px !important; // Reduced margin
            margin-top: 0 !important; // Remove top margin
            gap: 6px !important; // Reduced gap
            flex-shrink: 0 !important; // Don't shrink
            width: 100% !important; // Full width

            .v-select {
              font-size: 0.85rem !important;
              width: 100% !important; // Full width
            }

            .vs-button {
              padding: 6px 10px !important;
              font-size: 0.75rem !important;
              flex-shrink: 0 !important;
            }
          }

          /* Additional filter row (license plate, vin, etc) */
          .flex.flex-row:not(.overflow-x-auto):not(.items-center) {
            margin-top: 0 !important;
            margin-bottom: 4px !important;
            gap: 6px !important;
            flex-shrink: 0 !important; // Don't shrink
            width: 100% !important; // Full width

            .v-select,
            .vs-input,
            input {
              width: 100% !important;
            }
          }

          /* Filter buttons - horizontal scroll on mobile */
          .filter-buttons-container,
          .flex.flex-row.overflow-x-auto {
            flex-wrap: nowrap !important;
            gap: 6px !important;
            padding: 4px 0 8px 0 !important;
            margin-top: 0 !important;
            margin-bottom: 6px !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch !important;
            flex-shrink: 0 !important;

            scrollbar-width: thin !important;
            scrollbar-color: rgba(0, 0, 0, 0.3) transparent !important;

            &::-webkit-scrollbar {
              height: 6px !important;
            }

            &::-webkit-scrollbar-track {
              background: rgba(0, 0, 0, 0.05) !important;
              border-radius: 3px !important;
            }

            &::-webkit-scrollbar-thumb {
              background: rgba(0, 0, 0, 0.3) !important;
              border-radius: 3px !important;
            }

            &::-webkit-scrollbar-thumb:hover {
              background: rgba(0, 0, 0, 0.5) !important;
            }

            > div {
              flex: 0 0 auto !important;
              min-width: 130px !important;
              padding: 8px 10px !important;
              font-size: 0.75rem !important;
              min-height: auto !important;
              white-space: nowrap !important;
            }
          }

          /* Vehicle list sidebar - fill available space */
          #sidebar-scrollarea.w-full.flex.flex-col,
          #sidebar-scrollarea {
            flex: 1 1 auto !important; // Fill available space
            max-height: none !important; // Remove max-height limit
            min-height: 150px !important; // Minimum height
            height: auto !important; // Let flex control height
            width: 100% !important;
            padding-bottom: 0 !important; // Parent handles space for button
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            overflow-y: auto !important; // Enable scroll
            overflow-x: hidden !important;
            -webkit-overflow-scrolling: touch !important; // Smooth scroll on iOS

            > div {
              width: 100% !important; // Each item full width
            }

            .manual-card {
              padding: 8px !important;
              font-size: 0.85rem !important;
              margin-bottom: 6px !important;
              width: 100% !important;
              min-width: 100% !important;
              max-width: 100% !important;
              box-sizing: border-box !important;
              margin-left: 0 !important;
              margin-right: 0 !important;

              .manual-card__identity {
                padding-right: 50px !important; // Reduced for mobile
              }

              .flex {
                gap: 6px !important;
                width: 100% !important;
              }

              img,
              .vehicle-icon {
                width: 38px !important;
                height: 38px !important;
                flex-shrink: 0 !important;
              }

              > div {
                margin-bottom: 0 !important;
              }
            }
          }

          /* Dropdowns */
          .v-select {
            font-size: 0.85rem !important;

            .vs-select--options {
              max-height: 200px !important;
            }
          }

          /* Remove extra spacing */
          > div {
            margin-bottom: 0 !important;
          }

          /* Force compact spacing for all children */
          * {
            margin-top: 0 !important;
          }

          /* Remove default gaps in flex containers */
          .flex-col {
            gap: 0 !important;
          }

          /* Download button wrapper - stick to bottom */
          .download-button-wrapper {
            position: absolute !important;
            bottom: 0 !important;
            left: 0 !important;
            right: 0 !important;
            padding: 12px !important;
            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1) !important;
            border-radius: 0 0 16px 16px !important;

            .vs-button {
              width: 100% !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              padding: 12px !important;
              font-size: 0.9rem !important;
              text-align: center !important;

              span {
                margin: 0 auto !important;
              }
            }
          }
        }

        .filter-panel-container--collapsed {
          padding: 8px 12px !important; // Even more compact when collapsed
          padding-bottom: 8px !important; // No space for button when collapsed
          overflow-y: visible !important;

          h3 {
            font-size: 1rem;
            margin: 0;
          }
        }

        .filter-panel-container--expanded {
          height: calc((100vh - 80px) * 0.8) !important; // Reduce height to 80%
          max-height: calc((100vh - 80px) * 0.8) !important;
          overflow-y: hidden !important;
        }
      }
    }

    /* Map height - maximize for mobile */
    .heights {
      height: calc(100vh - 64px) !important; // Full screen minus navbar
      min-height: calc(100vh - 64px) !important;
    }

    /* When filter is expanded, reduce map height */
    .header-filter-map .bg-white.filter-panel-container--expanded ~ * .heights {
      height: 50vh !important;
      min-height: 50vh !important;
    }

    /* Download button */
    .download-button-overlay {
      bottom: 10px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      width: calc(100% - 20px) !important;
      z-index: 1000 !important;

      .vs-button {
        width: 100% !important;
        padding: 12px !important;
        font-size: 0.9rem !important;
      }
    }
  }
}

/* Extra small mobile - 480px */
@media (max-width: 480px) {
  #dashboard-analytics {
    /* Filter panel - even more compact */
    .header-filter-map {
      top: 60px !important; // Smaller navbar on tiny screens

      .content-area__heading .bg-white,
      .content-area__heading .filter-panel-container {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 100% !important;
        padding: 10px !important;
        padding-bottom: 65px !important;
        gap: 6px !important;
        overflow-y: hidden !important;
        position: relative !important;

        h3 {
          font-size: 0.95rem;
        }

        /* Filter buttons - horizontal scroll */
        .filter-buttons-container,
        .flex.flex-row.overflow-x-auto {
          flex-wrap: nowrap !important;
          padding: 4px 0 8px 0 !important;
          gap: 6px !important;
          overflow-x: auto !important;

          scrollbar-width: thin !important;

          &::-webkit-scrollbar {
            height: 5px !important;
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.3) !important;
            border-radius: 3px !important;
          }

          > div {
            min-width: 120px !important;
            padding: 8px 10px !important;
            font-size: 0.7rem !important;
          }
        }

        .download-button-wrapper {
          padding: 10px !important;
        }

        /* Vehicle list - fill space but compact */
        #sidebar-scrollarea.w-full,
        #sidebar-scrollarea {
          flex: 1 1 auto !important;
          max-height: none !important;
          min-height: 150px !important;
          height: auto !important; // Let flex control
          overflow-y: auto !important;

          .manual-card {
            padding: 8px !important;
            font-size: 0.8rem !important;
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
            margin-left: 0 !important;
            margin-right: 0 !important;

            .manual-card__identity {
              padding-right: 50px !important; // Reduced for small mobile
            }

            img,
            .vehicle-icon {
              width: 36px !important;
              height: 36px !important;
            }
          }
        }

        /* Smaller select inputs */
        .v-select {
          font-size: 0.8rem !important;
        }

        .vs-button {
          padding: 5px 10px !important;
          font-size: 0.7rem !important;
        }
      }

      .content-area__heading .filter-panel-container--collapsed {
        padding-bottom: 8px !important;
        overflow-y: visible !important;
      }

      .content-area__heading .filter-panel-container--expanded {
        overflow-y: hidden !important;
      }
    }

    /* Map - still maximize available space */
    .heights {
      height: calc(100vh - 60px) !important;
      min-height: calc(100vh - 60px) !important;
    }

    /* Download button smaller */
    .download-button-overlay {
      .vs-button {
        padding: 10px !important;
        font-size: 0.85rem !important;
      }
    }
  }
}

/* Landscape mode adjustments */
@media (max-width: 768px) and (orientation: landscape) {
  #dashboard-analytics {
    .header-filter-map {
      .content-area__heading .bg-white,
      .content-area__heading .filter-panel-container {
        max-height: 50vh !important;
        height: 50vh !important;
        overflow-y: hidden !important;
        gap: 6px !important;
        position: relative !important;
        padding-bottom: 65px !important;

        #sidebar-scrollarea.w-full,
        #sidebar-scrollarea {
          flex: 1 1 auto !important;
          max-height: none !important;
          min-height: 100px !important;
          height: auto !important;
          overflow-y: auto !important;
        }
      }

      .content-area__heading .filter-panel-container--collapsed {
        overflow-y: visible !important;
        height: auto !important;
        max-height: 50vh !important;
      }

      .content-area__heading .filter-panel-container--expanded {
        overflow-y: hidden !important;
      }
    }

    /* Maximize map in landscape */
    .heights {
      height: 100vh !important;
      min-height: 100vh !important;
    }
  }
}
</style>
